/* eslint-disable react/jsx-filename-extension */
import React, { useEffect } from 'react';

function Header(props) {
  useEffect(() => {
    document.querySelector('.menu-trigger')
      .addEventListener('click', props.onMenuOpen);

    return () => {
      document.querySelector('.menu-trigger')
        .removeEventListener('click', props.onMenuOpen);
    };
  });

  return (
    <div
      className="genesee"
      dangerouslySetInnerHTML={{ __html: headerString }}
    />
  );
}

export default Header;

const headerString = `
  <div id="page" class="hfeed site">
  <header id="masthead" class="site-header" role="banner">
  <div class="container-fluid">
    <div class="row g-sm-0">
      <div class="col-auto mr-auto">
        <div class="brand">
          <a class="logo" href="https://geneseesci.com">
            <img src="https://geneseesci.com/wp-content/themes/heisenbug/images/logo.png">							</a>
        </div>
      </div>

      <div class="col-sm d-none d-md-block">
        <div id="searchform" method="get" action="/shop-online/search" class="search  d-sm-flex">
          <form action="https://geneseesci.com/shop-online/search" class="searcbar" style="">
            <input autocomplete="off" type="text" class="form-control" name="s" id="s" placeholder="Search" value="" required="">
            <span class="input-group-btn">
              <button class="btn btn-link" type="submit" id="searchsubmit"><i class="fa fa-search"></i></button>
            </span>
          </form>
        </div>
      </div>

      <div class="col-auto">
        <div class="col-auto right-links">
          <ul id="top-menu">
            <!--
<li class="item-link no-decorate hide-1400-down"><a href="#">Welcome
Jack Yoon
</a></li>
-->


<li class="item-link login-link menu-item-has-children" id="top-login-link">
<a class="account-login" href="https://geneseesci.com/shop-online/login">Login</a>
<div class="sub-menu sub-light">
<div class="text-center">
  <a href="https://geneseesci.com/shop-online/login" class="btn btn-green btn-block ucase">Login</a>
  OR
  <a href="https://geneseesci.com/shop-online/register" class="btn btn-blue btn-block ucase">REQUEST AN ACCOUNT</a>
</div>
</div>
</li>

<li class="item-link login-link menu-item-has-children" id="top-login-link" style="display: none;">
              <a class="account-login" href="https://geneseesci.com/shop-online/login">Login</a>
              <div class="sub-menu sub-light">
                <div class="text-center">
                  <a href="https://geneseesci.com/shop-online/login" class="btn btn-green btn-block ucase">Login</a>
                  OR
                  <a href="https://geneseesci.com/shop-online/register" class="btn btn-blue btn-block ucase">REQUEST AN ACCOUNT</a>
                </div>
              </div>
            </li>
            <li class="item-link menu-item-has-children">
              <a href="https://geneseesci.com/shop-online/cart"><span class="d-none d-sm-block">My Cart (<span class="cart_count">0</span>)</span></a>
              <div class="sub-menu sub-cart" id="cart-menu"><div class="cart-items" style="padding:15px;">
<table>
<tbody>
                                        </tbody>
</table>
</div>
<div class="cart-actions" style="padding:15px;background-color:#f0f0f0;border-top: medium solid #bbbbbb;">
<table>
<tbody>
  <tr>
    <td><strong>Subtotal</strong>
      <br>
      <em>(Excluding tax, shipping)</em>
    </td>
    <td class="text-right"><strong id="cart-menu-total">$0.00</strong></td>
  </tr>
</tbody>
</table><a href="https://geneseesci.com/shop-online/cart" class="btn btn-blue btn-block ucase">View Cart</a><br><a href="javascript:void(0)" data-toggle="modal" data-target="#CheckOutModal" class="btn btn-green btn-block ucase">Checkout</a><table>




</table></div></div>
            </li>
          </ul>
        </div>

      </div>

    </div>

    <div class="row d-block d-md-none">
      <div class="col-12">
        <div id="searchform" method="get" action="/shop-online/search" class="search  d-sm-flex">
          <form action="/shop-online/search" class="searcbar" style="">
            <input autocomplete="off" type="text" class="form-control" name="s" id="s" placeholder="Search" value="" required="">
            <span class="input-group-btn">
              <button class="btn btn-link" type="submit" id="searchsubmit"><i class="fa fa-search"></i></button>
            </span>
          </form>
        </div>
      </div>
    </div>


  </div>
</header>
<div id="top-bar">
			<div class="row no-gutters justify-content-between">
				<div class="left-links">
					<nav>

<style>
    #ad_block_1 img,
    #ad_block_2 img,
    #ad_block_3 img,
    #ad_block_4 img {
        width: 270px;
        height: 350px;
    }
</style>

<ul id="main-menu" class="main-menu t1 list-inline mr-auto">
	<li id="by-product" class="menu-item-has-children t1 hide-600-down"><a href="#"><span class="hide-650-down d-inline">By </span>Product</a>
		<div class="root-container sub-menu">
			<div class="row no-gutters">
				<div class="col">
					<h3>Browse By Product</h3>
					<ul class="t2 list-unstyled" data-tier="2">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/259/gloves">Gloves</a>

                			<div class="sub-menu">

        			<h3>Gloves</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7158/autoclave-gloves">Autoclave Gloves</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Autoclave Gloves" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Autoclave Gloves" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7625/biodegradable-gloves-powder-free">Biodegradable Gloves, Powder-Free</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biodegradable Gloves, Powder-Free" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biodegradable Gloves, Powder-Free" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/260/latex-gloves-powder-free">Latex Gloves, Powder-Free</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Latex Gloves, Powder-Free" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Latex Gloves, Powder-Free" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/261/nitrile-gloves-powder-free">Nitrile Gloves, Powder-Free</a>

                			<div class="sub-menu">

        			<h3>Nitrile Gloves, Powder-Free</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7896/n-gen">N-GEN</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="N-GEN" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="N-GEN" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7895/s-gen">S-GEN</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="S-GEN" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="S-GEN" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7894/x-gen">X-GEN</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="X-GEN" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="X-GEN" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nitrile Gloves, Powder-Free" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nitrile Gloves, Powder-Free" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5800/glove-box-holders">Glove Box Holders</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glove Box Holders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glove Box Holders" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gloves" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gloves" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1510/pipet-tips">Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Pipet Tips</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7858/olympus-filter-pipet-tips">Olympus Filter Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Filter Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Filter Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6589/olympus-premium-universal-pipet-tips">Olympus Premium Universal Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Olympus Premium Universal Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7530/barrier-pipet-tips">Barrier Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7531/standard-pipet-tips">Standard Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Pipet Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7532/10ul-reach-premium-pipet-tip">10µl Reach Premium Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Reach Premium Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Reach Premium Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7533/10ul-premium-pipet-tip">10µl Premium Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Premium Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Premium Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7534/200ul-premium-pipet-tip">200µl Premium Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Premium Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Premium Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7535/1250ul-reach-premium-pipet-tip">1250µl Reach Premium Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1250µl Reach Premium Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1250µl Reach Premium Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6633/5ml--and--10ml-pipet-tips">5ml &amp; 10ml Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5ml &amp; 10ml Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5ml &amp; 10ml Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7563/olympus-ergonomic-universal-pipet-tips">Olympus Ergonomic Universal Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Olympus Ergonomic Universal Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7564/barrier-tips">Barrier Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7565/standard-tips">Standard Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7566/10ul-ergonomic-pipet-tip">10µl Ergonomic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>10µl Ergonomic Pipet Tip</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7572/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7567/10ul-reach-ergonomic-pipet-tip">10µl Reach Ergonomic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>10µl Reach Ergonomic Pipet Tip</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7574/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Reach Ergonomic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Reach Ergonomic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7568/200ul-ergonomic-pipet-tip">200µl Ergonomic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>200µl Ergonomic Pipet Tip</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7576/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7577/non-low-binding">Non-Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7569/300ul-ergonomic-pipet-tip">300µl Ergonomic Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="300µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="300µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7570/1000ul-ergonomic-pipet-tip">1000µl Ergonomic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>1000µl Ergonomic Pipet Tip</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7579/non-low-binding">Non-Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7578/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl Ergonomic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7571/1000ul-reach-ergonomic-pipet-tip">1000µl Reach Ergonomic Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl Reach Ergonomic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl Reach Ergonomic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Ergonomic Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Ergonomic Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6594/xtip4-rainin-lts-tips">xTIP4 Rainin™ LTS™ Tips</a>

                			<div class="sub-menu">

        			<h3>xTIP4 Rainin™ LTS™ Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6595/barrier-pipet-tips">Barrier Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6596/standard-pipet-tips">Standard Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Pipet Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7503/20ul-">20µl </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="20µl " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="20µl " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7504/250ul">250µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250µl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7505/300ul">300µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="300µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="300µl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7506/1000ul">1000µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7507/1200ul">1200µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1200µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1200µl" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="xTIP4 Rainin™ LTS™ Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="xTIP4 Rainin™ LTS™ Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6304/eppendorf-pipet-tips">Eppendorf Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Eppendorf Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6305/ept.i.p.s.">epT.I.P.S.</a>

                			<div class="sub-menu">

        			<h3>epT.I.P.S.</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6306/single">Single</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6307/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6308/racked">Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6309/ept.i.p.s.-box">epT.I.P.S. Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="epT.I.P.S. Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="epT.I.P.S. Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6310/reloads">Reloads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reloads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reloads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6311/starter-sets">Starter Sets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Starter Sets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Starter Sets" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="epT.I.P.S." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="epT.I.P.S." data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6312/ep-dualfilter-t.i.p.s.">ep Dualfilter T.I.P.S.</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ep Dualfilter T.I.P.S." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ep Dualfilter T.I.P.S." data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6314/combitips">CombiTips</a>

                			<div class="sub-menu">

        			<h3>CombiTips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6315/standard">Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6316/sterile">Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sterile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6317/pcr-clean">PCR Clean</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Clean" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Clean" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6318/accessories">Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CombiTips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CombiTips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4699/gilson-pipet-tips">Gilson Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Gilson Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4700/bulk-standard">Bulk, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4701/racked-standard">Racked, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4702/filter-tips">Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4703/towerpack">TowerPack</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TowerPack" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TowerPack" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8117/amplipur-tips">Amplipur Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Amplipur Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Amplipur Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4704/distritips">DistriTips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DistriTips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DistriTips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4693/serological-pipets">Serological Pipets</a>

                			<div class="sub-menu">

        			<h3>Serological Pipets</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4694/genclone-brand">GenClone Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GenClone Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GenClone Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7941/olympus-brand">Olympus Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Brand" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4657/automation-pipet-tips">Automation Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Automation Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6796/beckman-platforms">Beckman Platforms</a>

                			<div class="sub-menu">

        			<h3>Beckman Platforms</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6798/384-well-filter-tips">384-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6797/384-well-standard-tips">384-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6799/96-well-standard-tips">96-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6800/96-well-filter-tips">96-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Beckman Platforms" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Beckman Platforms" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4667/agilent-platforms">Agilent Platforms</a>

                			<div class="sub-menu">

        			<h3>Agilent Platforms</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6774/384-well-filter-tips">384-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4668/384-well-standard-tips">384-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agilent Platforms" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agilent Platforms" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4679/molecular-devices-flipr-platform">Molecular Devices FLIPR Platform</a>

                			<div class="sub-menu">

        			<h3>Molecular Devices FLIPR Platform</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6776/clear">Clear</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6775/black">Black</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Devices FLIPR Platform" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Devices FLIPR Platform" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4658/biomek-assorted-tips">Biomek Assorted Tips</a>

                			<div class="sub-menu">

        			<h3>Biomek Assorted Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4661/96-well-standard-tips">96-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4662/96-well-filter-tips">96-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biomek Assorted Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biomek Assorted Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4664/biomek-1000--and--2000-tips">Biomek 1000 &amp; 2000 Tips</a>

                			<div class="sub-menu">

        			<h3>Biomek 1000 &amp; 2000 Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4665/96-well-standard-tips">96-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4666/96-well-filter-tips">96-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biomek 1000 &amp; 2000 Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biomek 1000 &amp; 2000 Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4669/tecan-platforms">Tecan Platforms</a>

                			<div class="sub-menu">

        			<h3>Tecan Platforms</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4670/96-well-standard-tips">96-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4671/96-well-filtertips">96-Well FilterTips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well FilterTips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well FilterTips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4672/96-well-conductive-tips">96-Well Conductive Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Conductive Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Conductive Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tecan Platforms" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tecan Platforms" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Automation Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Automation Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4973/repeater-pipette-tips">Repeater Pipette Tips</a>

                			<div class="sub-menu">

        			<h3>Repeater Pipette Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4974/non-sterile">Non-Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Sterile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4975/sterile">Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sterile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Repeater Pipette Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Repeater Pipette Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4656/wide-orifice-pipet-tips">Wide Orifice Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Orifice Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Orifice Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4652/gel-loading-pipet-tips">Gel Loading Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Gel Loading Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6259/10ul-flat-gel-tips">10µl Flat Gel Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Flat Gel Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Flat Gel Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4653/10ul-round-gel-tips">10µl Round Gel Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Round Gel Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Round Gel Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4654/200ul-round-gel-tips">200µl Round Gel Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Round Gel Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Round Gel Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4655/200ul-flat-gel-tips">200µl Flat Gel Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Flat Gel Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Flat Gel Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4868/filtered-gel-tips">Filtered Gel Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filtered Gel Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filtered Gel Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Loading Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Loading Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4698/transfer-pipets">Transfer Pipets</a>

                			<div class="sub-menu">

        			<h3>Transfer Pipets</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7989/3-ml">3 ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3 ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3 ml" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7990/4-ml">4 ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4 ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4 ml" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7991/5-ml">5 ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5 ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5 ml" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7992/7-ml">7 ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="7 ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="7 ml" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transfer Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transfer Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7943/universal-filtered-tips">Universal Filtered Tips</a>

                			<div class="sub-menu">

        			<h3>Universal Filtered Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7945/10ul">10ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7946/20ul">20ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="20ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="20ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7947/100ul">100ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7948/200ul">200ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7949/300ul">300ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="300ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="300ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7950/1000ul">1000ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ul" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Universal Filtered Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Universal Filtered Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7944/universal-standard-tips">Universal Standard Tips</a>

                			<div class="sub-menu">

        			<h3>Universal Standard Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7953/racked-non-sterile">Racked, Non-Sterile</a>

                			<div class="sub-menu">

        			<h3>Racked, Non-Sterile</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7955/10ul">10ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7958/200ul">200ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7960/1000ul">1000ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ul" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, Non-Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, Non-Sterile" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7954/racked-sterile">Racked, Sterile</a>

                			<div class="sub-menu">

        			<h3>Racked, Sterile</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7964/10ul">10ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7965/200ul">200ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7966/1000ul">1000ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ul" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, Sterile" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7951/reloads">Reloads</a>

                			<div class="sub-menu">

        			<h3>Reloads</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7969/10ul">10ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7971/200ul">200ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7970/1000ul">1000ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ul" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reloads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reloads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7972/racked-and-stacked">Racked &amp; Stacked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked and Stacked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked and Stacked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7963/starter-packs">Starter Packs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Starter Packs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Starter Packs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Universal Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Universal Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipet Tips" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipet Tips" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1511/tubes">Tubes</a>

                			<div class="sub-menu">

        			<h3>Tubes</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4378/15--and--50ml-centrifuge-tubes">15 &amp; 50ml Centrifuge Tubes</a>

                			<div class="sub-menu">

        			<h3>15 &amp; 50ml Centrifuge Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7993/genclone">GenClone</a>

                			<div class="sub-menu">

        			<h3>GenClone</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7995/15ml-centrifuge-tubes">15ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7996/50ml-centrifuge-tubes">50ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GenClone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GenClone" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7994/olympus">Olympus</a>

                			<div class="sub-menu">

        			<h3>Olympus</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4379/15ml-centrifuge-tubes">15ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4380/50ml-centrifuge-tubes">50ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15 &amp; 50ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15 &amp; 50ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7792/25ml-centrifuge-tubes">25ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7725/5ml-centrifuge-tubes">5ml Centrifuge Tubes</a>

                			<div class="sub-menu">

        			<h3>5ml Centrifuge Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7726/snap-cap">Snap Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Snap Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Snap Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7727/screw-cap">Screw Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Screw Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Screw Cap" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4395/microcentrifuge-tubes">Microcentrifuge Tubes</a>

                			<div class="sub-menu">

        			<h3>Microcentrifuge Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4396/0.6ml-microcentrifuge-tubes">0.6ml Microcentrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.6ml Microcentrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.6ml Microcentrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4397/1.7ml-microcentrifuge-tubes">1.7ml Microcentrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1.7ml Microcentrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1.7ml Microcentrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4398/2.0ml-microcentrifuge-tubes">2.0ml Microcentrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2.0ml Microcentrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2.0ml Microcentrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4976/0.6ml-microcentrifuge-tubes-assorted-colors">0.6ml Microcentrifuge Tubes, Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.6ml Microcentrifuge Tubes, Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.6ml Microcentrifuge Tubes, Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4977/1.7ml-microcentrifuge-tubes-assorted-colors">1.7ml Microcentrifuge Tubes, Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1.7ml Microcentrifuge Tubes, Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1.7ml Microcentrifuge Tubes, Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4978/2.0ml-microcentrifuge-tubes-assorted-colors">2.0ml Microcentrifuge Tubes, Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2.0ml Microcentrifuge Tubes, Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2.0ml Microcentrifuge Tubes, Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microcentrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microcentrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4399/screw-cap-microtubes">Screw Cap Microtubes</a>

                			<div class="sub-menu">

        			<h3>Screw Cap Microtubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6262/sterile-preassembled-with-caps-on">Sterile, Preassembled with Caps On</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sterile, Preassembled with Caps On" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sterile, Preassembled with Caps On" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6260/0.5ml-screw-cap-tubes">0.5ml Screw Cap Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.5ml Screw Cap Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.5ml Screw Cap Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4403/1.5ml-screw-cap-tubes">1.5ml Screw Cap Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1.5ml Screw Cap Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1.5ml Screw Cap Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4406/2.0ml-screw-cap-tubes">2.0ml Screw Cap Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2.0ml Screw Cap Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2.0ml Screw Cap Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6261/screw-caps-for-microtubes-assorted-colors">Screw Caps for Microtubes, Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Screw Caps for Microtubes, Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Screw Caps for Microtubes, Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Screw Cap Microtubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Screw Cap Microtubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4411/cryogenic-vials">Cryogenic Vials</a>

                			<div class="sub-menu">

        			<h3>Cryogenic Vials</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6263/olympus-brand">Olympus Brand</a>

                			<div class="sub-menu">

        			<h3>Olympus Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6266/external-thread">External Thread</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="External Thread" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="External Thread" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6265/internal-thread">Internal Thread</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Internal Thread" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Internal Thread" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6269/cryovial-cap-inserts">Cryovial Cap Inserts</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryovial Cap Inserts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryovial Cap Inserts" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6271/40-place-cryovial-rack">40-Place Cryovial Rack</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="40-Place Cryovial Rack" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="40-Place Cryovial Rack" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8012/1.8-ml-self-standing-cryovials">1.8 ml Self-Standing Cryovials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1.8 ml Self-Standing Cryovials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1.8 ml Self-Standing Cryovials" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7997/simport-brand">Simport Brand</a>

                			<div class="sub-menu">

        			<h3>Simport Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7998/internal-thread">Internal Thread</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Internal Thread" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Internal Thread" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7999/external-thread">External Thread</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="External Thread" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="External Thread" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8000/cryovial-inserts">Cryovial Inserts</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryovial Inserts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryovial Inserts" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Simport Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Simport Brand" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryogenic Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryogenic Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7064/flow-cytometry-tubes">Flow Cytometry Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flow Cytometry Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flow Cytometry Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7450/pcr-tubes">PCR Tubes</a>

                			<div class="sub-menu">

        			<h3>PCR Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7451/4-strip-pcr-tubes--and--caps">4-Strip PCR Tubes &amp; Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4-Strip PCR Tubes &amp; Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4-Strip PCR Tubes &amp; Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7452/8-strip-pcr-tubes--and--strip-caps">8-Strip PCR Tubes &amp; Strip Caps</a>

                			<div class="sub-menu">

        			<h3>8-Strip PCR Tubes &amp; Strip Caps</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7592/assorted-colors">Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7591/packed-separate">Packed Separate</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Packed Separate" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Packed Separate" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7590/packed-together">Packed Together</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Packed Together" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Packed Together" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7453/8-strip-pcr-tubes-individual-attached-caps">8-Strip PCR Tubes, Individual Attached Caps</a>

                			<div class="sub-menu">

        			<h3>8-Strip PCR Tubes, Individual Attached Caps</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7593/individual-dome-caps">Individual Dome Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Dome Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Dome Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7594/individual-flat-caps">Individual Flat Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Flat Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Flat Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7595/individual-flat-caps-low-profile">Individual Flat Caps, Low Profile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Flat Caps, Low Profile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Flat Caps, Low Profile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7596/assorted-colors">Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip PCR Tubes, Individual Attached Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip PCR Tubes, Individual Attached Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7454/0.2ml-individual-pcr-tubes">0.2ml Individual PCR Tubes</a>

                			<div class="sub-menu">

        			<h3>0.2ml Individual PCR Tubes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7588/flat-cap">Flat Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flat Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flat Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7589/dome-cap">Dome Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dome Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dome Cap" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.2ml Individual PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.2ml Individual PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7455/0.5ml-individual-pcr-tubes">0.5ml Individual PCR Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.5ml Individual PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.5ml Individual PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7456/12-strip-pcr-tubes--and--strip-caps">12-Strip PCR Tubes &amp; Strip Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4419/culture-tubes">Culture Tubes</a>

                			<div class="sub-menu">

        			<h3>Culture Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7492/polypropylene">Polypropylene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7491/polystyrene">Polystyrene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Culture Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Culture Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7934/duoclick-culture-tube">DuoClick Culture Tube</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DuoClick Culture Tube" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DuoClick Culture Tube" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4429/test-tubes">Test Tubes</a>

                			<div class="sub-menu">

        			<h3>Test Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4430/3.0ml-12mm">3.0ml (12mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3.0ml (12mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3.0ml (12mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4431/5.0ml-12mm">5.0ml (12mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5.0ml (12mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5.0ml (12mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4432/8.0ml-13mm">8.0ml (13mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8.0ml (13mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8.0ml (13mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4433/14ml-16mm">14ml (16mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="14ml (16mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="14ml (16mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4434/16ml-17mm">16ml (17mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="16ml (17mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="16ml (17mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4435/19ml-16mm">19ml (16mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="19ml (16mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="19ml (16mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7448/test-tube-caps">Test Tube Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tube Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tube Caps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4425/microtiter-tubes">Microtiter Tubes</a>

                			<div class="sub-menu">

        			<h3>Microtiter Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4426/individual-tubes">Individual Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4427/8-tube-strips">8-Tube Strips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Tube Strips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Tube Strips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4428/12-tube-strips">12-Tube Strips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Tube Strips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Tube Strips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microtiter Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microtiter Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4424/transport-tubes-self-standing">Transport Tubes, Self-Standing</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transport Tubes, Self-Standing" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transport Tubes, Self-Standing" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tubes" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tubes" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/184/plates">Plates</a>

                			<div class="sub-menu">

        			<h3>Plates</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/209/cell--and--tissue-culture-plates">Cell &amp; Tissue Culture Plates</a>

                			<div class="sub-menu">

        			<h3>Cell &amp; Tissue Culture Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/210/tc-treated-plates">TC Treated Plates</a>

                			<div class="sub-menu">

        			<h3>TC Treated Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/211/clear-plates">Clear Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/212/black-white-plates">Black/White Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Treated Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Treated Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/213/non-treated-plates">Non-Treated Plates</a>

                			<div class="sub-menu">

        			<h3>Non-Treated Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/214/clear-plates">Clear Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/215/black-white-plates">Black/White Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Tissue Culture Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Tissue Culture Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5806/immunoassay-plates">Immunoassay Plates</a>

                			<div class="sub-menu">

        			<h3>Immunoassay Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5807/high-binding-surface-elisa">High Binding Surface (ELISA)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Binding Surface (ELISA)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Binding Surface (ELISA)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5808/medium-binding-surface-eia-ria">Medium Binding Surface (EIA/RIA)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Medium Binding Surface (EIA/RIA)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Medium Binding Surface (EIA/RIA)" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Immunoassay Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Immunoassay Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5908/non-treated-assay-plates">Non-Treated Assay Plates</a>

                			<div class="sub-menu">

        			<h3>Non-Treated Assay Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6273/96-well">96-Well</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6274/384-well">384-Well</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated Assay Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated Assay Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4979/luminescence---fluorescence-plates">Luminescence / Fluorescence Plates</a>

                			<div class="sub-menu">

        			<h3>Luminescence / Fluorescence Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4980/tc-treated">TC Treated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Treated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Treated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4981/non-treated">Non-Treated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Luminescence / Fluorescence Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Luminescence / Fluorescence Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/185/pcr-plates">PCR Plates</a>

                			<div class="sub-menu">

        			<h3>PCR Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7457/olympus-96-well-plates">Olympus 96-Well Plates</a>

                			<div class="sub-menu">

        			<h3>Olympus 96-Well Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7458/96-well-non-skirted">96-Well Non-Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Non-Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Non-Skirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7459/96-well-semi-skirted">96-Well Semi-Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Semi-Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Semi-Skirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7460/96-well-full-skirted">96-Well Full-Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Full-Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Full-Skirted" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus 96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus 96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7461/olympus-384-well-plates">Olympus 384-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus 384-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus 384-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7462/24--and--48-well-pcr-plates">24 &amp; 48-Well PCR Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="24 &amp; 48-Well PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="24 &amp; 48-Well PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/222/deep-well-plates-">Deep Well Plates </a>

                			<div class="sub-menu">

        			<h3>Deep Well Plates </h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/223/96-well-deep-well-plates">96-Well Deep Well Plates</a>

                			<div class="sub-menu">

        			<h3>96-Well Deep Well Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/224/round-well-design">Round Well Design</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Round Well Design" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Round Well Design" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/225/square-well-design">Square Well Design</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Square Well Design" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Square Well Design" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Deep Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Deep Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/226/384-well-deep-well-plates">384-Well Deep Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Deep Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Deep Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6850/12-channel-reservoir">12-Channel Reservoir</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Channel Reservoir" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Channel Reservoir" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Deep Well Plates " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Deep Well Plates " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plates" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plates" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8030/dishes--and--reservoirs">Dishes &amp; Reservoirs</a>

                			<div class="sub-menu">

        			<h3>Dishes &amp; Reservoirs</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4855/cell--and--tissue-culture-dishes">Cell &amp; Tissue Culture Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Tissue Culture Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Tissue Culture Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/230/petri-dishes">Petri Dishes</a>

                			<div class="sub-menu">

        			<h3>Petri Dishes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/231/standard-dishes">Standard Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/232/dishes-w--gripping-ring">Dishes w/ Gripping Ring</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dishes w/ Gripping Ring" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dishes w/ Gripping Ring" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5029/square-dishes">Square Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Square Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Square Dishes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/233/reagent-reservoirs">Reagent Reservoirs</a>

                			<div class="sub-menu">

        			<h3>Reagent Reservoirs</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/236/olympus-reservoirs-">Olympus Reservoirs </a>

                			<div class="sub-menu">

        			<h3>Olympus Reservoirs </h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/237/individually-wrapped">Individually Wrapped</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/238/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Reservoirs " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Reservoirs " data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/234/biodegradable-reservoirs-biotix">Biodegradable Reservoirs, Biotix</a>

                			<div class="sub-menu">

        			<h3>Biodegradable Reservoirs, Biotix</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4869/individually-wrapped">Individually Wrapped</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4870/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biodegradable Reservoirs, Biotix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biodegradable Reservoirs, Biotix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6542/biodegradable-reservoirs-bio-pure">Biodegradable Reservoirs, Bio-Pure</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biodegradable Reservoirs, Bio-Pure" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biodegradable Reservoirs, Bio-Pure" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4972/texan-reagent-reservoirs">Texan Reagent Reservoirs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Texan Reagent Reservoirs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Texan Reagent Reservoirs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reagent Reservoirs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reagent Reservoirs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/239/robotic-reservoirs">Robotic Reservoirs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Robotic Reservoirs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Robotic Reservoirs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dishes &amp; Reservoirs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dishes &amp; Reservoirs" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/366/sealing-films">Sealing Films</a>

                			<div class="sub-menu">

        			<h3>Sealing Films</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7037/pcr-film-strips-">PCR Film Strips </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Film Strips " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Film Strips " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/370/real-time-pcr-films">Real-Time PCR Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real-Time PCR Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real-Time PCR Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/367/standard-pcr-films">Standard PCR Films</a>

                			<div class="sub-menu">

        			<h3>Standard PCR Films</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/368/transparent-films">Transparent Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transparent Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transparent Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/369/aluminum-foil-films">Aluminum Foil Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aluminum Foil Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aluminum Foil Films" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard PCR Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard PCR Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/375/elisa-incubation--and--storage">ELISA, Incubation &amp; Storage</a>

                			<div class="sub-menu">

        			<h3>ELISA, Incubation &amp; Storage</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/376/sealplate-films">SealPlate Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SealPlate Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SealPlate Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/377/sealmate-system">SealMate System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SealMate System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SealMate System" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ELISA, Incubation &amp; Storage" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ELISA, Incubation &amp; Storage" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/371/cold-storage-films">Cold Storage Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cold Storage Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cold Storage Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/372/cell--and--tissue-culture-films">Cell &amp; Tissue Culture Films</a>

                			<div class="sub-menu">

        			<h3>Cell &amp; Tissue Culture Films</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/373/aeraseal-films">AeraSeal Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="AeraSeal Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="AeraSeal Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/374/sealmate-system">SealMate System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SealMate System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SealMate System" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Tissue Culture Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Tissue Culture Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/378/fluorescence--and--luminescence-films">Fluorescence &amp; Luminescence Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fluorescence &amp; Luminescence Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fluorescence &amp; Luminescence Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/379/protein-crystallization-films">Protein Crystallization Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Crystallization Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Crystallization Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/380/films-for-automation">Films for Automation</a>

                			<div class="sub-menu">

        			<h3>Films for Automation</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/381/pcr--and--cold-storage">PCR &amp; Cold Storage</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR &amp; Cold Storage" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR &amp; Cold Storage" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/382/robotics-pierceability">Robotics Pierceability</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Robotics Pierceability" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Robotics Pierceability" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/383/roll-seal-films">Roll-Seal Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Roll-Seal Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Roll-Seal Films" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Films for Automation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Films for Automation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/384/pierceable-films">Pierceable Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pierceable Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pierceable Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5909/sealing-film-for-microtubes">Sealing Film for Microtubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Film for Microtubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Film for Microtubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Films" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Films" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4705/tissue-culture-plastics">Tissue Culture Plastics</a>

                			<div class="sub-menu">

        			<h3>Tissue Culture Plastics</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4711/tissue-culture-plates">Tissue Culture Plates</a>

                			<div class="sub-menu">

        			<h3>Tissue Culture Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4712/tc-treated-plates">TC Treated Plates</a>

                			<div class="sub-menu">

        			<h3>TC Treated Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4713/clear-plates">Clear Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4714/black-white-plates">Black/White Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Treated Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Treated Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4715/non-treated-plates">Non-Treated Plates</a>

                			<div class="sub-menu">

        			<h3>Non-Treated Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4716/clear-plates">Clear Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4717/black-white-plates">Black/White Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4718/tissue-culture-dishes">Tissue Culture Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4706/tissue-culture-flasks">Tissue Culture Flasks</a>

                			<div class="sub-menu">

        			<h3>Tissue Culture Flasks</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4707/tc-treated-flasks">TC Treated Flasks</a>

                			<div class="sub-menu">

        			<h3>TC Treated Flasks</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4708/vented-cap">Vented Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vented Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vented Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4709/plug-seal-cap">Plug Seal Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plug Seal Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plug Seal Cap" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Treated Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Treated Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4710/non-treated-flasks">Non-Treated Flasks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7656/shaker-flasks">Shaker Flasks</a>

                			<div class="sub-menu">

        			<h3>Shaker Flasks</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7653/baffled-bottom">Baffled Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Baffled Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Baffled Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7652/flat-bottom">Flat Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flat Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flat Bottom" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaker Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaker Flasks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8128/hybex-glass-bottles--and--flasks">Hybex™ Glass Bottles &amp; Flasks</a>

                			<div class="sub-menu">

        			<h3>Hybex™ Glass Bottles &amp; Flasks</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8129/hybex-erlenmeyer-flasks">Hybex™ Erlenmeyer Flasks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Erlenmeyer Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Erlenmeyer Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8130/hybex-erlenmeyer-flasks-w--gl45-cap">Hybex™ Erlenmeyer Flasks w/ GL45 Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Erlenmeyer Flasks w/ GL45 Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Erlenmeyer Flasks w/ GL45 Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8131/hybex-media-storage-bottles">Hybex™ Media Storage Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Media Storage Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Media Storage Bottles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Glass Bottles &amp; Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Glass Bottles &amp; Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6944/tissue-culture-bundles">Tissue Culture Bundles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4746/culture-tubes">Culture Tubes</a>

                			<div class="sub-menu">

        			<h3>Culture Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7464/polystyrene">Polystyrene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7463/polypropylene">Polypropylene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Culture Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Culture Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7045/tc-plate-inserts">TC Plate Inserts</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Plate Inserts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Plate Inserts" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4721/serological-pipets">Serological Pipets</a>

                			<div class="sub-menu">

        			<h3>Serological Pipets</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6575/individually-wrapped">Individually Wrapped</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4725/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4743/centrifuge-tubes">Centrifuge Tubes</a>

                			<div class="sub-menu">

        			<h3>Centrifuge Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4744/15ml-centrifuge-tubes">15ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4745/50ml-centrifuge-tubes">50ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4726/vacuum-filtration">Vacuum Filtration</a>

                			<div class="sub-menu">

        			<h3>Vacuum Filtration</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4727/complete-systems">Complete Systems</a>

                			<div class="sub-menu">

        			<h3>Complete Systems</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6474/15ml-systems">15ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5366/50ml-systems">50ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4728/250ml-systems">250ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4729/500ml-systems">500ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4730/1000ml-systems">1000ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Complete Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Complete Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4731/bottle-top-filter-cups">Bottle Top Filter Cups</a>

                			<div class="sub-menu">

        			<h3>Bottle Top Filter Cups</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4732/250ml-filter-cups">250ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4733/500ml-filter-cups">500ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4734/1000ml-filter-cups">1000ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottle Top Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottle Top Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Filtration" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Filtration" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4735/syringe-filters">Syringe Filters</a>

                			<div class="sub-menu">

        			<h3>Syringe Filters</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4736/pes-membrane">PES Membrane</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PES Membrane" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PES Membrane" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4739/pvdf-membrane">PVDF Membrane</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PVDF Membrane" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PVDF Membrane" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5714/cell-strainers">Cell Strainers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Strainers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Strainers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6561/cryogenic-vials">Cryogenic Vials</a>

                			<div class="sub-menu">

        			<h3>Cryogenic Vials</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6563/cryovials-internal-thread">Cryovials, Internal Thread</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryovials, Internal Thread" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryovials, Internal Thread" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6562/cryovials-external-thread">Cryovials, External Thread</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryovials, External Thread" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryovials, External Thread" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6565/cryovial-racks--and--boxes">Cryovial Racks &amp; Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryovial Racks &amp; Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryovial Racks &amp; Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryogenic Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryogenic Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6567/cell-freezing-container">Cell Freezing Container</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Freezing Container" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Freezing Container" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5008/cell-scrapers">Cell Scrapers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Scrapers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Scrapers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6582/plate-spreaders">Plate Spreaders</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plate Spreaders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plate Spreaders" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Plastics" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Plastics" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5757/cell-media--and--serum-fbs">Cell Media &amp; Serum (FBS)</a>

                			<div class="sub-menu">

        			<h3>Cell Media &amp; Serum (FBS)</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6585/fetal-bovine-serum--and--bioequivalents">Fetal Bovine Serum &amp; Bioequivalents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fetal Bovine Serum &amp; Bioequivalents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fetal Bovine Serum &amp; Bioequivalents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5760/classical-media">Classical Media</a>

                			<div class="sub-menu">

        			<h3>Classical Media</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5778/dmem">DMEM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DMEM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DMEM" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5780/rpmi-1640">RPMI 1640</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RPMI 1640" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RPMI 1640" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5781/mem">MEM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MEM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MEM" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5782/hams-f10--and--f12">Hams F10 &amp; F12</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hams F10 &amp; F12" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hams F10 &amp; F12" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Classical Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Classical Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5758/buffers--and--balanced-salts">Buffers &amp; Balanced Salts</a>

                			<div class="sub-menu">

        			<h3>Buffers &amp; Balanced Salts</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5773/dpbs">DPBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DPBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DPBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5774/pbs">PBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5775/hepes">HEPES</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HEPES" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HEPES" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Buffers &amp; Balanced Salts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Buffers &amp; Balanced Salts" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5765/cell-dissociation-reagents">Cell Dissociation Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Dissociation Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Dissociation Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5764/antibiotics--and--selection-agents">Antibiotics &amp; Selection Agents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibiotics &amp; Selection Agents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibiotics &amp; Selection Agents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5767/media-supplements">Media Supplements</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media Supplements" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media Supplements" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5759/process-water">Process Water</a>

                			<div class="sub-menu">

        			<h3>Process Water</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5761/cell-culture-grade-water">Cell Culture Grade Water</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Culture Grade Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Culture Grade Water" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5762/molecular-biology-grade-water">Molecular Biology Grade Water</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Biology Grade Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Biology Grade Water" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Process Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Process Water" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5771/drosophila-media"><i>Drosophila</i> Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Media" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Media &amp; Serum (FBS)" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Media &amp; Serum (FBS)" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/391/reagents-taq--and--buffers">Reagents, <i>Taq</i> &amp; Buffers</a>

                			<div class="sub-menu">

        			<h3>Reagents, <i>Taq</i> &amp; Buffers</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6574/agarose">Agarose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agarose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5746/antibiotics">Antibiotics</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibiotics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibiotics" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5486/bioreagents">Bioreagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bioreagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bioreagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5480/buffers-powdered">Buffers, Powdered</a>

                			<div class="sub-menu">

        			<h3>Buffers, Powdered</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5811/bbs">BBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="BBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="BBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5812/carbonate-bicarbonate">Carbonate-Bicarbonate</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Carbonate-Bicarbonate" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Carbonate-Bicarbonate" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5813/edta">EDTA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="EDTA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="EDTA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5814/glycine">Glycine</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glycine" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glycine" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5815/glycine-hcl">Glycine-HCl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glycine-HCl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glycine-HCl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5816/hepes">HEPES</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HEPES" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HEPES" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5817/mops">MOPS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MOPS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MOPS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5818/pbs">PBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5819/pbs-tween-20">PBS-Tween 20</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PBS-Tween 20" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PBS-Tween 20" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5820/pipes">PIPES</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PIPES" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PIPES" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5821/sodium-acetate">Sodium Acetate</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sodium Acetate" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sodium Acetate" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5822/ssc">SSC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SSC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SSC" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5823/sspe">SSPE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SSPE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SSPE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5824/tae">TAE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TAE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TAE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5825/taps">TAPS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TAPS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TAPS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5826/tbe">TBE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TBE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TBE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5827/tbs">TBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5828/tg-sds">TG-SDS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TG-SDS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TG-SDS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5829/tricine">Tricine</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tricine" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tricine" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5830/tris-base">Tris Base</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris Base" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris Base" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5831/tris-edta-te">Tris-EDTA (TE)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-EDTA (TE)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-EDTA (TE)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5832/tris-glycine-tg">Tris-Glycine (TG)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-Glycine (TG)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-Glycine (TG)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5833/tris-hcl">Tris-HCl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-HCl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-HCl" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Buffers, Powdered" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Buffers, Powdered" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5479/buffers-solutions">Buffers, Solutions</a>

                			<div class="sub-menu">

        			<h3>Buffers, Solutions</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5834/borate-buffered-saline">Borate Buffered Saline</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Borate Buffered Saline" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Borate Buffered Saline" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5835/edta-buffer-1x">EDTA Buffer, 1X</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="EDTA Buffer, 1X" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="EDTA Buffer, 1X" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5836/glycine-hci">Glycine-HCI</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glycine-HCI" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glycine-HCI" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5837/hepes-koh">HEPES-KOH</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HEPES-KOH" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HEPES-KOH" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5838/hepes-naoh">HEPES-NaOH</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HEPES-NaOH" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HEPES-NaOH" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5839/mops">MOPS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MOPS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MOPS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5840/pbs">PBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5841/pbs-tween-20">PBS-Tween 20</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PBS-Tween 20" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PBS-Tween 20" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5842/sds">SDS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SDS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SDS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5843/ssc">SSC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SSC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SSC" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5844/tae">TAE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TAE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TAE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5845/tbe">TBE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TBE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TBE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5846/tbs">TBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5847/tbs-tween-20">TBS-Tween 20</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TBS-Tween 20" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TBS-Tween 20" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5848/tg-sds">TG-SDS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TG-SDS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TG-SDS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5853/tris-edta-te-10x-50x">Tris-EDTA (TE), 10X-50X</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-EDTA (TE), 10X-50X" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-EDTA (TE), 10X-50X" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5849/tris-edta-te-100x">Tris-EDTA (TE), 100X</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-EDTA (TE), 100X" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-EDTA (TE), 100X" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5850/tris-glycine-tg">Tris-Glycine (TG)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-Glycine (TG)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-Glycine (TG)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5851/tris-hcl">Tris-HCl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-HCl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-HCl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5852/tris-sds">Tris-SDS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris-SDS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris-SDS" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Buffers, Solutions" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Buffers, Solutions" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6991/cdna-synthesis-kits">cDNA Synthesis Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="cDNA Synthesis Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="cDNA Synthesis Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/439/competent-cells">Competent Cells</a>

                			<div class="sub-menu">

        			<h3>Competent Cells</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/440/gc5-competent-cells">GC5 Competent Cells</a>

                			<div class="sub-menu">

        			<h3>GC5 Competent Cells</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/441/single-use-aliquots">Single Use Aliquots</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Use Aliquots" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Use Aliquots" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/442/200ul-aliquots">200ul Aliquots</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200ul Aliquots" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200ul Aliquots" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/443/96-well-plates">96-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GC5 Competent Cells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GC5 Competent Cells" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/444/gc10-competent-cells">GC10 Competent Cells</a>

                			<div class="sub-menu">

        			<h3>GC10 Competent Cells</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/445/single-use-aliquots">Single Use Aliquots</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Use Aliquots" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Use Aliquots" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/446/200ul-aliquots">200ul Aliquots</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200ul Aliquots" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200ul Aliquots" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/447/96-well-plates">96-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GC10 Competent Cells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GC10 Competent Cells" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/448/gc10-electrocomp-cells-">GC10 Electrocomp Cells </a>

                			<div class="sub-menu">

        			<h3>GC10 Electrocomp Cells </h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/449/thunderbolt-gc10">Thunderbolt GC10</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thunderbolt GC10" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thunderbolt GC10" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GC10 Electrocomp Cells " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GC10 Electrocomp Cells " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/451/jm109-competent-cells">JM109 Competent Cells</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="JM109 Competent Cells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="JM109 Competent Cells" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5162/e.-coli-transformation-kit--and--buffer-set">E. Coli Transformation Kit &amp; Buffer Set</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="E. Coli Transformation Kit &amp; Buffer Set" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="E. Coli Transformation Kit &amp; Buffer Set" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5082/mix--and--plate-competent-cells">Mix &amp; Plate Competent Cells</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mix &amp; Plate Competent Cells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mix &amp; Plate Competent Cells" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5185/mix--and--go-competent-cells">Mix &amp; Go Competent Cells</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mix &amp; Go Competent Cells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mix &amp; Go Competent Cells" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Competent Cells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Competent Cells" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/427/decontaminants">Decontaminants</a>

                			<div class="sub-menu">

        			<h3>Decontaminants</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/428/rnase-dnase-removal">RNase, DNase Removal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNase, DNase Removal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNase, DNase Removal" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/429/alcohol-wipes">Alcohol Wipes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Alcohol Wipes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Alcohol Wipes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Decontaminants" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Decontaminants" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7010/dna-extract--and--amplify-kits">DNA Extract &amp; Amplify Kits</a>

                			<div class="sub-menu">

        			<h3>DNA Extract &amp; Amplify Kits</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7011/rapid-extract-pcr-kit">Rapid Extract PCR Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rapid Extract PCR Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rapid Extract PCR Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7012/rapid-extract-lysis-only-kit">Rapid Extract Lysis Only Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rapid Extract Lysis Only Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rapid Extract Lysis Only Kit" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA Extract &amp; Amplify Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA Extract &amp; Amplify Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/410/dntps">dNTPs</a>

                			<div class="sub-menu">

        			<h3>dNTPs</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/411/dntp-sets">dNTP Sets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Sets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Sets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/412/dntp-mixes">dNTP Mixes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTPs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTPs" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/422/electrophoresis-reagents">Electrophoresis Reagents</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/423/liquid-buffers">Liquid Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5747/nucleic-acid-stains">Nucleic Acid Stains</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nucleic Acid Stains" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nucleic Acid Stains" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/426/page-reagents">PAGE Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PAGE Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PAGE Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/424/powdered-buffers">Powdered Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Powdered Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Powdered Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/425/tris-tricine-edta">Tris/Tricine/EDTA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris/Tricine/EDTA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris/Tricine/EDTA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7847/flow-cytometry-reagents">Flow Cytometry Reagents</a>

                			<div class="sub-menu">

        			<h3>Flow Cytometry Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7849/primary-antibodies">Primary Antibodies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Primary Antibodies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Primary Antibodies" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flow Cytometry Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flow Cytometry Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7614/high-fidelity-polymerases">High-Fidelity Polymerases</a>

                			<div class="sub-menu">

        			<h3>High-Fidelity Polymerases</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7626/high-fidelity-polymerase">High Fidelity Polymerase</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Fidelity Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Fidelity Polymerase" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7627/hot-start-high-fidelity-polymerase">Hot Start High Fidelity Polymerase</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start High Fidelity Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start High Fidelity Polymerase" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High-Fidelity Polymerases" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High-Fidelity Polymerases" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6993/one-step-rt-pcr-mix-endpoint">One-Step RT-PCR Mix (Endpoint)</a>

                			<div class="sub-menu">

        			<h3>One-Step RT-PCR Mix (Endpoint)</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6994/pcrbio-1-step-rt-pcr-kits">PCRBio 1-Step RT-PCR Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBio 1-Step RT-PCR Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBio 1-Step RT-PCR Kits" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="One-Step RT-PCR Mix (Endpoint)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="One-Step RT-PCR Mix (Endpoint)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6987/one-step-rt-qpcr-mixes">One-Step RT-qPCR Mixes</a>

                			<div class="sub-menu">

        			<h3>One-Step RT-qPCR Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6988/sygreen-1-step-detect-kits-for-sensitivity">SyGreen 1-Step Detect Kits for Sensitivity</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen 1-Step Detect Kits for Sensitivity" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen 1-Step Detect Kits for Sensitivity" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6989/sygreen-1-step-go-kits-for-rapid-results">SyGreen 1-Step Go Kits for Rapid Results</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen 1-Step Go Kits for Rapid Results" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen 1-Step Go Kits for Rapid Results" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6990/probe-1-step-go-kits">Probe 1-Step Go Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Probe 1-Step Go Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Probe 1-Step Go Kits" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="One-Step RT-qPCR Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="One-Step RT-qPCR Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6980/real-time-pcr-mixes-qpcr">Real-Time PCR Mixes (qPCR)</a>

                			<div class="sub-menu">

        			<h3>Real-Time PCR Mixes (qPCR)</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6981/sygreen-qpcr-mix">SyGreen qPCR Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen qPCR Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen qPCR Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6982/sygreen-qpcr-mix-blue">SyGreen qPCR Mix, Blue</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen qPCR Mix, Blue" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen qPCR Mix, Blue" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6985/sygreen-hrm-qpcr-mix">SyGreen HRM qPCR Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen HRM qPCR Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen HRM qPCR Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6983/probe-qpcr-mix">Probe qPCR Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Probe qPCR Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Probe qPCR Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6984/probe-qpcr-mix-blue">Probe qPCR Mix, Blue</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Probe qPCR Mix, Blue" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Probe qPCR Mix, Blue" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6986/probe-genotyping-qpcr-mix">Probe Genotyping qPCR Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Probe Genotyping qPCR Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Probe Genotyping qPCR Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5104/apex-green-qpcr-mix">Apex Green qPCR Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Green qPCR Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Green qPCR Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5103/apex-probe-qpcr-mix">Apex Probe qPCR Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Probe qPCR Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Probe qPCR Mix" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real-Time PCR Mixes (qPCR)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real-Time PCR Mixes (qPCR)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6992/reverse-transcriptases">Reverse Transcriptases</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reverse Transcriptases" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reverse Transcriptases" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/392/taq-dna-polymerases"><i>Taq</i> DNA Polymerases</a>

                			<div class="sub-menu">

        			<h3><i>Taq</i> DNA Polymerases</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/393/apex-standard-taq-5-unit-ul">Apex Standard <i>Taq</i>, 5 Unit/ul</a>

                			<div class="sub-menu">

        			<h3>Apex Standard <i>Taq</i>, 5 Unit/ul</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/394/w--1.5mm-mg-buffers">w/ 1.5mM Mg Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ 1.5mM Mg Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ 1.5mM Mg Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/395/w--mg-free-buffers">w/ Mg Free Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/396/w--multiplex-buffers">w/ Multiplex Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Multiplex Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Multiplex Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/397/no-buffers-included">No Buffers Included</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="No Buffers Included" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="No Buffers Included" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Standard Taq, 5 Unit/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Standard Taq, 5 Unit/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/398/apex-standard-taq-1-unit-ul">Apex Standard <i>Taq</i>, 1 Unit/ul</a>

                			<div class="sub-menu">

        			<h3>Apex Standard <i>Taq</i>, 1 Unit/ul</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/399/w--mg-free-buffer">w/ Mg Free Buffer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Mg Free Buffer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Mg Free Buffer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/400/-red-mg-free-buffer"> RED, Mg Free Buffer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category=" RED, Mg Free Buffer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category=" RED, Mg Free Buffer" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Standard Taq, 1 Unit/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Standard Taq, 1 Unit/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/401/apex-hot-start-taq-5-units-ul">Apex Hot Start <i>Taq</i>, 5 Units/ul</a>

                			<div class="sub-menu">

        			<h3>Apex Hot Start <i>Taq</i>, 5 Units/ul</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/402/w--mg-free-buffers">w/ Mg Free Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Hot Start Taq, 5 Units/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Hot Start Taq, 5 Units/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6996/pcrbio-standard-taq-5-units-ul">PCRBIO Standard <i>Taq</i>, 5 Units/ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Standard Taq, 5 Units/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Standard Taq, 5 Units/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6998/pcrbio-hot-start-taq-5units-ul">PCRBIO Hot Start <i>Taq</i>, 5Units/ul</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Hot Start Taq, 5Units/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Hot Start Taq, 5Units/ul" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Taq DNA Polymerases" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Taq DNA Polymerases" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/405/taq-master-mixes"><i>Taq</i> Master Mixes</a>

                			<div class="sub-menu">

        			<h3><i>Taq</i> Master Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/406/apex-master-mix-colorless">Apex Master Mix, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Master Mix, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Master Mix, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/407/apex-master-mix-red">Apex Master Mix, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Master Mix, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Master Mix, Red" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/408/apex-hot-start-master-mix-colorless">Apex Hot Start Master Mix, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Hot Start Master Mix, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Hot Start Master Mix, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/409/apex-hot-start-master-mix-blue">Apex Hot Start Master Mix, Blue</a>

                			<div class="sub-menu">

        			<h3>Apex Hot Start Master Mix, Blue</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7002/standard-colorless">Standard, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard, Colorless" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Hot Start Master Mix, Blue" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Hot Start Master Mix, Blue" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7003/pcrbio-master-mix-red">PCRBIO Master Mix, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Master Mix, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Master Mix, Red" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7004/pcrbio-hot-start-master-mix-colorless">PCRBIO Hot Start Master Mix, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Hot Start Master Mix, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Hot Start Master Mix, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7005/pcrbio-hot-start-master-mix-red">PCRBIO Hot Start Master Mix, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Hot Start Master Mix, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Hot Start Master Mix, Red" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Taq Master Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Taq Master Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6914/transfection-reagents">Transfection Reagents</a>

                			<div class="sub-menu">

        			<h3>Transfection Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7779/in-vitro-transfection-reagents">in vitro Transfection Reagents</a>

                			<div class="sub-menu">

        			<h3>in vitro Transfection Reagents</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7070/jetoptimus-dna-transfection-reagent">jetOPTIMUS® DNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetOPTIMUS® DNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetOPTIMUS® DNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6916/jetprime-dna-and-sirna-transfection-reagent-">jetPRIME® DNA &amp; siRNA Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPRIME® DNA and siRNA Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPRIME® DNA and siRNA Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6921/interferin-sirna-and-mirna-transfection-reagent">INTERFERin® siRNA &amp; miRNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="INTERFERin® siRNA and miRNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="INTERFERin® siRNA and miRNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6917/jetmessenger-mrna-transfection-reagent">jetMESSENGER™ mRNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetMESSENGER™ mRNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetMESSENGER™ mRNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6922/pulsin-protein-delivery-reagent">PULSin® protein Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PULSin® protein Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PULSin® protein Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6919/jetpei-hepatocyte-dna-transfection-reagent-">jetPEI®-Hepatocyte DNA Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPEI®-Hepatocyte DNA Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPEI®-Hepatocyte DNA Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6918/jetpei-macrophage-dna-transfection-reagent-">jetPEI®-Macrophage DNA Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPEI®-Macrophage DNA Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPEI®-Macrophage DNA Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6915/jetpei-hts-dna-transfection-reagent">jetPEI® HTS DNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPEI® HTS DNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPEI® HTS DNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vitro Transfection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vitro Transfection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7780/in-vivo-transfection-reagents">In vivo Transfection Reagents</a>

                			<div class="sub-menu">

        			<h3>In vivo Transfection Reagents</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6924/in-vivo-jetpei-in-vivo-delivery-reagent">in vivo-jetPEI®, in vivo Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetPEI®, in vivo Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetPEI®, in vivo Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7781/in-vivo-jetrna-delivery-reagent">in vivo-jetRNA® Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetRNA® Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetRNA® Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6926/in-vivo-jetpei-gal-in-vivo-delivery-reagent">in vivo-jetPEI®-Gal, in vivo Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetPEI®-Gal, in vivo Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetPEI®-Gal, in vivo Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6925/in-vivo-jetpei-man-in-vivo-delivery-reagent">in vivo-jetPEI®-Man, in vivo Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetPEI®-Man, in vivo Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetPEI®-Man, in vivo Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="In vivo Transfection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="In vivo Transfection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7773/protein-production">Protein Production</a>

                			<div class="sub-menu">

        			<h3>Protein Production</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7774/fectopro">FectoPRO®</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FectoPRO®" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FectoPRO®" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7775/fectocho-expression-system">FectoCHO® Expression System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FectoCHO® Expression System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FectoCHO® Expression System" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Production" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Production" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7776/virus-production">Virus Production</a>

                			<div class="sub-menu">

        			<h3>Virus Production</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7777/fectovir-aav">FectoVIR®-AAV</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FectoVIR®-AAV" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FectoVIR®-AAV" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7778/peipro-dna-transfection-reagent">PEIpro® DNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PEIpro® DNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PEIpro® DNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Virus Production" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Virus Production" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transfection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transfection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5168/water">Water</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Water" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reagents, Taq, &amp; Buffers" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reagents, Taq, &amp; Buffers" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6659/chemicals--and--standards">Chemicals &amp; Standards</a>

                			<div class="sub-menu">

        			<h3>Chemicals &amp; Standards</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6729/acids--and--bases">Acids &amp; Bases</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Acids &amp; Bases" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Acids &amp; Bases" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6730/anion-standards">Anion Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anion Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anion Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6731/apha-standard-methods-reagents">APHA Standard Methods Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="APHA Standard Methods Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="APHA Standard Methods Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6732/atomic-absorption-aa-standards">Atomic Absorption (AA) Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Atomic Absorption (AA) Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Atomic Absorption (AA) Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6733/blood-bank-reagents">Blood Bank Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blood Bank Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blood Bank Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6734/bod---cod-standards">BOD / COD Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="BOD / COD Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="BOD / COD Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6735/chemical-indicators">Chemical Indicators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Chemical Indicators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Chemical Indicators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6736/clinical-reagents">Clinical Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clinical Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clinical Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6737/color-standards">Color Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Color Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Color Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6738/conductivity-standards">Conductivity Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Conductivity Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Conductivity Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6739/cytology-reagents">Cytology Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cytology Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cytology Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6740/dry-chemicals">Dry Chemicals</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dry Chemicals" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dry Chemicals" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6741/european-pharmacopoeia-ep-reagents">European Pharmacopoeia (EP) Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="European Pharmacopoeia (EP) Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="European Pharmacopoeia (EP) Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6742/fixatives">Fixatives</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fixatives" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fixatives" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6743/high-purity-water">High Purity Water</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Purity Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Purity Water" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6744/histology-reagents">Histology Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Histology Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Histology Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6745/hplc-reagents">HPLC Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HPLC Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HPLC Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6746/hematology-reagents">Hematology Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hematology Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hematology Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6747/ion-selective-electrode-ise-standards-and-reagents">Ion Selective Electrode ISE Standards &amp; Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ion Selective Electrode ISE Standards and Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ion Selective Electrode ISE Standards and Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6748/microbiology-reagents">Microbiology Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microbiology Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microbiology Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6749/other-aqueous-solutions">Other Aqueous Solutions</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Other Aqueous Solutions" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Other Aqueous Solutions" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6750/other-standards">Other Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Other Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Other Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6751/oxidation-reduction-potential-orp-standards">Oxidation-Reduction Potential (ORP) Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Oxidation-Reduction Potential (ORP) Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Oxidation-Reduction Potential (ORP) Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6752/ph-control-buffers">pH Control Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="pH Control Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="pH Control Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6753/ph-reference-buffers">pH Reference Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="pH Reference Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="pH Reference Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6754/ph-test-strips">pH Test Strips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="pH Test Strips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="pH Test Strips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6755/solvents">Solvents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Solvents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Solvents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6756/titrants">Titrants</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Titrants" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Titrants" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6757/usp-reagents">USP Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="USP Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="USP Reagents" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Chemicals &amp; Standards" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Chemicals &amp; Standards" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5042/dna--and--rna-purification">DNA &amp; RNA Purification</a>

                			<div class="sub-menu">

        			<h3>DNA &amp; RNA Purification</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5180/uprep-universal-spin-columns">UPrep Universal Spin Columns</a>

                			<div class="sub-menu">

        			<h3>UPrep Universal Spin Columns</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6551/plasmid-miniprep-columns">Plasmid Miniprep Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Miniprep Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Miniprep Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6552/plasmid-midi-columns">Plasmid Midi Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Midi Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Midi Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6553/plasmid-maxi-columns">Plasmid Maxi Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Maxi Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Maxi Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6554/pcr-purification-columns">PCR Purification Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Purification Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Purification Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6555/gel-extraction-columns">Gel Extraction Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Extraction Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Extraction Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6556/gdna-extraction-columns">gDNA Extraction Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="gDNA Extraction Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="gDNA Extraction Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6557/direct-zol-extra-columns">Direct-zol Extra Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Direct-zol Extra Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Direct-zol Extra Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6558/rna-clean-up-columns">RNA Clean-up Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA Clean-up Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA Clean-up Columns" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="UPrep Universal Spin Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="UPrep Universal Spin Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5145/sample-collection--and--preservation">Sample Collection &amp; Preservation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sample Collection &amp; Preservation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sample Collection &amp; Preservation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5037/pcr-purification---dna-clean-up-kits">PCR Purification / DNA Clean-up Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Purification / DNA Clean-up Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Purification / DNA Clean-up Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5038/gel-dna-extraction-kits">Gel DNA Extraction Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel DNA Extraction Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel DNA Extraction Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5040/plasmid-dna-purification-kits">Plasmid DNA Purification Kits</a>

                			<div class="sub-menu">

        			<h3>Plasmid DNA Purification Kits</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5043/plasmid-miniprep">Plasmid Miniprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Miniprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Miniprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5044/plasmid-midiprep">Plasmid Midiprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Midiprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Midiprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5045/plasmid-maxiprep">Plasmid Maxiprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Maxiprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Maxiprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5739/plasmid-gigaprep">Plasmid Gigaprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Gigaprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Gigaprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6546/bac-yac--and--pac-dna">BAC, YAC, &amp; PAC DNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="BAC, YAC, &amp; PAC DNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="BAC, YAC, &amp; PAC DNA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid DNA Purification Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid DNA Purification Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5041/genomic-dna-purification-kits">Genomic DNA Purification Kits</a>

                			<div class="sub-menu">

        			<h3>Genomic DNA Purification Kits</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5046/genomic-dna-clean-up">Genomic DNA Clean-up</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Genomic DNA Clean-up" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Genomic DNA Clean-up" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5047/cell--and--soft-tissue-dna">Cell &amp; Soft Tissue DNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Soft Tissue DNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Soft Tissue DNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5048/solid--and--ffpe-tissue-dna">Solid &amp; FFPE Tissue DNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Solid &amp; FFPE Tissue DNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Solid &amp; FFPE Tissue DNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5049/soil-fecal--and--plant-dna">Soil, Fecal &amp; Plant DNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soil, Fecal &amp; Plant DNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soil, Fecal &amp; Plant DNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5050/bacterial--and--fungal-dna">Bacterial &amp; Fungal DNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bacterial &amp; Fungal DNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bacterial &amp; Fungal DNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5173/nucleosomal-dna">Nucleosomal DNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nucleosomal DNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nucleosomal DNA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Genomic DNA Purification Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Genomic DNA Purification Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7723/viral-dna-rna-purification">Viral DNA/RNA Purification</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Viral DNA/RNA Purification" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Viral DNA/RNA Purification" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5053/total-rna-purification-kits">Total RNA Purification Kits</a>

                			<div class="sub-menu">

        			<h3>Total RNA Purification Kits</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5054/samples-in-tri-reagent-trizol-etc.">Samples in TRI-Reagent®, TRIzol®, etc.</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Samples in TRI-Reagent®, TRIzol®, etc." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Samples in TRI-Reagent®, TRIzol®, etc." data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5055/cell--and--soft-tissue-rna">Cell &amp; Soft Tissue RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Soft Tissue RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Soft Tissue RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5167/solid--and--ffpe-tissue-rna">Solid &amp; FFPE Tissue RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Solid &amp; FFPE Tissue RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Solid &amp; FFPE Tissue RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5170/soil-fecal--and--plant-rna">Soil, Fecal &amp; Plant RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soil, Fecal &amp; Plant RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soil, Fecal &amp; Plant RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5056/bacterial--and--fungal-rna">Bacterial &amp; Fungal RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bacterial &amp; Fungal RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bacterial &amp; Fungal RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5171/blood--and--body-fluid-rna">Blood &amp; Body Fluid RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blood &amp; Body Fluid RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blood &amp; Body Fluid RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7733/viral-rna-isolation">Viral RNA Isolation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Viral RNA Isolation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Viral RNA Isolation" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Total RNA Purification Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Total RNA Purification Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5051/rna-clean-up-kits">RNA Clean-up Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA Clean-up Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA Clean-up Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5172/dna-rna-co-purification-kits">DNA/RNA Co-Purification Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA/RNA Co-Purification Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA/RNA Co-Purification Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6547/microbiomics-and-metagenomics">Microbiomics &amp; Metagenomics</a>

                			<div class="sub-menu">

        			<h3>Microbiomics &amp; Metagenomics</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6550/sample-collection-and-stabilization-devices">Sample Collection &amp; Stabilization Devices</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sample Collection and Stabilization Devices" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sample Collection and Stabilization Devices" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6548/standards">Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standards" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7620/microbial-dna-isolation">Microbial DNA Isolation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microbial DNA Isolation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microbial DNA Isolation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7621/microbial-rna-isolation">Microbial RNA Isolation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microbial RNA Isolation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microbial RNA Isolation" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microbiomics and Metagenomics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microbiomics and Metagenomics" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5064/epigenetics">Epigenetics</a>

                			<div class="sub-menu">

        			<h3>Epigenetics</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5174/dna-methylation">DNA Methylation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA Methylation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA Methylation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5175/dna-hydroxymethylation">DNA Hydroxymethylation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA Hydroxymethylation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA Hydroxymethylation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7617/chip-kits">ChIP Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ChIP Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ChIP Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7622/ngs-library-prep-kits">NGS Library Prep Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="NGS Library Prep Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="NGS Library Prep Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7623/methylated-dna-standards">Methylated DNA Standards</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Methylated DNA Standards" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Methylated DNA Standards" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Epigenetics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Epigenetics" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7084/sample-collection--and--preservation">Sample Collection &amp; Preservation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sample Collection &amp; Preservation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sample Collection &amp; Preservation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7746/micro-volume-spectrophotometers">Micro-Volume Spectrophotometers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Micro-Volume Spectrophotometers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Micro-Volume Spectrophotometers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA &amp; RNA Purification" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA &amp; RNA Purification" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6377/protein-biology-products">Protein Biology Products</a>

                			<div class="sub-menu">

        			<h3>Protein Biology Products</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6383/antibodies">Antibodies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibodies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibodies" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6380/antibody-purification-resins">Antibody Purification Resins</a>

                			<div class="sub-menu">

        			<h3>Antibody Purification Resins</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6399/protein-g-agarose">Protein G Agarose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein G Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein G Agarose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6400/protein-a-g-agarose">Protein A/G Agarose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein A/G Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein A/G Agarose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6401/protein-l-agarose">Protein L Agarose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein L Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein L Agarose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6397/protein-a-agarose">Protein A Agarose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein A Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein A Agarose" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibody Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibody Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6861/blocking--and--transfer-buffers">Blocking &amp; Transfer Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blocking &amp; Transfer Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blocking &amp; Transfer Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6701/blotting-boxes">Blotting Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6702/blotting-paper">Blotting Paper</a>

                			<div class="sub-menu">

        			<h3>Blotting Paper</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6703/0.34mm-thick-3mm-chr">0.34mm thick (3MM Chr)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.34mm thick (3MM Chr)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.34mm thick (3MM Chr)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6704/0.83mm-thick-gb003">0.83mm thick (GB003)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.83mm thick (GB003)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.83mm thick (GB003)" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6698/blotting-x-ray-film">Blotting X-Ray Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting X-Ray Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting X-Ray Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6697/blotting-membranes">Blotting Membranes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Membranes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Membranes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6382/ecl-detection-reagents">ECL Detection Reagents</a>

                			<div class="sub-menu">

        			<h3>ECL Detection Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6388/prosignal-pico">ProSignal Pico</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ProSignal Pico" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ProSignal Pico" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6389/prosignal-dura">ProSignal Dura</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ProSignal Dura" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ProSignal Dura" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6390/prosignal-femto">ProSignal Femto</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ProSignal Femto" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ProSignal Femto" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ECL Detection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ECL Detection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6385/page-reagents--and--stains">PAGE Reagents &amp; Stains</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PAGE Reagents &amp; Stains" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PAGE Reagents &amp; Stains" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7597/protein-concentrators">Protein Concentrators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Concentrators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Concentrators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7062/protease-inhibitor-cocktails">Protease Inhibitor Cocktails</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protease Inhibitor Cocktails" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protease Inhibitor Cocktails" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7061/protein-extraction">Protein Extraction</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Extraction" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Extraction" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6713/protein-ladders">Protein Ladders</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Ladders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Ladders" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7063/protein-quantitation">Protein Quantitation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Quantitation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Quantitation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6387/purification-reagents">Purification Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Purification Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Purification Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7149/tagged-purification-resins">Tagged Purification Resins</a>

                			<div class="sub-menu">

        			<h3>Tagged Purification Resins</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6378/his-tag-purification-resins">His-Tag Purification Resins</a>

                			<div class="sub-menu">

        			<h3>His-Tag Purification Resins</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6728/ni-nta-columns">Ni-NTA Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ni-NTA Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ni-NTA Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6393/nickel-nta-agarose-resin">Nickel-NTA Agarose Resin</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nickel-NTA Agarose Resin" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nickel-NTA Agarose Resin" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6394/nickel-max-flow-affinity-resin">Nickel Max Flow Affinity Resin</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nickel Max Flow Affinity Resin" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nickel Max Flow Affinity Resin" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6395/cobalt-max-flow-metal-affinity-resin">Cobalt Max Flow Metal Affinity Resin</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cobalt Max Flow Metal Affinity Resin" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cobalt Max Flow Metal Affinity Resin" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6392/cobalt-metal-affinity-resin">Cobalt Metal Affinity Resin</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cobalt Metal Affinity Resin" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cobalt Metal Affinity Resin" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="His-Tag Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="His-Tag Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6379/gst-tag-purification-resins">GST-Tag Purification Resins</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GST-Tag Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GST-Tag Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tagged Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tagged Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6559/syringe-filters">Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Biology Products" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Biology Products" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1512/electrophoresis">Electrophoresis</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4441/agarose">Agarose</a>

                			<div class="sub-menu">

        			<h3>Agarose</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4442/general-purpose--and--quick-dissolve-le">General Purpose &amp; Quick Dissolve LE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General Purpose &amp; Quick Dissolve LE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General Purpose &amp; Quick Dissolve LE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4445/super-fine-resolution">Super Fine Resolution</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Super Fine Resolution" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Super Fine Resolution" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4446/super-resolution-3:1-blend">Super Resolution 3:1 Blend</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Super Resolution 3:1 Blend" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Super Resolution 3:1 Blend" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4447/low-melt">Low Melt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Melt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Melt" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4448/low-melt-sieve">Low Melt Sieve</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Melt Sieve" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Melt Sieve" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agarose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4472/blotting-paper">Blotting Paper</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4473/dna-ladders">DNA Ladders</a>

                			<div class="sub-menu">

        			<h3>DNA Ladders</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7054/up-to-500-bp">Up to 500 bp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Up to 500 bp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Up to 500 bp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7055/100-bp---1-kb">100 bp - 1 kb</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100 bp - 1 kb" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100 bp - 1 kb" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7058/100-bp---3-kb">100 bp - 3 kb</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100 bp - 3 kb" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100 bp - 3 kb" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7057/up-to-5-000-bp">Up to 5,000 bp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Up to 5,000 bp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Up to 5,000 bp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7056/up-to-10-000-bp--plus-">Up to 10,000 bp +</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Up to 10,000 bp +" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Up to 10,000 bp +" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4476/gel-loading-dye">Gel Loading Dye</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Loading Dye" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Loading Dye" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA Ladders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA Ladders" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4449/electrophoresis-buffers">Electrophoresis Buffers</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis Buffers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4450/liquid-solutions">Liquid Solutions</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Solutions" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Solutions" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4451/powder-premix-preset-ph">Powder Premix, Preset pH</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Powder Premix, Preset pH" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Powder Premix, Preset pH" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5888/single-use-powder-packs">Single Use Powder Packs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Use Powder Packs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Use Powder Packs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4452/tris-tricine-edta">Tris/Tricine/EDTA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris/Tricine/EDTA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris/Tricine/EDTA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4488/electroblotting-systems">Electroblotting Systems</a>

                			<div class="sub-menu">

        			<h3>Electroblotting Systems</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4489/semi-dry-electroblotters">Semi-Dry Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Dry Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Dry Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4490/tank-electroblotters">Tank Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tank Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tank Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroblotting Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroblotting Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4477/gel-boxes--and--accessories">Gel Boxes &amp; Accessories</a>

                			<div class="sub-menu">

        			<h3>Gel Boxes &amp; Accessories</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5081/real-time-horizontal-electrophoresis">Real Time Horizontal Electrophoresis</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real Time Horizontal Electrophoresis" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real Time Horizontal Electrophoresis" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4478/horizontal-gel-boxes">Horizontal Gel Boxes</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Boxes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4479/mini-horizontal-systems">Mini Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4480/midi-horizontal-systems">Midi Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4481/maxi-horizontal-systems">Maxi Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maxi Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maxi Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4482/vertical-gel-boxes">Vertical Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vertical Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vertical Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4483/horizontal-gel-box-accessories">Horizontal Gel Box Accessories</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Box Accessories</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4484/gel-casting-systems">Gel Casting Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Casting Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Casting Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4485/mini-horizontal-system-accessories">Mini Horizontal System Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal System Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal System Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4486/midi-horizontal-system-accessories">Midi Horizontal System Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal System Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal System Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Box Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Box Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4487/vertical-gel-box-accessories">Vertical Gel Box Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vertical Gel Box Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vertical Gel Box Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4880/gel-box-trade-in-program---25%-off">Gel Box Trade-In Program - 25% Off</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Box Trade-In Program - 25% Off" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Box Trade-In Program - 25% Off" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Boxes &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Boxes &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4492/gel-documentation-systems">Gel Documentation Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Documentation Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Documentation Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4461/gel-loading-tips">Gel Loading Tips</a>

                			<div class="sub-menu">

        			<h3>Gel Loading Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4462/round-gel-loading-tips">Round Gel Loading Tips</a>

                			<div class="sub-menu">

        			<h3>Round Gel Loading Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4463/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4464/racked">Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4465/racked-sterile">Racked, Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, Sterile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Round Gel Loading Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Round Gel Loading Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4466/flat-gel-loading-tips">Flat Gel Loading Tips</a>

                			<div class="sub-menu">

        			<h3>Flat Gel Loading Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4467/racked-0.37mm-o.d.">Racked, 0.37mm O.D.</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, 0.37mm O.D." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, 0.37mm O.D." data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4468/racked-0.17mm-o.d">Racked, 0.17mm O.D</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, 0.17mm O.D" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, 0.17mm O.D" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flat Gel Loading Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flat Gel Loading Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Loading Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Loading Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6560/nucleic-acid-stains">Nucleic Acid Stains</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nucleic Acid Stains" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nucleic Acid Stains" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4457/page-reagents">PAGE Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PAGE Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PAGE Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4491/power-supplies">Power Supplies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Power Supplies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Power Supplies" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4493/transilluminators">Transilluminators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transilluminators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transilluminators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/100/media">Media</a>

                			<div class="sub-menu">

        			<h3>Media</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/110/agars">Agars</a>

                			<div class="sub-menu">

        			<h3>Agars</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/111/granulated-agar">Granulated Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Granulated Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Granulated Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/112/powdered-agar">Powdered Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Powdered Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Powdered Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7446/nematode-medium-agar">Nematode Medium Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nematode Medium Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nematode Medium Agar" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agars" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agars" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6570/antibiotics">Antibiotics</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibiotics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibiotics" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4990/buffers--and--balanced-salts">Buffers &amp; Balanced Salts</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Buffers &amp; Balanced Salts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Buffers &amp; Balanced Salts" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6571/cell-dissociation-reagents">Cell Dissociation Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Dissociation Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Dissociation Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5485/dehydrated-culture-media">Dehydrated Culture Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dehydrated Culture Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dehydrated Culture Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/121/drosophila-media"><i>Drosophila</i> Media</a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i> Media</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/122/prepackaged-media">Prepackaged Media</a>

                			<div class="sub-menu">

        			<h3>Prepackaged Media</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/123/drosophila-food"><i>Drosophila</i> Food</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Food" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Food" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/124/grape-agar">Grape Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Grape Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Grape Agar" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Prepackaged Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Prepackaged Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/125/drosphila-agar">Drosphila Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosphila Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosphila Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/126/yellow-cornmeal">Yellow Cornmeal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yellow Cornmeal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yellow Cornmeal" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/127/yeast">Yeast</a>

                			<div class="sub-menu">

        			<h3>Yeast</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/128/inactive-dry-yeast">Inactive Dry Yeast</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Inactive Dry Yeast" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Inactive Dry Yeast" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/129/active-dry-yeast">Active Dry Yeast</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Active Dry Yeast" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Active Dry Yeast" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yeast" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yeast" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/130/molasses">Molasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molasses" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/131/soy-flour">Soy Flour</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soy Flour" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soy Flour" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/132/tegosept">Tegosept</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tegosept" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tegosept" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/133/propionic-acid-sodium-salt">Propionic Acid, Sodium Salt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Propionic Acid, Sodium Salt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Propionic Acid, Sodium Salt" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/134/malt-extract">Malt Extract</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Malt Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Malt Extract" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/135/sucrose">Sucrose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sucrose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sucrose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/136/dextrose">Dextrose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dextrose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dextrose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/137/corn-syrup-">Corn Syrup </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Corn Syrup " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Corn Syrup " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/138/apple-cider-vinegar">Apple Cider Vinegar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apple Cider Vinegar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apple Cider Vinegar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/139/drosophila-media-dispensing-equipment"><i>Drosophila</i> Media Dispensing Equipment</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Media Dispensing Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Media Dispensing Equipment" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5898/inoculating-loops">Inoculating Loops</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Inoculating Loops" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Inoculating Loops" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4985/mammalian-cell-media">Mammalian Cell Media</a>

                			<div class="sub-menu">

        			<h3>Mammalian Cell Media</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4993/classical-media">Classical Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Classical Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Classical Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4994/fetal-bovine-serum">Fetal Bovine Serum</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fetal Bovine Serum" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fetal Bovine Serum" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mammalian Cell Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mammalian Cell Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7447/nematode-growth-media">Nematode Growth Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nematode Growth Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nematode Growth Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5086/media-dispensing-pumps">Media Dispensing Pumps</a>

                			<div class="sub-menu">

        			<h3>Media Dispensing Pumps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5087/peristaltic-pumps">Peristaltic Pumps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Peristaltic Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Peristaltic Pumps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5088/silicone-tubing-for-peristaltic-pumps">Silicone Tubing for Peristaltic Pumps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Silicone Tubing for Peristaltic Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Silicone Tubing for Peristaltic Pumps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media Dispensing Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media Dispensing Pumps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5484/pre-weighed-media-vials">Pre-weighed Media Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pre-weighed Media Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pre-weighed Media Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/113/tryptone-peptone-yeast-extract">Tryptone, Peptone, Yeast Extract</a>

                			<div class="sub-menu">

        			<h3>Tryptone, Peptone, Yeast Extract</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/114/tryptone">Tryptone</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tryptone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tryptone" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/115/yeast-extract">Yeast Extract</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yeast Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yeast Extract" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/116/peptone">Peptone</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Peptone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Peptone" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tryptone, Peptone, Yeast Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tryptone, Peptone, Yeast Extract" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/262/equipment--and--apparatus">Equipment &amp; Apparatus</a>

                			<div class="sub-menu">

        			<h3>Equipment &amp; Apparatus</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8089/poseidon-equipment">Poseidon Equipment</a>

                			<div class="sub-menu">

        			<h3>Poseidon Equipment</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8092/centrifuges">Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Centrifuges</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8104/mini-centrifuge">Mini Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8106/mini-12-centrifuge-">Mini 12 Centrifuge </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini 12 Centrifuge " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini 12 Centrifuge " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8107/high-speed-12-centrifuge-">High Speed 12 Centrifuge </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Speed 12 Centrifuge " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Speed 12 Centrifuge " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8108/high-speed-24-centrifuge-">High Speed 24 Centrifuge </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Speed 24 Centrifuge " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Speed 24 Centrifuge " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8093/mixers--and--shakers">Mixers &amp; Shakers</a>

                			<div class="sub-menu">

        			<h3>Mixers &amp; Shakers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8098/mixers">Mixers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mixers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mixers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8099/shakers">Shakers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shakers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mixers &amp; Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mixers &amp; Shakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8090/pipettors">Pipettors</a>

                			<div class="sub-menu">

        			<h3>Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8112/single-channel">Single-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8102/8-channel">8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8103/12-channel">12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8095/rockers--and--rotators">Rockers &amp; Rotators</a>

                			<div class="sub-menu">

        			<h3>Rockers &amp; Rotators</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8100/rockers">Rockers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rockers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8101/rotators">Rotators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rotators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rotators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rockers &amp; Rotators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rockers &amp; Rotators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8097/temperature-controllers">Temperature Controllers</a>

                			<div class="sub-menu">

        			<h3>Temperature Controllers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8113/dry-bath-blocks-">Dry Bath Blocks </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dry Bath Blocks " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dry Bath Blocks " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8110/dry-baths">Dry Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dry Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dry Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8109/mini-incubated-shaker">Mini Incubated Shaker</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Incubated Shaker" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Incubated Shaker" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Temperature Controllers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Temperature Controllers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon Equipment" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6278/balances">Balances</a>

                			<div class="sub-menu">

        			<h3>Balances</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6279/analytical-balances">Analytical Balances</a>

                			<div class="sub-menu">

        			<h3>Analytical Balances</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7889/accuris">Accuris™</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accuris™" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accuris™" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6349/ohaus-adventurer">OHAUS Adventurer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Adventurer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Adventurer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6348/ohaus-explorer">OHAUS Explorer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Explorer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Explorer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6350/ohaus-pioneer">OHAUS Pioneer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Pioneer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Pioneer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6875/radwag-as.r2">Radwag AS.R2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag AS.R2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag AS.R2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7634/radwag-as.x2">Radwag AS.X2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag AS.X2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag AS.X2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7748/radwag-xa">Radwag XA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag XA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag XA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Analytical Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Analytical Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7635/compact-balances">Compact Balances</a>

                			<div class="sub-menu">

        			<h3>Compact Balances</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7891/accuris-compact">Accuris™ Compact</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accuris™ Compact" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accuris™ Compact" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7884/accuris-mini-">Accuris™ Mini </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accuris™ Mini " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accuris™ Mini " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7636/ohaus-ranger">OHAUS Ranger</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Ranger" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Ranger" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Compact Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Compact Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6359/portable-balances">Portable Balances</a>

                			<div class="sub-menu">

        			<h3>Portable Balances</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7637/ohaus-compass-cr">OHAUS Compass CR</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Compass CR" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Compass CR" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7087/ohaus-compass-cx">OHAUS Compass CX</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Compass CX" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Compass CX" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6365/ohaus-scout-portable">OHAUS Scout Portable</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Scout Portable" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Scout Portable" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6366/ohaus-scout-touch">OHAUS Scout Touch</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Scout Touch" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Scout Touch" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Portable Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Portable Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6282/precision-balances">Precision Balances</a>

                			<div class="sub-menu">

        			<h3>Precision Balances</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7892/accuris-precision">Accuris™ Precision</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accuris™ Precision" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accuris™ Precision" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6357/ohaus-adventurer">OHAUS Adventurer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Adventurer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Adventurer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6356/ohaus-explorer">OHAUS Explorer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Explorer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Explorer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6358/ohaus-pioneer">OHAUS Pioneer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Pioneer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Pioneer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6877/radwag-ps.r2">Radwag PS.R2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag PS.R2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag PS.R2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7638/radwag-ps.x2">Radwag PS.X2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag PS.X2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag PS.X2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7749/radwag-wtc">Radwag WTC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag WTC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag WTC" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7750/radwag-ps">Radwag PS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag PS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag PS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7751/radwag-wlc">Radwag WLC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag WLC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag WLC" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7752/radwag-pm">Radwag PM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag PM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag PM" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Precision Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Precision Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6285/semi-micro-balances">Semi-Micro Balances</a>

                			<div class="sub-menu">

        			<h3>Semi-Micro Balances</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7640/ohaus-explorer">OHAUS Explorer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Explorer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Explorer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7641/ohaus-pioneer">OHAUS Pioneer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Pioneer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Pioneer" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Micro Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Micro Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7642/two-pan-balances">Two Pan Balances</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Two Pan Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Two Pan Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7643/weights">Weights</a>

                			<div class="sub-menu">

        			<h3>Weights</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7646/class-astm-1">Class ASTM 1</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class ASTM 1" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class ASTM 1" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7647/class-astm-1-nvlap-certified">Class ASTM 1, NVLAP Certified</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class ASTM 1, NVLAP Certified" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class ASTM 1, NVLAP Certified" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7890/class-e2">Class E2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class E2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class E2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7887/class-f1">Class F1</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class F1" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class F1" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7886/class-m1">Class M1</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class M1" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class M1" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Weights" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Weights" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7756/micro-balances">Micro Balances</a>

                			<div class="sub-menu">

        			<h3>Micro Balances</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7760/radwag-mya">Radwag MYA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag MYA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag MYA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7761/radwag-xa">Radwag XA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Radwag XA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Radwag XA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Micro Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Micro Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7883/balance-accessories">Balance Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Balance Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Balance Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7153/baths">Baths</a>

                			<div class="sub-menu">

        			<h3>Baths</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6249/bead-baths">Bead Baths</a>

                			<div class="sub-menu">

        			<h3>Bead Baths</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6250/lab-armor-bead-baths">Lab Armor Bead Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lab Armor Bead Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lab Armor Bead Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6251/thermal-beads-to-replace-water">Thermal Beads to Replace Water</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Beads to Replace Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Beads to Replace Water" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bead Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bead Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6244/dry-baths">Dry Baths</a>

                			<div class="sub-menu">

        			<h3>Dry Baths</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6245/single-block">Single Block</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Block" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Block" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6246/multi-block-dry-bath">Multi Block Dry Bath</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi Block Dry Bath" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi Block Dry Bath" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6247/thermal-beads-to-replace-blocks">Thermal Beads to Replace Blocks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Beads to Replace Blocks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Beads to Replace Blocks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dry Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dry Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6248/water-baths">Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Water Baths" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6225/bottletop-dispensers">Bottletop Dispensers</a>

                			<div class="sub-menu">

        			<h3>Bottletop Dispensers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6819/analog">Analog</a>

                			<div class="sub-menu">

        			<h3>Analog</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6821/recirculation-valve">Recirculation Valve</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Recirculation Valve" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Recirculation Valve" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6820/standard-valve">Standard Valve</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Valve" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Valve" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Analog" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Analog" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6815/digital">Digital</a>

                			<div class="sub-menu">

        			<h3>Digital</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6816/recirculation-valve">Recirculation Valve</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Recirculation Valve" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Recirculation Valve" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6817/standard-valve">Standard Valve</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Valve" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Valve" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Digital" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Digital" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6226/common-materials">Common materials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Common materials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Common materials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6227/high-purity">High Purity</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Purity" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Purity" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6228/organic">Organic</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Organic" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Organic" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottletop Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottletop Dispensers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7863/cabinets-and-hoods">Cabinets &amp; Hoods</a>

                			<div class="sub-menu">

        			<h3>Cabinets &amp; Hoods</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7864/biosafety-cabinets">Biosafety Cabinets</a>

                			<div class="sub-menu">

        			<h3>Biosafety Cabinets</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7865/class-ii-a2">Class II A2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class II A2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class II A2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7868/class-ii-a2-eco">Class II A2 Eco</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class II A2 Eco" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class II A2 Eco" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7866/class-ii-b2">Class II B2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Class II B2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Class II B2" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biosafety Cabinets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biosafety Cabinets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7869/ductless-fume-hoods">Ductless Fume Hoods</a>

                			<div class="sub-menu">

        			<h3>Ductless Fume Hoods</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7870/basic">Basic</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Basic" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Basic" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7871/education">Education</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Education" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Education" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7872/ecoline">Ecoline</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ecoline" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ecoline" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7873/pro">PRO</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PRO" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PRO" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7874/weighing-station">Weighing Station</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Weighing Station" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Weighing Station" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ductless Fume Hoods" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ductless Fume Hoods" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7875/laminar-clean-benches">Laminar Clean Benches</a>

                			<div class="sub-menu">

        			<h3>Laminar Clean Benches</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7878/horizontal">Horizontal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7877/vertical">Vertical</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vertical" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vertical" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Laminar Clean Benches" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Laminar Clean Benches" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7879/pcr-cabinets">PCR Cabinets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Cabinets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Cabinets" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cabinets and Hoods" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cabinets and Hoods" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7860/cell-counters">Cell Counters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Counters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Counters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7633/cell-imaging-systems">Cell Imaging Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Imaging Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Imaging Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6828/centrifuges">Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Centrifuges</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7021/beckman-coulter-brand">Beckman Coulter Brand</a>

                			<div class="sub-menu">

        			<h3>Beckman Coulter Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7022/microfuge-16-microcentrifuge">Microfuge 16 Microcentrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microfuge 16 Microcentrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microfuge 16 Microcentrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7023/microfuge-20-microcentrifuge">Microfuge 20 Microcentrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microfuge 20 Microcentrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microfuge 20 Microcentrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7025/microfuge-20r-microcentrifuge">Microfuge 20R Microcentrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microfuge 20R Microcentrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microfuge 20R Microcentrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7031/allegra-x-5-centrifuge">Allegra X-5 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Allegra X-5 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Allegra X-5 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7032/allegra-x-30-centrifuge">Allegra X-30 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Allegra X-30 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Allegra X-30 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7033/allegra-x-30r-centrifuge">Allegra X-30R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Allegra X-30R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Allegra X-30R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7028/avanti-j-15-centrifuge">Avanti J-15 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Avanti J-15 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Avanti J-15 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7029/avanti-j-15r-centrifuge">Avanti J-15R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Avanti J-15R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Avanti J-15R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7034/avanti-jxn-26-floor-centrifuge">Avanti JXN-26 Floor Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Avanti JXN-26 Floor Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Avanti JXN-26 Floor Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7035/avanti-jxn-30-floor-centrifuge">Avanti JXN-30 Floor Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Avanti JXN-30 Floor Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Avanti JXN-30 Floor Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7030/avanti-j-e-floor-centrifuge">Avanti J-E Floor Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Avanti J-E Floor Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Avanti J-E Floor Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7036/avanti-j-e-rotors--and--accessories">Avanti J-E Rotors &amp; Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Avanti J-E Rotors &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Avanti J-E Rotors &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Beckman Coulter Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Beckman Coulter Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7013/benchmark-brand">Benchmark Brand</a>

                			<div class="sub-menu">

        			<h3>Benchmark Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7014/mini-centrifuges">Mini Centrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7015/microcentrifuges">Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7763/hematocrit-centrifuges">Hematocrit Centrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hematocrit Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hematocrit Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8115/accessories">Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7016/eppendorf-brand">Eppendorf Brand</a>

                			<div class="sub-menu">

        			<h3>Eppendorf Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7017/5425-centrifuge">5425 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5425 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5425 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7018/5425-rotors--and--accessories">5425 Rotors &amp; Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5425 Rotors &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5425 Rotors &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7019/5804-centrifuge">5804 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5804 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5804 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7020/5804r-centrifuge">5804R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5804R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5804R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8080/hermle-brand">Hermle Brand</a>

                			<div class="sub-menu">

        			<h3>Hermle Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8114/centrifuge-bundle-offers">Centrifuge Bundle Offers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuge Bundle Offers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuge Bundle Offers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8081/microcentrifuges-non-refrigerated">Microcentrifuges Non Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microcentrifuges Non Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microcentrifuges Non Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8082/microcentrifuges-refrigerated">Microcentrifuges Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microcentrifuges Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microcentrifuges Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8083/benchtop-centrifuges-non-refrigerated">Benchtop Centrifuges Non Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchtop Centrifuges Non Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchtop Centrifuges Non Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8084/benchtop-centrifuges-refrigerated-">Benchtop Centrifuges Refrigerated </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchtop Centrifuges Refrigerated " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchtop Centrifuges Refrigerated " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8085/high-performance-centrifuges-non-refrigerated--">High Performance Centrifuges Non Refrigerated  </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Performance Centrifuges Non Refrigerated  " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Performance Centrifuges Non Refrigerated  " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8086/high-performance-centrifuges-refrigerated-">High Performance Centrifuges Refrigerated </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Performance Centrifuges Refrigerated " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Performance Centrifuges Refrigerated " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8087/filtration-centrifuge-">Filtration Centrifuge </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filtration Centrifuge " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filtration Centrifuge " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8088/oil-testing-centrifuge-">Oil Testing Centrifuge </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Oil Testing Centrifuge " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Oil Testing Centrifuge " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hermle Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hermle Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8061/hettich-brand">Hettich Brand</a>

                			<div class="sub-menu">

        			<h3>Hettich Brand</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8062/rotofix-32a">ROTOFIX 32A</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTOFIX 32A" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTOFIX 32A" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8063/rotofix-46-h">ROTOFIX 46 (H)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTOFIX 46 (H)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTOFIX 46 (H)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8064/mikro-185">MIKRO 185</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MIKRO 185" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MIKRO 185" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8065/mikro-200-r">MIKRO 200 (R)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MIKRO 200 (R)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MIKRO 200 (R)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8066/eba-200-s">EBA 200 (S)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="EBA 200 (S)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="EBA 200 (S)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8067/mikro-220-r">MIKRO 220 (R)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MIKRO 220 (R)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MIKRO 220 (R)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8068/eba-280-s">EBA 280 (S)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="EBA 280 (S)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="EBA 280 (S)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8069/universal-320-r">UNIVERSAL 320 (R)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="UNIVERSAL 320 (R)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="UNIVERSAL 320 (R)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8070/rotina-380-r">ROTINA 380 (R)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTINA 380 (R)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTINA 380 (R)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8071/rotina-420-r">ROTINA 420 (R)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTINA 420 (R)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTINA 420 (R)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8072/rotanta-460-r-rf">ROTANTA 460 (R, RF)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTANTA 460 (R, RF)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTANTA 460 (R, RF)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8075/rotixa-500rs">ROTIXA 500RS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTIXA 500RS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTIXA 500RS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8073/roto-silenta-630rs">ROTO SILENTA 630RS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ROTO SILENTA 630RS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ROTO SILENTA 630RS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8074/miscellaneous">Miscellaneous</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hettich Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hettich Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8002/genesee-scientific-brand">Genesee Scientific Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Genesee Scientific Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Genesee Scientific Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8003/mini-centrifuges">Mini Centrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6838/microcentrifuges-non-refrigerated">Microcentrifuges Non Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microcentrifuges Non Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microcentrifuges Non Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6837/microcentrifuges-refrigerated">Microcentrifuges Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microcentrifuges Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microcentrifuges Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6839/benchtop-centrifuges-non-refrigerated">Benchtop Centrifuges Non Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchtop Centrifuges Non Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchtop Centrifuges Non Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6840/benchtop-centrifuges-refrigerated">Benchtop Centrifuges Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchtop Centrifuges Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchtop Centrifuges Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6841/benchtop-centrifuges-heated--and--refrigerated">Benchtop Centrifuges Heated &amp; Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchtop Centrifuges Heated &amp; Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchtop Centrifuges Heated &amp; Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6842/high-performance-centrifuges-non-refrigerated">High Performance Centrifuges Non Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Performance Centrifuges Non Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Performance Centrifuges Non Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6843/high-performance-centrifuges-refrigerated">High Performance Centrifuges Refrigerated</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Performance Centrifuges Refrigerated" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Performance Centrifuges Refrigerated" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6343/co2-regulators">CO2 Regulators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Regulators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Regulators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7648/density-determination-kits">Density Determination Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Density Determination Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Density Determination Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6114/electrophoresis">Electrophoresis</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6121/electroblotting-systems">Electroblotting Systems</a>

                			<div class="sub-menu">

        			<h3>Electroblotting Systems</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6122/semi-dry-electroblotters">Semi-Dry Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Dry Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Dry Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6123/tank-electroblotters">Tank Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tank Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tank Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroblotting Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroblotting Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6116/horizontal-gel-boxes">Horizontal Gel Boxes</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Boxes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6117/mini-horizontal-gel-boxes---small">Mini Horizontal Gel Boxes - Small</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal Gel Boxes - Small" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal Gel Boxes - Small" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6118/midi-horizontal-gel-boxes--medium">Midi Horizontal Gel Boxes- Medium</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal Gel Boxes- Medium" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal Gel Boxes- Medium" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6119/maxi-horizontal-gel-boxes--large">Maxi Horizontal Gel Boxes- Large</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maxi Horizontal Gel Boxes- Large" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maxi Horizontal Gel Boxes- Large" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6125/imaging-systems">Imaging Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Imaging Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Imaging Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6124/power-supplies">Power Supplies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Power Supplies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Power Supplies" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6115/real-time-horizontal-electrophoresis">Real Time Horizontal Electrophoresis</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real Time Horizontal Electrophoresis" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real Time Horizontal Electrophoresis" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6126/transilluminators">Transilluminators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transilluminators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transilluminators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6120/vertical-gel-boxes">Vertical Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vertical Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vertical Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6232/electroporators">Electroporators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroporators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroporators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6127/freezers">Freezers</a>

                			<div class="sub-menu">

        			<h3>Freezers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8013/-20c-freezers">-20C Freezers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="-20C Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="-20C Freezers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8014/-30c-freezers">-30C Freezers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="-30C Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="-30C Freezers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8027/-40c-freezers">-40C Freezers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="-40C Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="-40C Freezers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8015/-80c-freezers">-80C Freezers</a>

                			<div class="sub-menu">

        			<h3>-80C Freezers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8022/haier-twincool">Haier TwinCool</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Haier TwinCool" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Haier TwinCool" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8023/haier-smart-frequency">Haier Smart Frequency</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Haier Smart Frequency" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Haier Smart Frequency" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8024/haier-ultra-low">Haier Ultra Low</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Haier Ultra Low" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Haier Ultra Low" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8025/haier-water-cooled">Haier Water-Cooled</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Haier Water-Cooled" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Haier Water-Cooled" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="-80C Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="-80C Freezers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Freezers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6129/homogenizers">Homogenizers</a>

                			<div class="sub-menu">

        			<h3>Homogenizers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6130/tissue-homogenizer">Tissue Homogenizer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Homogenizer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Homogenizer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6131/tissue-homogenizer-beads">Tissue Homogenizer Beads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Homogenizer Beads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Homogenizer Beads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7762/ultrasonic-homogenizers">Ultrasonic Homogenizers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ultrasonic Homogenizers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ultrasonic Homogenizers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Homogenizers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Homogenizers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6128/hot-plates-and-stirrers">Hot Plates &amp; Stirrers</a>

                			<div class="sub-menu">

        			<h3>Hot Plates &amp; Stirrers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8004/magnetic-stirrers">Magnetic Stirrers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Magnetic Stirrers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Magnetic Stirrers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8005/hot-plates">Hot Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8006/hot-plate-stirrers">Hot Plate Stirrers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Plate Stirrers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Plate Stirrers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8007/stir-bars">Stir Bars</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stir Bars" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stir Bars" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8008/stir-bar-retrievers">Stir Bar Retrievers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stir Bar Retrievers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stir Bar Retrievers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Plates and Stirrers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Plates and Stirrers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6132/incubators">Incubators</a>

                			<div class="sub-menu">

        			<h3>Incubators</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6141/co2-incubators">CO2 Incubators</a>

                			<div class="sub-menu">

        			<h3>CO2 Incubators</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6142/general-co2-incubators">General CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6143/air-jacket-co2-incubators">Air Jacket CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Air Jacket CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Air Jacket CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6144/water-jacket-co2-incubators">Water Jacket CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Water Jacket CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Water Jacket CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6145/high-heat-decontamination-co2-incubators">High Heat Decontamination CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Heat Decontamination CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Heat Decontamination CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6133/drosophila-specific-incubators"><i>Drosophila</i> Specific Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Specific Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Specific Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6134/general-purpose-incubators">General Purpose Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General Purpose Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General Purpose Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6146/mini-incubators">Mini Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6147/refrigerated-incubators">Refrigerated Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Refrigerated Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Refrigerated Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6135/shaking-incubators">Shaking Incubators</a>

                			<div class="sub-menu">

        			<h3>Shaking Incubators</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6136/benchmark-shaking-incubators">Benchmark Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6137/benchmark-shaking-incubator-accessories">Benchmark Shaking Incubator Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Shaking Incubator Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Shaking Incubator Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8001/crystal-shaking-incubators">Crystal Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Crystal Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Crystal Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6138/shel-lab-shaking-incubators">Shel Lab Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shel Lab Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shel Lab Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6139/eppendorf-shaking-incubators">Eppendorf Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6140/labnet-shaking-incubators">Labnet Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6148/microscopes">Microscopes</a>

                			<div class="sub-menu">

        			<h3>Microscopes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6149/drosophila-microscopes"><i>Drosophila</i> Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6150/inverted-compound-microscopes">Inverted Compound Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Inverted Compound Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Inverted Compound Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6151/upright-compound-microscopes">Upright Compound Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Upright Compound Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Upright Compound Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6152/stereo-dissecting-microscopes">Stereo/Dissecting Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6153/light-source">Light Source</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Light Source" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Light Source" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6154/halocarbon-oil">Halocarbon Oil</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6155/slides">Slides</a>

                			<div class="sub-menu">

        			<h3>Slides</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6156/plain-slides-beveled">Plain Slides, Beveled</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6157/charged-slides">Charged Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Charged Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Charged Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6158/concavity-slides">Concavity Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6159/cover-glasses">Cover Glasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Slides" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8011/liquid-handling-systems">Liquid Handling Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Handling Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Handling Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8136/liquid-nitrogen-tanks">Liquid Nitrogen Tanks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Nitrogen Tanks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Nitrogen Tanks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6286/moisture-analyzers">Moisture Analyzers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Moisture Analyzers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Moisture Analyzers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6160/ovens">Ovens</a>

                			<div class="sub-menu">

        			<h3>Ovens</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6163/forced-air-ovens">Forced Air Ovens</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Forced Air Ovens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Forced Air Ovens" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6162/hybridization-ovens">Hybridization Ovens</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybridization Ovens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybridization Ovens" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6165/vacuum-ovens">Vacuum Ovens</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Ovens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Ovens" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6164/gravity-convection-ovens">Gravity Convection Ovens</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gravity Convection Ovens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gravity Convection Ovens" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8078/mechanical-convection-ovens">Mechanical Convection Ovens</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mechanical Convection Ovens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mechanical Convection Ovens" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ovens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ovens" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6375/pipettors--and--accessories">Pipettors &amp; Accessories</a>

                			<div class="sub-menu">

        			<h3>Pipettors &amp; Accessories</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7172/single-channel-pipettors">Single Channel Pipettors</a>

                			<div class="sub-menu">

        			<h3>Single Channel Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6486/eppendorf-reference-2-single-channel">Eppendorf Reference 2 Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Reference 2 Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Reference 2 Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6493/eppendorf-research-plus-single-channel">Eppendorf Research Plus Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6503/gilson-pipetman-classic-single-channel">Gilson PIPETMAN Classic Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Classic Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Classic Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6527/gilson-pipetman-g-single-channel">Gilson PIPETMAN G Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN G Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN G Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6513/gilson-pipetman-l-single-channel">Gilson PIPETMAN L Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6533/labnet-biopette-single-channel">Labnet BioPette Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet BioPette Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet BioPette Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7598/mtc-propette-single-channel">MTC ProPette Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MTC ProPette Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MTC ProPette Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6480/poseidon-single-channel">Poseidon Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7908/mtc-halo-single-channel">MTC Halo Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MTC Halo Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MTC Halo Single Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7176/single-channel-pipettors-fixed-volume">Single Channel Pipettors, Fixed Volume</a>

                			<div class="sub-menu">

        			<h3>Single Channel Pipettors, Fixed Volume</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6487/eppendorf-reference-2-fixed-volume">Eppendorf Reference 2 Fixed Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Reference 2 Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Reference 2 Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6494/eppendorf-research-plus-fixed-volume">Eppendorf Research Plus Fixed Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6531/gilson-pipetman-f-fixed-volume">Gilson PIPETMAN F Fixed Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN F Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN F Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7207/labnet-labpette-fixed-volume">Labnet Labpette Fixed Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Labpette Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Labpette Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Pipettors, Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Pipettors, Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7900/4-channel-pipettors">4-Channel Pipettors</a>

                			<div class="sub-menu">

        			<h3>4-Channel Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7901/eppendorf-research-plus-move-it">Eppendorf Research Plus Move It</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus Move It" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus Move It" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4-Channel Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4-Channel Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7183/8-channel-pipettors">8-Channel Pipettors</a>

                			<div class="sub-menu">

        			<h3>8-Channel Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6488/eppendorf-reference-2-8-channel">Eppendorf Reference 2 8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Reference 2 8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Reference 2 8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6495/eppendorf-research-plus-8-channel">Eppendorf Research Plus 8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus 8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus 8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7599/gilson-pipetman-g-8-channel">Gilson PIPETMAN G 8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN G 8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN G 8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6515/gilson-pipetman-l-8-channel">Gilson PIPETMAN L 8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L 8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L 8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6534/labnet-biopette-8-channel">Labnet BioPette 8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet BioPette 8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet BioPette 8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6481/poseidon-8-channel">Poseidon 8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon 8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon 8-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Channel Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Channel Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7184/12-channel-pipettors">12-Channel Pipettors</a>

                			<div class="sub-menu">

        			<h3>12-Channel Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6489/eppendorf-reference-2-12-channel">Eppendorf Reference 2 12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Reference 2 12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Reference 2 12-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6496/eppendorf-research-plus-12-channel">Eppendorf Research Plus 12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus 12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus 12-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7600/gilson-pipetman-g-12-channel">Gilson PIPETMAN G 12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN G 12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN G 12-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6516/gilson-pipetman-l-12-channel">Gilson PIPETMAN L 12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L 12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L 12-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6535/labnet-biopette-12-channel">Labnet BioPette 12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet BioPette 12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet BioPette 12-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6482/poseidon-12-channel">Poseidon 12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon 12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon 12-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Channel Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Channel Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7719/16-channel-pipettors">16-Channel Pipettors</a>

                			<div class="sub-menu">

        			<h3>16-Channel Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7720/eppendorf-research-plus-16-channel">Eppendorf Research Plus 16-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus 16-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus 16-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="16-Channel Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="16-Channel Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7721/24-channel-pipettors">24-Channel Pipettors</a>

                			<div class="sub-menu">

        			<h3>24-Channel Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7722/eppendorf-research-plus-24-channel">Eppendorf Research Plus 24-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus 24-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus 24-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="24-Channel Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="24-Channel Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7902/adjustable-tip-spacing-pipettors">Adjustable Tip Spacing Pipettors</a>

                			<div class="sub-menu">

        			<h3>Adjustable Tip Spacing Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7903/4-channel-adjustable-tip-spacing-pipettors">4-Channel Adjustable Tip Spacing Pipettors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7904/6-channel-adjustable-tip-spacing-pipettors">6-Channel Adjustable Tip Spacing Pipettors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="6-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="6-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7905/8-channel-adjustable-tip-spacing-pipettors">8-Channel Adjustable Tip Spacing Pipettors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7906/12-channel-adjustable-tip-spacing-pipettors">12-Channel Adjustable Tip Spacing Pipettors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Channel Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Adjustable Tip Spacing Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7601/electronic-pipettors">Electronic Pipettors</a>

                			<div class="sub-menu">

        			<h3>Electronic Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7602/gilson-pipetman-m">Gilson PIPETMAN M</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN M" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN M" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7744/labnet-excel">Labnet Excel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Excel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Excel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electronic Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electronic Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7171/lts-tip-pipettors">LTS Tip Pipettors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="LTS Tip Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="LTS Tip Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7603/pipette-controllers">Pipette Controllers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipette Controllers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipette Controllers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6530/positive-displacement-pipettors">Positive Displacement Pipettors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Positive Displacement Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Positive Displacement Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7208/repeaters">Repeaters</a>

                			<div class="sub-menu">

        			<h3>Repeaters</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7209/eppendorf-repeater-m4">Eppendorf Repeater M4</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Repeater M4" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Repeater M4" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7211/eppendorf-repeater-m4-tips">Eppendorf Repeater M4 Tips</a>

                			<div class="sub-menu">

        			<h3>Eppendorf Repeater M4 Tips</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7216/eppendorf-quality-standard">Eppendorf Quality, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Quality, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Quality, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7217/pcr-clean-standard">PCR Clean, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Clean, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Clean, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7218/biopur-sterile">Biopur, Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biopur, Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biopur, Sterile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Repeater M4 Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Repeater M4 Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7224/eppendorf-repeater-e3-e3x">Eppendorf Repeater E3,E3x</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Repeater E3,E3x" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Repeater E3,E3x" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7225/eppendorf-repeater-e3-e3x-tips">Eppendorf Repeater E3,E3x Tips</a>

                			<div class="sub-menu">

        			<h3>Eppendorf Repeater E3,E3x Tips</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7226/eppendorf-quality-standard">Eppendorf Quality, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Quality, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Quality, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7227/pcr-clean-standard">PCR Clean, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Clean, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Clean, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7228/biopur-sterile">Biopur, Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biopur, Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biopur, Sterile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Repeater E3,E3x Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Repeater E3,E3x Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7220/brandtech-handystep">BrandTech HandyStep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="BrandTech HandyStep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="BrandTech HandyStep" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7221/brandtech-handystep-tips">BrandTech HandyStep Tips</a>

                			<div class="sub-menu">

        			<h3>BrandTech HandyStep Tips</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7222/olympus-repeater-tips-standard">Olympus Repeater Tips, Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Repeater Tips, Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Repeater Tips, Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7223/olympus-repeater-tips-sterile">Olympus Repeater Tips, Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Repeater Tips, Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Repeater Tips, Sterile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="BrandTech HandyStep Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="BrandTech HandyStep Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Repeaters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Repeaters" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7177/starter-kits">Starter Kits</a>

                			<div class="sub-menu">

        			<h3>Starter Kits</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7198/eppendorf--research-plus-starter-kit">Eppendorf  Research Plus Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf  Research Plus Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf  Research Plus Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7203/gilson-pipetman-classic-starter-kit">Gilson PIPETMAN Classic Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Classic Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Classic Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7201/gilson-pipetman-l-starter-kit">Gilson PIPETMAN L Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7202/gilson-pipetman-g-starter-kit">Gilson PIPETMAN G Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN G Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN G Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6699/poseidon-starter-kit">Poseidon Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7204/gilson-pipetman-neo-starter-kit">Gilson PIPETMAN Neo Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Neo Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Neo Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7200/labnet-biopette-plus-starter-kit">Labnet BioPette Plus Starter Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet BioPette Plus Starter Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet BioPette Plus Starter Kit" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Starter Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Starter Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7174/trade-in-program">Trade-In Program</a>

                			<div class="sub-menu">

        			<h3>Trade-In Program</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6484/poseidon-trade-in">Poseidon Trade-In</a>

                			<div class="sub-menu">

        			<h3>Poseidon Trade-In</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7229/single-channel">Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7230/8-channel">8-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7231/12-channel">12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6490/reference-2-trade-in">Reference 2 Trade-In</a>

                			<div class="sub-menu">

        			<h3>Reference 2 Trade-In</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7232/single-channel">Single Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7233/new-node">New node</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="New node" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="New node" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7234/12-channel">12-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reference 2 Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reference 2 Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6497/research-plus-trade-in">Research Plus Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Research Plus Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Research Plus Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6504/gilson-pipetman-classic-trade-in">Gilson PIPETMAN Classic Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Classic Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Classic Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6528/gilson-pipetman-g-trade-in">Gilson PIPETMAN G Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN G Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN G Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6510/gilson-pipetman-neo-trade-in">Gilson PIPETMAN Neo Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Neo Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Neo Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6517/gilson-pipetman-l-trade-in">Gilson PIPETMAN L Trade-In</a>

                			<div class="sub-menu">

        			<h3>Gilson PIPETMAN L Trade-In</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7185/gilson-pipetman-l-8ch-trade-in">Gilson PIPETMAN L 8Ch Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L 8Ch Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L 8Ch Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7186/gilson-pipetman-l-12ch-trade-in">Gilson PIPETMAN L 12Ch Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L 12Ch Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L 12Ch Trade-In" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L Trade-In" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trade-In Program" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trade-In Program" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7187/pipettor-accessories">Pipettor Accessories</a>

                			<div class="sub-menu">

        			<h3>Pipettor Accessories</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6483/poseidon-accessories">Poseidon Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6491/eppendorf-reference-2-accessories">Eppendorf Reference 2 Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Reference 2 Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Reference 2 Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6507/gilson-pipetman-classic-accessories">Gilson PIPETMAN Classic Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Classic Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Classic Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6518/gilson-pipetman-l-accessories">Gilson PIPETMAN L Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN L Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN L Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6536/labnet-biopette-accessories">Labnet BioPette Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet BioPette Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet BioPette Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6498/eppendorf-research-plus-accessories">Eppendorf Research Plus Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6529/gilson-pipetman-g-accessories">Gilson PIPETMAN G Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN G Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN G Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6511/gilson-pipetman-neo-accessories">Gilson PIPETMAN Neo Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson PIPETMAN Neo Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson PIPETMAN Neo Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6935/universal-pipettor-stands">Universal Pipettor Stands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Universal Pipettor Stands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Universal Pipettor Stands" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipettor Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipettor Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipettors &amp; Accessories" data-url="https://geneseesci.com/brands-poseidon/?utm_source=website&amp;utm_medium=bb&amp;utm_campaign=poseidon" data-img="https://geneseesci.com/wp-content/uploads/2020/06/poseidon.jpg"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipettors &amp; Accessories" data-url="https://geneseesci.com/genesee-brochure/?utm_source=website&amp;utm_medium=bbp&amp;utm_campaign=brochure" data-img="https://geneseesci.com/wp-content/uploads/2020/10/2020FallBrochure.jpg"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6287/ph-meters--and--accessories">pH Meters &amp; Accessories</a>

                			<div class="sub-menu">

        			<h3>pH Meters &amp; Accessories</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6288/ph-meters">pH Meters</a>

                			<div class="sub-menu">

        			<h3>pH Meters</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6367/ohaus-starter-series">OHAUS Starter Series</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="OHAUS Starter Series" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="OHAUS Starter Series" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="pH Meters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="pH Meters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6293/electrodes">Electrodes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrodes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrodes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6934/buffers--and--solutions">Buffers &amp; Solutions</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Buffers &amp; Solutions" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Buffers &amp; Solutions" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="pH Meters &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="pH Meters &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6941/plate-reader-and-washers">Plate Reader &amp; Washers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plate Reader and Washers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plate Reader and Washers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6220/pumps">Pumps</a>

                			<div class="sub-menu">

        			<h3>Pumps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6224/aspiration-stations">Aspiration Stations</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aspiration Stations" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aspiration Stations" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6221/vacuum-concentrators">Vacuum Concentrators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Concentrators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Concentrators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6222/vacuum-pumps">Vacuum Pumps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Pumps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pumps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6936/qpcr--and--pcr-machines">qPCR &amp; PCR Machines</a>

                			<div class="sub-menu">

        			<h3>qPCR &amp; PCR Machines</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6937/non-gradient">Non-Gradient</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Gradient" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Gradient" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6938/gradient">Gradient</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gradient" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gradient" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6939/qpcr">qPCR</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="qPCR" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="qPCR" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="qPCR &amp; PCR Machines" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="qPCR &amp; PCR Machines" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7157/rockers--and--shakers">Rockers &amp; Shakers</a>

                			<div class="sub-menu">

        			<h3>Rockers &amp; Shakers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6236/3d-rockers-ì-motion">3D Rockers (ì Motion)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3D Rockers (ì Motion)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3D Rockers (ì Motion)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6237/2d-rockers-seesaw-motion">2D Rockers (Seesaw Motion)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2D Rockers (Seesaw Motion)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2D Rockers (Seesaw Motion)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6238/linear-rockers--and--shakers-left-to-right">Linear Rockers &amp; Shakers (Left to Right)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Linear Rockers &amp; Shakers (Left to Right)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Linear Rockers &amp; Shakers (Left to Right)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6239/orbital-shakers-cirular-motion">Orbital Shakers (Cirular Motion)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Orbital Shakers (Cirular Motion)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Orbital Shakers (Cirular Motion)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6240/multitherm-shakers">MultiTherm Shakers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MultiTherm Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MultiTherm Shakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6242/tube-rollers--and--rotating-mixers">Tube Rollers &amp; Rotating Mixers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tube Rollers &amp; Rotating Mixers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tube Rollers &amp; Rotating Mixers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rockers &amp; Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rockers &amp; Shakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6231/sonicators">Sonicators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sonicators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sonicators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6230/spectrophotometers">Spectrophotometers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Spectrophotometers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Spectrophotometers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6233/sterilization-equipment">Sterilization Equipment</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sterilization Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sterilization Equipment" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6241/vortex-mixers">Vortex Mixers</a>

                			<div class="sub-menu">

        			<h3>Vortex Mixers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8118/benchmark-scientific-multitherm-touch">Benchmark Scientific MultiTherm Touch</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific MultiTherm Touch" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific MultiTherm Touch" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vortex Mixers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vortex Mixers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Equipment &amp; Apparatus" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Equipment &amp; Apparatus" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8137/sartorius">Sartorius</a>

                			<div class="sub-menu">

        			<h3>Sartorius</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8138/arium-water-purification-systems">Arium Water Purification Systems</a>

                			<div class="sub-menu">

        			<h3>Arium Water Purification Systems</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8139/arium-mini">Arium Mini</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Mini" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Mini" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8140/arium-advanced">Arium Advanced</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Advanced" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Advanced" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8141/arium-comfort">Arium Comfort</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Comfort" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Comfort" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8142/arium-comfort-i">Arium Comfort I</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Comfort I" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Comfort I" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8143/arium-comfort-ii">Arium Comfort II</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Comfort II" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Comfort II" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8144/arium-pro">Arium Pro</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Pro" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Pro" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8145/arium-bags--and--bagtank">Arium Bags &amp; Bagtank</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Bags &amp; Bagtank" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Bags &amp; Bagtank" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8146/arium-accessories">Arium Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Arium Water Purification Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Arium Water Purification Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8147/balances">Balances</a>

                			<div class="sub-menu">

        			<h3>Balances</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8148/entris-ii-essential-balances">Entris II Essential Balances</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Entris II Essential Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Entris II Essential Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8149/entris-ii-advanced-balances">Entris II Advanced Balances</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Entris II Advanced Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Entris II Advanced Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8150/practum-precision-balances">Practum Precision Balances</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Practum Precision Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Practum Precision Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8151/quintix-precision-balances">Quintix Precision Balances</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Quintix Precision Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Quintix Precision Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8152/secura-precision-balances">Secura Precision Balances</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Secura Precision Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Secura Precision Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8153/balance-accessories">Balance Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Balance Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Balance Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Balances" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Balances" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8154/proline-plus-pipettors">Proline Plus Pipettors</a>

                			<div class="sub-menu">

        			<h3>Proline Plus Pipettors</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8155/single-channel">Single-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8156/multi-channel">Multi-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8157/multi-packs">Multi-Packs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Packs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Packs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Proline Plus Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Proline Plus Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8158/tacta-pipettors">Tacta Pipettors</a>

                			<div class="sub-menu">

        			<h3>Tacta Pipettors</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8159/single-channel">Single-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8160/multi-channel">Multi-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8161/multi-packs">Multi-Packs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Packs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Packs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tacta Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tacta Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8162/mline-pipettors">mLINE Pipettors</a>

                			<div class="sub-menu">

        			<h3>mLINE Pipettors</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8163/single-channel">Single-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8164/multi-channel">Multi-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="mLINE Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="mLINE Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8165/picus-electronic-pipettors">Picus Electronic Pipettors</a>

                			<div class="sub-menu">

        			<h3>Picus Electronic Pipettors</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8166/single-channel">Single-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8167/multi-channel">Multi-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Picus Electronic Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Picus Electronic Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8168/picus-nxt-electronic-pipettors">Picus NxT Electronic Pipettors</a>

                			<div class="sub-menu">

        			<h3>Picus NxT Electronic Pipettors</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8169/single-channel">Single-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8170/multi-channel">Multi-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Picus NxT Electronic Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Picus NxT Electronic Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8171/optifit-pipet-tips">Optifit Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Optifit Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8172/filter-tips">Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8173/10ul-pipet-tips">10µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8174/20ul-pipet-tips">20µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="20µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="20µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8175/120ul-pipet-tips">120µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="120µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="120µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8176/200ul-pipet-tips">200µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8177/350ul-pipet-tips">350µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="350µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="350µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8178/1000ul-pipet-tips">1000µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8179/1200ul-pipet-tips">1200µl Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1200µl Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1200µl Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8180/5ml-pipet-tips">5ml Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5ml Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5ml Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8181/10ml-pipet-tips">10ml Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10ml Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10ml Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Optifit Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Optifit Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8182/bottle-top-dispensers">Bottle Top Dispensers</a>

                			<div class="sub-menu">

        			<h3>Bottle Top Dispensers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8183/dispensers">Dispensers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dispensers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8184/dispensing-heads">Dispensing Heads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dispensing Heads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dispensing Heads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8185/dispenser-accessories">Dispenser Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dispenser Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dispenser Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottle Top Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottle Top Dispensers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8186/moisture-analyzers">Moisture Analyzers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Moisture Analyzers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Moisture Analyzers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8187/ultrafiltration-devices">Ultrafiltration Devices</a>

                			<div class="sub-menu">

        			<h3>Ultrafiltration Devices</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8188/vivaspin-turbo-4">Vivaspin Turbo 4</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin Turbo 4" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin Turbo 4" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8189/vivaspin-turbo-15">Vivaspin Turbo 15</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin Turbo 15" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin Turbo 15" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8190/vivaspin-2">Vivaspin 2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin 2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin 2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8191/vivaspin-6">Vivaspin 6</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin 6" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin 6" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8192/vivaspin-15r">Vivaspin 15R</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin 15R" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin 15R" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8193/vivaspin-20">Vivaspin 20</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin 20" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin 20" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8194/vivaspin-500">Vivaspin 500</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaspin 500" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaspin 500" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8195/vivacell">Vivacell</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivacell" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivacell" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8196/vivaflow">Vivaflow</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivaflow" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivaflow" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8197/vivacon-2">Vivacon 2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivacon 2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivacon 2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8198/vivacon-500">Vivacon 500</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vivacon 500" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vivacon 500" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8199/specialty-vivaspin">Specialty Vivaspin</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Specialty Vivaspin" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Specialty Vivaspin" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ultrafiltration Devices" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ultrafiltration Devices" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8200/syringe-filters">Syringe Filters</a>

                			<div class="sub-menu">

        			<h3>Syringe Filters</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8201/minisart-pes-syringe-filters">Minisart PES Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart PES Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart PES Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8202/minisart-ptfe-syringe-filters">Minisart PTFE Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart PTFE Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart PTFE Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8203/minisart-srp-syringe-filters">Minisart SRP Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart SRP Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart SRP Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8204/minisart-ca-syringe-filters">Minisart CA Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart CA Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart CA Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8205/minisart-rc-syringe-filters">Minisart RC Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart RC Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart RC Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8206/minisart-ny-syringe-filters">Minisart NY Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart NY Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart NY Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8207/minisart-gf-syringe-filters">Minisart GF Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart GF Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart GF Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8208/minisart-nml-syringe-filters">Minisart NML Syringe Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Minisart NML Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Minisart NML Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8209/complete-filter-units">Complete Filter Units</a>

                			<div class="sub-menu">

        			<h3>Complete Filter Units</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8210/microsart-cn-units">Microsart CN Units</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microsart CN Units" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microsart CN Units" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8211/biosart-100-monitors">Biosart 100 Monitors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biosart 100 Monitors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biosart 100 Monitors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Complete Filter Units" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Complete Filter Units" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8212/membrane-filters">Membrane Filters</a>

                			<div class="sub-menu">

        			<h3>Membrane Filters</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8213/cn--and--ca-membrane-discs">CN &amp; CA Membrane Discs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CN &amp; CA Membrane Discs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CN &amp; CA Membrane Discs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8214/gelatin-filters">Gelatin Filters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gelatin Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gelatin Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8215/hydrosart-membrane-discs">Hydrosart Membrane Discs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hydrosart Membrane Discs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hydrosart Membrane Discs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8216/pes-membrane-discs">PES Membrane Discs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PES Membrane Discs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PES Membrane Discs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Membrane Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Membrane Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8217/microbiology">Microbiology</a>

                			<div class="sub-menu">

        			<h3>Microbiology</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8218/media">Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8219/nutrient-pad-sets">Nutrient Pad Sets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nutrient Pad Sets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nutrient Pad Sets" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microbiology" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microbiology" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sartorius" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sartorius" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5368/eppendorf">Eppendorf</a>

                			<div class="sub-menu">

        			<h3>Eppendorf</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6335/advantage-promotions">Advantage Promotions</a>

                			<div class="sub-menu">

        			<h3>Advantage Promotions</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8132/cellxpert">CellXpert</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CellXpert" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CellXpert" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8133/eppendorf-research-plus">Eppendorf Research Plus</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf Research Plus" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf Research Plus" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8134/mastercycler">Mastercycler</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mastercycler" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mastercycler" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8135/xplorer-plus-move-it">Xplorer plus Move It</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Xplorer plus Move It" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Xplorer plus Move It" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Advantage Promotions" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Advantage Promotions" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6319/consumables">Consumables</a>

                			<div class="sub-menu">

        			<h3>Consumables</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5420/centrifuge-tubes">Centrifuge Tubes</a>

                			<div class="sub-menu">

        			<h3>Centrifuge Tubes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5422/flex-tubes-1.5ml">Flex Tubes (1.5ml)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flex Tubes (1.5ml)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flex Tubes (1.5ml)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5423/safe-lock-tubes-0.5ml">Safe Lock Tubes (0.5ml)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Safe Lock Tubes (0.5ml)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Safe Lock Tubes (0.5ml)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5424/safe-lock-tubes-1.5ml">Safe Lock Tubes (1.5ml)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Safe Lock Tubes (1.5ml)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Safe Lock Tubes (1.5ml)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5425/safe-lock-tubes-2ml">Safe Lock Tubes (2ml)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Safe Lock Tubes (2ml)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Safe Lock Tubes (2ml)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5426/dna-lobind-tubes">DNA LoBind Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA LoBind Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA LoBind Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5427/protein-lobind-tubes">Protein LoBind Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein LoBind Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein LoBind Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5428/5ml-tubes">5ml Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5ml Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5ml Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7685/15ml-tubes">15ml Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7686/25ml-tubes">25ml Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25ml Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25ml Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7687/50ml-tubes">50ml Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7715/pcr-tubes-and-strips">PCR Tubes &amp; Strips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Tubes and Strips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Tubes and Strips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6329/combitips-advanced">CombiTips Advanced</a>

                			<div class="sub-menu">

        			<h3>CombiTips Advanced</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6330/standard">Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6331/sterile">Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sterile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6332/pcr-clean">PCR Clean</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Clean" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Clean" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6333/accessories">Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CombiTips Advanced" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CombiTips Advanced" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7689/pipette-tips">Pipette Tips</a>

                			<div class="sub-menu">

        			<h3>Pipette Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6327/ep-dualfilter-t.i.p.s.">ep Dualfilter T.I.P.S.</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ep Dualfilter T.I.P.S." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ep Dualfilter T.I.P.S." data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6320/ept.i.p.s.">epT.I.P.S.</a>

                			<div class="sub-menu">

        			<h3>epT.I.P.S.</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6321/single">Single</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6322/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6323/racked">Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6324/ept.i.p.s.-box">epT.I.P.S. Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="epT.I.P.S. Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="epT.I.P.S. Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6325/reloads">Reloads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reloads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reloads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6326/starter-sets">Starter Sets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Starter Sets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Starter Sets" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="epT.I.P.S." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="epT.I.P.S." data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipette Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipette Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5434/pcr-plates">PCR Plates</a>

                			<div class="sub-menu">

        			<h3>PCR Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5435/twin.tec-96-well-plates-skirted">twin.tec 96 Well Plates, Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="twin.tec 96 Well Plates, Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="twin.tec 96 Well Plates, Skirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5436/twin.tec-96-well-plates-semi-skirted">twin.tec 96 Well Plates, Semi-Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="twin.tec 96 Well Plates, Semi-Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="twin.tec 96 Well Plates, Semi-Skirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5437/twin.tec-96-well-plates-unskirted">twin.tec 96 Well Plates, Unskirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="twin.tec 96 Well Plates, Unskirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="twin.tec 96 Well Plates, Unskirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5438/twin.tec-96-well-plates-divisible">twin.tec 96 Well Plates, Divisible</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="twin.tec 96 Well Plates, Divisible" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="twin.tec 96 Well Plates, Divisible" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5439/twin.tec-384-well-plates">twin.tec 384 Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="twin.tec 384 Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="twin.tec 384 Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5440/twin.tec-real-time-plates">twin.tec Real-Time Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="twin.tec Real-Time Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="twin.tec Real-Time Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5441/real-time-pcr-tubes">Real Time PCR Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real Time PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real Time PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Consumables" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Consumables" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5447/electroporators">Electroporators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroporators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroporators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5384/liquid-handling">Liquid Handling</a>

                			<div class="sub-menu">

        			<h3>Liquid Handling</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5421/bottle-top-dispensers">Bottle Top Dispensers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottle Top Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottle Top Dispensers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5673/easypet-3-pipet-controller">Easypet 3 Pipet Controller</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Easypet 3 Pipet Controller" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Easypet 3 Pipet Controller" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5400/research-plus-pipettors">Research Plus Pipettors</a>

                			<div class="sub-menu">

        			<h3>Research Plus Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5401/single-channel-adjustable-volume">Single Channel Adjustable Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Adjustable Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Adjustable Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5402/single-channel-fixed-volume">Single Channel Fixed Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5404/multi-channel-adjustable-volume">Multi Channel Adjustable Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi Channel Adjustable Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi Channel Adjustable Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7666/research-plus-pipette-packs">Research Plus Pipette Packs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Research Plus Pipette Packs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Research Plus Pipette Packs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5403/trade-in">Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trade-In" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Research Plus Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Research Plus Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5406/reference-2-pipettors">Reference 2 Pipettors</a>

                			<div class="sub-menu">

        			<h3>Reference 2 Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5407/single-channel-adjustable-volume">Single Channel Adjustable Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Adjustable Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Adjustable Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5408/single-channel-fixed-volume">Single Channel Fixed Volume</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Fixed Volume" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Fixed Volume" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5409/trade-in">Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trade-In" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Reference 2 Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Reference 2 Pipettors" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5416/repeating-dispensers--and--combitips">Repeating Dispensers &amp; Combitips</a>

                			<div class="sub-menu">

        			<h3>Repeating Dispensers &amp; Combitips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5418/repeater-stream--and--xstream">Repeater stream &amp; Xstream</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Repeater stream &amp; Xstream" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Repeater stream &amp; Xstream" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5419/combitips-advanced">Combitips advanced</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Combitips advanced" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Combitips advanced" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5417/repeater-m4">Repeater M4</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Repeater M4" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Repeater M4" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Repeating Dispensers &amp; Combitips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Repeating Dispensers &amp; Combitips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5410/xplorer--and--xplorer-plus-electronic-pipettors">Xplorer &amp; Xplorer Plus Electronic Pipettors</a>

                			<div class="sub-menu">

        			<h3>Xplorer &amp; Xplorer Plus Electronic Pipettors</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5411/single-channel-">Single Channel </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5412/single-channel-trade-in">Single Channel Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single Channel Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single Channel Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5413/multi-channel">Multi-Channel</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5414/multi-channel-trade-in">Multi-Channel Trade-In</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multi-Channel Trade-In" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multi-Channel Trade-In" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5415/xplorer--and--xplorer-plus-accessories">Xplorer &amp; Xplorer Plus Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Xplorer &amp; Xplorer Plus Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Xplorer &amp; Xplorer Plus Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Xplorer &amp; Xplorer Plus Electronic Pipettors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Xplorer &amp; Xplorer Plus Electronic Pipettors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Handling" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Handling" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5382/multipurpose-centrifuges">Multipurpose Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Multipurpose Centrifuges</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7701/minispin-centrifuge">MiniSpin Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MiniSpin Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MiniSpin Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7702/5418r-centrifuge">5418R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5418R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5418R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7703/5420-centrifuge">5420 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5420 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5420 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7704/5424r-centrifuge">5424R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5424R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5424R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7705/5425-centrifuge">5425 Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5425 Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5425 Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7765/5425r-centrifuge">5425R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5425R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5425R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7706/5427r-centrifuge">5427R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5427R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5427R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7707/5430--and--5430r-centrifuge">5430 &amp; 5430R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5430 &amp; 5430R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5430 &amp; 5430R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7708/5702--and--5702r-centrifuge">5702 &amp; 5702R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5702 &amp; 5702R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5702 &amp; 5702R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7709/5804--and--5804r-centrifuge">5804 &amp; 5804R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5804 &amp; 5804R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5804 &amp; 5804R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7710/5810--and--5810r-centrifuge">5810 &amp; 5810R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5810 &amp; 5810R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5810 &amp; 5810R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7711/5910r-centrifuge">5910R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5910R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5910R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7713/5920r-centrifuge">5920R Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5920R Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5920R Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7712/vacufuge-plus">Vacufuge Plus</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacufuge Plus" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacufuge Plus" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multipurpose Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multipurpose Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5385/mixers--and--temperature-control">Mixers &amp; Temperature Control</a>

                			<div class="sub-menu">

        			<h3>Mixers &amp; Temperature Control</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5442/themomixer-c">ThemoMixer C</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ThemoMixer C" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ThemoMixer C" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5443/thermostat-c">ThermoStat C</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ThermoStat C" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ThermoStat C" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5444/thermomixer-f1.5">ThermoMixer F1.5</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ThermoMixer F1.5" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ThermoMixer F1.5" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5445/thermomixer-fp">ThermoMixer FP</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ThermoMixer FP" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ThermoMixer FP" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mixers &amp; Temperature Control" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mixers &amp; Temperature Control" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5466/new-brunswick-freezers">New Brunswick Freezers</a>

                			<div class="sub-menu">

        			<h3>New Brunswick Freezers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5467/chest-freezers">Chest Freezers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Chest Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Chest Freezers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5468/upright-freezers">Upright Freezers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Upright Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Upright Freezers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="New Brunswick Freezers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="New Brunswick Freezers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5470/new-brunswick-incubators">New Brunswick Incubators</a>

                			<div class="sub-menu">

        			<h3>New Brunswick Incubators</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5471/shaking-incubators">Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5472/co2-incubators">CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="New Brunswick Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="New Brunswick Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5473/new-brunswick-shakers">New Brunswick Shakers</a>

                			<div class="sub-menu">

        			<h3>New Brunswick Shakers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5474/innova-shakers">Innova Shakers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Innova Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Innova Shakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5475/excella-shakers">Excella Shakers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Excella Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Excella Shakers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="New Brunswick Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="New Brunswick Shakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5429/pcr">PCR</a>

                			<div class="sub-menu">

        			<h3>PCR</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5430/thermal-cyclers">Thermal Cyclers</a>

                			<div class="sub-menu">

        			<h3>Thermal Cyclers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5431/mastercycler-nexus">Mastercycler Nexus</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mastercycler Nexus" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mastercycler Nexus" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5432/mastercycler-nexus-x2">Mastercycler Nexus X2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mastercycler Nexus X2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mastercycler Nexus X2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7714/mastercycler-x50">Mastercycler X50</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mastercycler X50" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mastercycler X50" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Cyclers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Cyclers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Eppendorf" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Eppendorf" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1513/storage-racks--and--boxes">Storage Racks &amp; Boxes</a>

                			<div class="sub-menu">

        			<h3>Storage Racks &amp; Boxes</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6272/storage-racks-cryovial">Storage Racks, Cryovial</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Storage Racks, Cryovial" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Storage Racks, Cryovial" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1764/storage-racks-microtube">Storage Racks, Microtube</a>

                			<div class="sub-menu">

        			<h3>Storage Racks, Microtube</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4847/4-way-versatile-flipper-racks">4-Way Versatile Flipper Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4-Way Versatile Flipper Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4-Way Versatile Flipper Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4843/32-well-reversible-racks">32-Well Reversible Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="32-Well Reversible Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="32-Well Reversible Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4844/64-well-reversible-racks">64-Well Reversible Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="64-Well Reversible Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="64-Well Reversible Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4845/80-well-one-sided-racks">80-Well One-Sided Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="80-Well One-Sided Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="80-Well One-Sided Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4846/96-well-reversible-racks">96-Well Reversible Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Reversible Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Reversible Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7060/floating-tube-racks">Floating Tube Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Floating Tube Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Floating Tube Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1766/pcr-work-station-racks-">PCR Work Station Racks </a>

                			<div class="sub-menu">

        			<h3>PCR Work Station Racks </h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8010/coolcaddy-pcr-workstation">CoolCaddy PCR Workstation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CoolCaddy PCR Workstation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CoolCaddy PCR Workstation" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Work Station Racks " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Work Station Racks " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Storage Racks, Microtube" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Storage Racks, Microtube" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7059/storage-racks-15--and--50ml">Storage Racks, 15 &amp; 50ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Storage Racks, 15 &amp; 50ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Storage Racks, 15 &amp; 50ml" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7810/test-tube-racks">Test Tube Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tube Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tube Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6303/transporter-and-carriers">Transporter &amp; Carriers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transporter and Carriers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transporter and Carriers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5752/ice-pans--and--ice-buckets">Ice Pans &amp; Ice Buckets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ice Pans &amp; Ice Buckets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ice Pans &amp; Ice Buckets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8026/liquid-nitrogen-containers">Liquid Nitrogen Containers</a>

                			<div class="sub-menu">

        			<h3>Liquid Nitrogen Containers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8028/liquid-nitrogen-storage-tanks">Liquid Nitrogen Storage Tanks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Nitrogen Storage Tanks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Nitrogen Storage Tanks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8029/liquid-nitrogen-transport-tanks">Liquid Nitrogen Transport Tanks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Nitrogen Transport Tanks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Nitrogen Transport Tanks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Nitrogen Containers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Nitrogen Containers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1754/stainless-steel-freezer-racks">Stainless Steel Freezer Racks</a>

                			<div class="sub-menu">

        			<h3>Stainless Steel Freezer Racks</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6543/bin-style-organizers">Bin Style Organizers</a>

                			<div class="sub-menu">

        			<h3>Bin Style Organizers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6545/standard">Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6544/drawer-style">Drawer Style</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drawer Style" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drawer Style" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bin Style Organizers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bin Style Organizers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1755/horizontal-drawer-style-">Horizontal Drawer Style </a>

                			<div class="sub-menu">

        			<h3>Horizontal Drawer Style </h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1756/for-15--and--50ml-tubes-">For 15 &amp; 50ml Tubes </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 15 &amp; 50ml Tubes " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 15 &amp; 50ml Tubes " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1757/for-storage-bottles-">For Storage Bottles </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For Storage Bottles " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For Storage Bottles " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4830/for-2-inch-high-boxes">For 2-inch High Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 2-inch High Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 2-inch High Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4831/for-3-inch-high-boxes">For 3-inch High Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 3-inch High Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 3-inch High Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Drawer Style " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Drawer Style " data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4832/horizontal-side-loaded">Horizontal Side-Loaded</a>

                			<div class="sub-menu">

        			<h3>Horizontal Side-Loaded</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5197/for-mixed-storage-of-2--and--3-in.-boxes">For Mixed Storage of 2 &amp; 3 in. Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For Mixed Storage of 2 &amp; 3 in. Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For Mixed Storage of 2 &amp; 3 in. Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4833/for-15--and--50ml-tube-boxes">For 15 &amp; 50ml Tube Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 15 &amp; 50ml Tube Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 15 &amp; 50ml Tube Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4834/for-2-inch-high-boxes">For 2-inch High Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 2-inch High Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 2-inch High Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4835/for-3-inch-high-boxes">For 3-inch High Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 3-inch High Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 3-inch High Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4836/for-100-cell-hinged-boxes">For 100-Cell Hinged Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 100-Cell Hinged Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 100-Cell Hinged Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4837/for-96-well-plates">For 96-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4838/for-slide-boxes">For Slide Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For Slide Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For Slide Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Side-Loaded" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Side-Loaded" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7899/sliding-tray-style">Sliding Tray Style</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sliding Tray Style" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sliding Tray Style" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1761/vertical-for-chests--and--tanks-">Vertical for Chests &amp; Tanks </a>

                			<div class="sub-menu">

        			<h3>Vertical for Chests &amp; Tanks </h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1762/for-15--and--50ml-tube-boxes">For 15 &amp; 50ml Tube Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 15 &amp; 50ml Tube Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 15 &amp; 50ml Tube Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4839/for-2-inch-high-boxes">For 2-inch High Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 2-inch High Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 2-inch High Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4840/for-3-inch-high-boxes">For 3-inch High Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 3-inch High Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 3-inch High Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4841/for-100-cell-hinged-boxes">For 100-Cell Hinged Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 100-Cell Hinged Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 100-Cell Hinged Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4842/for-96-well-plates">For 96-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vertical for Chests &amp; Tanks " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vertical for Chests &amp; Tanks " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stainless Steel Freezer Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stainless Steel Freezer Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6928/steel-dewar-flasks">Steel Dewar Flasks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Steel Dewar Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Steel Dewar Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1770/tube-storage-boxes-w--lids">Tube Storage Boxes w/ Lids</a>

                			<div class="sub-menu">

        			<h3>Tube Storage Boxes w/ Lids</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7164/fiberboard-boxes--80°c">Fiberboard Boxes (-80°C)</a>

                			<div class="sub-menu">

        			<h3>Fiberboard Boxes (-80°C)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7165/81-place-storage-boxes">81-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7167/100-place-storage-boxes">100-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fiberboard Boxes (-80°C)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fiberboard Boxes (-80°C)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7168/hinged-cardboard-boxes--80°c">Hinged Cardboard Boxes (-80°C)</a>

                			<div class="sub-menu">

        			<h3>Hinged Cardboard Boxes (-80°C)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7169/81-place-storage-boxes">81-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7170/100-place-storage-boxes">100-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hinged Cardboard Boxes (-80°C)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hinged Cardboard Boxes (-80°C)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1772/cardboard-boxes--w--dividers">Cardboard Boxes  w/ Dividers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cardboard Boxes  w/ Dividers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cardboard Boxes  w/ Dividers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1776/microscope-slide-boxes">Microscope Slide Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slide Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slide Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4848/polypropylene-boxes--80°c">Polypropylene Boxes (-80°C)</a>

                			<div class="sub-menu">

        			<h3>Polypropylene Boxes (-80°C)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4851/50-place-storage-boxes">50-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4852/81-place-storage-boxes">81-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4853/100-place-storage-boxes">100-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4854/for-15--and--50ml-tubes">For 15 &amp; 50ml Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For 15 &amp; 50ml Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For 15 &amp; 50ml Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene Boxes (-80°C)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene Boxes (-80°C)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4849/polycarbonate-boxes--196°c">Polycarbonate Boxes (-196°C)</a>

                			<div class="sub-menu">

        			<h3>Polycarbonate Boxes (-196°C)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6870/25-place-storage-boxes">25-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4857/81-place-storage-boxes">81-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="81-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4858/100-place-storage-boxes">100-Place Storage Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Place Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polycarbonate Boxes (-196°C)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polycarbonate Boxes (-196°C)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4850/styrofoam-boxes">Styrofoam Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Styrofoam Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Styrofoam Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tube Storage Boxes w/ Lids" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tube Storage Boxes w/ Lids" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1777/personal-tube-chillers">Personal Tube Chillers</a>

                			<div class="sub-menu">

        			<h3>Personal Tube Chillers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5756/coolracks-">CoolRacks </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CoolRacks " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CoolRacks " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1779/isofreeze-racks">IsoFreeze Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="IsoFreeze Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="IsoFreeze Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1780/biocoolers">BioCoolers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="BioCoolers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="BioCoolers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5002/coolsafe-system--and--racks">CoolSafe System &amp; Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CoolSafe System &amp; Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CoolSafe System &amp; Racks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Personal Tube Chillers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Personal Tube Chillers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/1782/kimwipe--and--glove-box-dispensers-">Kimwipe &amp; Glove Box Dispensers </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Kimwipe &amp; Glove Box Dispensers " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Kimwipe &amp; Glove Box Dispensers " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5004/wash-n-dry-coverslip-rack">Wash-N-Dry Coverslip Rack</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wash-N-Dry Coverslip Rack" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wash-N-Dry Coverslip Rack" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Storage Racks &amp; Boxes" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Storage Racks &amp; Boxes" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/1514/labels--and--identification-tags">Labels &amp; Identification Tags</a>

                			<div class="sub-menu">

        			<h3>Labels &amp; Identification Tags</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5719/labeling-tape">Labeling Tape</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labeling Tape" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labeling Tape" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4571/pcr-tube-labels">PCR Tube Labels</a>

                			<div class="sub-menu">

        			<h3>PCR Tube Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4572/tough-spots--196ºc">Tough-Spots (-196ºC)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Spots (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Spots (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4573/tough-tags--40ºc">Tough-Tags (-40ºC)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Tube Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Tube Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4574/0.5---0.6ml-tube-labels">0.5 / 0.6ml Tube Labels</a>

                			<div class="sub-menu">

        			<h3>0.5 / 0.6ml Tube Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4575/tough-spots--196ºc">Tough-Spots (-196ºC)</a>

                			<div class="sub-menu">

        			<h3>Tough-Spots (-196ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4576/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4577/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Spots (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Spots (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4578/tough-tags--40ºc">Tough-Tags (-40ºC)</a>

                			<div class="sub-menu">

        			<h3>Tough-Tags (-40ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4579/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4580/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4581/cryo-tags--196ºc">Cryo-Tags (-196ºC)</a>

                			<div class="sub-menu">

        			<h3>Cryo-Tags (-196ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4582/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4583/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4584/thermal-transfer">Thermal Transfer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.5 / 0.6ml Tube Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.5 / 0.6ml Tube Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4585/1.5---2.0ml-tube-labels">1.5 / 2.0ml Tube Labels</a>

                			<div class="sub-menu">

        			<h3>1.5 / 2.0ml Tube Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4586/tough-spots--196ºc">Tough-Spots (-196ºC)</a>

                			<div class="sub-menu">

        			<h3>Tough-Spots (-196ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4587/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4588/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Spots (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Spots (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4589/tough-tags--40ºc">Tough-Tags (-40ºC)</a>

                			<div class="sub-menu">

        			<h3>Tough-Tags (-40ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4590/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4591/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4592/cryo-tags--196ºc">Cryo-Tags (-196ºC)</a>

                			<div class="sub-menu">

        			<h3>Cryo-Tags (-196ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4593/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4594/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4595/thermal-transfer">Thermal Transfer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1.5 / 2.0ml Tube Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1.5 / 2.0ml Tube Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4596/cryovial-labels">Cryovial Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryovial Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryovial Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4597/general-purpose-labels">General Purpose Labels</a>

                			<div class="sub-menu">

        			<h3>General Purpose Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4598/tough-tags--40ºc">Tough-Tags (-40ºC)</a>

                			<div class="sub-menu">

        			<h3>Tough-Tags (-40ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4599/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4600/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4601/cryo-tags--196ºc">Cryo-Tags (-196ºC)</a>

                			<div class="sub-menu">

        			<h3>Cryo-Tags (-196ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4602/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4603/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4604/thermal-transfer">Thermal Transfer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General Purpose Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General Purpose Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4605/15---50ml-tube-labels">15 / 50ml Tube Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15 / 50ml Tube Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15 / 50ml Tube Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4606/microplate-labels">Microplate Labels</a>

                			<div class="sub-menu">

        			<h3>Microplate Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4607/tough-tags--40ºc">Tough-Tags (-40ºC)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tough-Tags (-40ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4608/cryo-tags--196ºc">Cryo-Tags (-196ºC)</a>

                			<div class="sub-menu">

        			<h3>Cryo-Tags (-196ºC)</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4609/on-sheets">On Sheets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Sheets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Sheets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4610/on-rolls">On Rolls</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="On Rolls" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="On Rolls" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cryo-Tags (-196ºC)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4611/thermal-transfer">Thermal Transfer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Transfer" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microplate Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microplate Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4612/rack--and--box-labels">Rack &amp; Box Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rack &amp; Box Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rack &amp; Box Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4613/microscope-slide-labels">Microscope Slide Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slide Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slide Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4614/thermal-transfer-labels">Thermal Transfer Labels</a>

                			<div class="sub-menu">

        			<h3>Thermal Transfer Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4615/thermal-transfer-labels">Thermal Transfer Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Transfer Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Transfer Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4616/direct-thermal-transfer-labels">Direct Thermal Transfer Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Direct Thermal Transfer Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Direct Thermal Transfer Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4617/printers--and--accessories">Printers &amp; Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Printers &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Printers &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Transfer Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Transfer Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4618/specialty-labels">Specialty Labels</a>

                			<div class="sub-menu">

        			<h3>Specialty Labels</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4619/warning-labels">Warning Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Warning Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Warning Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4620/wash-off-labels">Wash-Off Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wash-Off Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wash-Off Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4621/clear-labels">Clear Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4622/cut-to-size-labels">Cut-to-Size Labels</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cut-to-Size Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cut-to-Size Labels" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Specialty Labels" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Specialty Labels" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4623/writers--and--pens">Writers &amp; Pens</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Writers &amp; Pens" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Writers &amp; Pens" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4624/printers--and--accessories">Printers &amp; Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Printers &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Printers &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labels &amp; Identification Tags" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labels &amp; Identification Tags" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/170/convenience-items">Convenience Items</a>

                			<div class="sub-menu">

        			<h3>Convenience Items</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/171/adhesives">Adhesives</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Adhesives" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Adhesives" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/173/aluminum-foil-plastic-wrap">Aluminum Foil, Plastic Wrap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aluminum Foil, Plastic Wrap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aluminum Foil, Plastic Wrap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/174/batteries">Batteries</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Batteries" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Batteries" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/175/cleaning-agents">Cleaning Agents</a>

                			<div class="sub-menu">

        			<h3>Cleaning Agents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/176/soap--and--hand-lotion">Soap &amp; Hand Lotion</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soap &amp; Hand Lotion" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soap &amp; Hand Lotion" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/177/surface-decontaminants">Surface Decontaminants</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/178/wipes">Wipes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wipes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wipes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cleaning Agents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cleaning Agents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/179/dry-milk">Dry Milk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dry Milk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dry Milk" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7738/hand-sanitizer">Hand Sanitizer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hand Sanitizer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hand Sanitizer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/183/nail-polish">Nail Polish</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nail Polish" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nail Polish" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6276/ph-indicator-papers">pH Indicator Papers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="pH Indicator Papers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="pH Indicator Papers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/181/razor-blades">Razor Blades</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Razor Blades" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Razor Blades" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/182/rubber-bands">Rubber Bands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/167/soap--and--hand-lotion">Soap &amp; Hand Lotion</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soap &amp; Hand Lotion" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soap &amp; Hand Lotion" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/180/toothpicks">Toothpicks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Toothpicks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Toothpicks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Convenience Items" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Convenience Items" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/140/general-lab-supplies">General Lab Supplies</a>

                			<div class="sub-menu">

        			<h3>General Lab Supplies</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/141/autoclave-containers">Autoclave Containers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Autoclave Containers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Autoclave Containers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/142/autoclave-tape">Autoclave Tape</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Autoclave Tape" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Autoclave Tape" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/143/autoradiography-film">Autoradiography Film</a>

                			<div class="sub-menu">

        			<h3>Autoradiography Film</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5893/blue-devil-lite-film">Blue Devil Lite Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil Lite Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil Lite Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6300/blue-devil-west">Blue Devil West</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil West" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil West" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/144/blue-devil-film">Blue Devil Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4874/blue-devil-premium-film">Blue Devil Premium Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil Premium Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil Premium Film" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Autoradiography Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Autoradiography Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/147/batteries">Batteries</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Batteries" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Batteries" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/148/biohazard-autoclave-bags">Biohazard Autoclave Bags</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biohazard Autoclave Bags" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biohazard Autoclave Bags" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5151/carboys">Carboys</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Carboys" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Carboys" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/149/cuvettes">Cuvettes</a>

                			<div class="sub-menu">

        			<h3>Cuvettes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5803/uv-cuvettes">UV-Cuvettes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="UV-Cuvettes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="UV-Cuvettes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/150/spectrophotometry">Spectrophotometry</a>

                			<div class="sub-menu">

        			<h3>Spectrophotometry</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6847/polystyrene-ps">Polystyrene (PS)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6848/pmma">PMMA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PMMA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PMMA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Spectrophotometry" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Spectrophotometry" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/151/electroporation">Electroporation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroporation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroporation" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cuvettes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cuvettes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/163/film-foil-wrap">Film, Foil, Wrap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Film, Foil, Wrap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Film, Foil, Wrap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7737/hand-sanitizer">Hand Sanitizer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hand Sanitizer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hand Sanitizer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5152/heavy-duty-vacuum-bottles">Heavy Duty Vacuum Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Heavy Duty Vacuum Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Heavy Duty Vacuum Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/8122/hybex-glass-bottles--and--flasks">Hybex™ Glass Bottles &amp; Flasks</a>

                			<div class="sub-menu">

        			<h3>Hybex™ Glass Bottles &amp; Flasks</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8123/hybex-erlenmeyer-flasks">Hybex™ Erlenmeyer Flasks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Erlenmeyer Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Erlenmeyer Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8124/hybex-erlenmeyer-flasks-w--gl45-cap">Hybex™ Erlenmeyer Flasks w/ GL45 Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Erlenmeyer Flasks w/ GL45 Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Erlenmeyer Flasks w/ GL45 Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/8125/hybex-media-storage-bottles-">Hybex™ Media Storage Bottles </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Media Storage Bottles " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Media Storage Bottles " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hybex™ Glass Bottles &amp; Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hybex™ Glass Bottles &amp; Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7114/lab-clamps">Lab Clamps</a>

                			<div class="sub-menu">

        			<h3>Lab Clamps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7115/2-prong-lab-clamp">2 Prong Lab Clamp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2 Prong Lab Clamp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2 Prong Lab Clamp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7116/3-prong-lab-clamp">3 Prong Lab Clamp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3 Prong Lab Clamp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3 Prong Lab Clamp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7117/4-prong-lab-clamp">4 Prong Lab Clamp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4 Prong Lab Clamp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4 Prong Lab Clamp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7118/starter-set-lab-clamp">Starter Set Lab Clamp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Starter Set Lab Clamp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Starter Set Lab Clamp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7119/boss-heads">Boss Heads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Boss Heads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Boss Heads" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lab Clamps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lab Clamps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7120/lab-jacks">Lab Jacks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lab Jacks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lab Jacks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4982/lab-markers">Lab Markers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lab Markers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lab Markers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/152/lab-wipes">Lab Wipes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lab Wipes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lab Wipes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5715/labeling-tape">Labeling Tape</a>

                			<div class="sub-menu">

        			<h3>Labeling Tape</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5720/3-4-inch">3/4 inch</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3/4 inch" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3/4 inch" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5721/1-2-inch">1/2 inch</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1/2 inch" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1/2 inch" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5722/1-inch">1 inch</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1 inch" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1 inch" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labeling Tape" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labeling Tape" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7088/measuring-glass">Measuring Glass</a>

                			<div class="sub-menu">

        			<h3>Measuring Glass</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7089/beakers">Beakers</a>

                			<div class="sub-menu">

        			<h3>Beakers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7090/glass-beaker">Glass Beaker</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass Beaker" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass Beaker" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7092/glass-beaker-astm">Glass Beaker, ASTM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass Beaker, ASTM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass Beaker, ASTM" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Beakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Beakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7095/burettes">Burettes</a>

                			<div class="sub-menu">

        			<h3>Burettes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7096/straight-bore-burette-glass-stopcock">Straight Bore Burette, Glass Stopcock</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Straight Bore Burette, Glass Stopcock" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Straight Bore Burette, Glass Stopcock" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7097/straight-bore-burette-ptfe-key-stopcock">Straight Bore Burette, PTFE Key Stopcock</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Straight Bore Burette, PTFE Key Stopcock" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Straight Bore Burette, PTFE Key Stopcock" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7098/heavy-duty-rubber-bulbs">Heavy Duty Rubber Bulbs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Heavy Duty Rubber Bulbs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Heavy Duty Rubber Bulbs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Burettes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Burettes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7099/cylinders">Cylinders</a>

                			<div class="sub-menu">

        			<h3>Cylinders</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7100/glass-cylinder">Glass Cylinder</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass Cylinder" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass Cylinder" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7101/glass-cylinder-astm">Glass Cylinder, ASTM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass Cylinder, ASTM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass Cylinder, ASTM" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cylinders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cylinders" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7105/flasks">Flasks</a>

                			<div class="sub-menu">

        			<h3>Flasks</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7107/filter-flask">Filter Flask</a>

                			<div class="sub-menu">

        			<h3>Filter Flask</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7106/erlenmeyer-flask">Erlenmeyer Flask</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Erlenmeyer Flask" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Erlenmeyer Flask" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filter Flask" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filter Flask" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7108/volumetric-flask-glass-stopper">Volumetric Flask, Glass Stopper</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Volumetric Flask, Glass Stopper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Volumetric Flask, Glass Stopper" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7121/media-bottles">Media Bottles</a>

                			<div class="sub-menu">

        			<h3>Media Bottles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7122/media-bottle-screw-cap">Media Bottle, Screw Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media Bottle, Screw Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media Bottle, Screw Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7123/amber-media-bottle-screw-cap">Amber Media Bottle, Screw Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Amber Media Bottle, Screw Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Amber Media Bottle, Screw Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7124/narrow-mouth-media-bottle-polypropylene-stopper">Narrow Mouth Media Bottle, Polypropylene Stopper</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Mouth Media Bottle, Polypropylene Stopper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Mouth Media Bottle, Polypropylene Stopper" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7125/wide-mouth-media-bottle-glass-stopper">Wide Mouth Media Bottle, Glass Stopper</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Mouth Media Bottle, Glass Stopper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Mouth Media Bottle, Glass Stopper" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7127/test-tubes">Test Tubes</a>

                			<div class="sub-menu">

        			<h3>Test Tubes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7128/test-tube-with-rim">Test Tube with Rim</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tube with Rim" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tube with Rim" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7130/test-tube-rubber-lined">Test Tube, Rubber Lined</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tube, Rubber Lined" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tube, Rubber Lined" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Measuring Glass" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Measuring Glass" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6256/measuring-plastics">Measuring Plastics</a>

                			<div class="sub-menu">

        			<h3>Measuring Plastics</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/6258/beakers">Beakers</a>

                			<div class="sub-menu">

        			<h3>Beakers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7093/polypropylene-beaker">Polypropylene Beaker</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene Beaker" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene Beaker" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7094/tpx-polymethylpentene-beaker">TPX Polymethylpentene Beaker</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TPX Polymethylpentene Beaker" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TPX Polymethylpentene Beaker" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Beakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Beakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7102/cylinders">Cylinders</a>

                			<div class="sub-menu">

        			<h3>Cylinders</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7103/polypropylene-cylinder">Polypropylene Cylinder</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene Cylinder" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene Cylinder" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7104/tpx-polymethylpentene-cylinder">TPX Polymethylpentene Cylinder</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TPX Polymethylpentene Cylinder" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TPX Polymethylpentene Cylinder" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cylinders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cylinders" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7109/jugs">Jugs</a>

                			<div class="sub-menu">

        			<h3>Jugs</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7110/polypropylene-jug">Polypropylene Jug</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene Jug" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene Jug" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7111/tpx-polymethylpentene-jug">TPX Polymethylpentene Jug</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TPX Polymethylpentene Jug" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TPX Polymethylpentene Jug" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Jugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Jugs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Measuring Plastics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Measuring Plastics" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/158/microscope-slides">Microscope Slides</a>

                			<div class="sub-menu">

        			<h3>Microscope Slides</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/159/plain-slides-beveled">Plain Slides, Beveled</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/160/charged-slides">Charged Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Charged Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Charged Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/161/concavity-slides">Concavity Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/162/cover-glasses">Cover Glasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5897/petri-dishes">Petri Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/153/microscope-slide-storage">Microscope Slide Storage</a>

                			<div class="sub-menu">

        			<h3>Microscope Slide Storage</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/154/25-slide-storage-box">25-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/155/50-slide-storage-box">50-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/156/100-slide-storage-box">100-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4983/20-slide-cardboard-folder">20-Slide Cardboard Folder</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="20-Slide Cardboard Folder" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="20-Slide Cardboard Folder" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5003/wash-n-dry-coverslip-rack">Wash-N-Dry Coverslip Rack</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wash-N-Dry Coverslip Rack" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wash-N-Dry Coverslip Rack" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5019/wash-n-dry-slide-rack">Wash-N-Dry Slide Rack</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wash-N-Dry Slide Rack" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wash-N-Dry Slide Rack" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slide Storage" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slide Storage" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5690/pipette-aids">Pipette Aids</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipette Aids" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipette Aids" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7150/mortar-and-pestle">Mortar &amp; Pestle</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mortar and Pestle" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mortar and Pestle" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7126/retort-stand">Retort Stand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Retort Stand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Retort Stand" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/5863/serological-pipets">Serological Pipets</a>

                			<div class="sub-menu">

        			<h3>Serological Pipets</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5867/individually-wrapped">Individually Wrapped</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5868/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7770/specimen-collection">Specimen Collection</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Specimen Collection" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Specimen Collection" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/168/surface-decontaminants">Surface Decontaminants</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/169/weighing-dishes">Weighing Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Weighing Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Weighing Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7132/wash-bottles">Wash Bottles</a>

                			<div class="sub-menu">

        			<h3>Wash Bottles</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7133/125ml-wash-bottle">125ml Wash Bottle</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="125ml Wash Bottle" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="125ml Wash Bottle" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7134/250ml-wash-bottle">250ml Wash Bottle</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Wash Bottle" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Wash Bottle" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7135/500ml-wash-bottle">500ml Wash Bottle</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Wash Bottle" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Wash Bottle" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7136/1000ml-wash-bottle">1000ml Wash Bottle</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Wash Bottle" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Wash Bottle" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wash Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wash Bottles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General Lab Supplies" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General Lab Supplies" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4884/drosophila"><i>Drosophila</i></a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i></h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4947/anesthesia-apparatus">Anesthesia Apparatus</a>

                			<div class="sub-menu">

        			<h3>Anesthesia Apparatus</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7244/anesthesia-accessories">Anesthesia Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anesthesia Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anesthesia Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7242/anesthesia-complete-systems">Anesthesia Complete Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anesthesia Complete Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anesthesia Complete Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7243/blowguns">Blowguns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blowguns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blowguns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7240/co2-bubblers">CO2 Bubblers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Bubblers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Bubblers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7236/co2-regulators">CO2 Regulators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Regulators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Regulators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7239/flowbuddy-flow-regulators">Flowbuddy Flow Regulators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flowbuddy Flow Regulators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flowbuddy Flow Regulators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7237/flypads">Flypads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flypads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flypads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7241/foot-pedals">Foot Pedals</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Foot Pedals" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Foot Pedals" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7423/trade-in-flypads">Trade-In Flypads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trade-In Flypads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trade-In Flypads" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anesthesia Apparatus" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anesthesia Apparatus" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7235/bottles">Bottles</a>

                			<div class="sub-menu">

        			<h3>Bottles</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7245/6oz-square-bottom">6oz Square Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="6oz Square Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="6oz Square Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7246/8oz-round-bottom">8oz Round Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8oz Round Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8oz Round Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7247/glass-stock-bottles">Glass Stock Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass Stock Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass Stock Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7248/bottles--and--closures-bundles">Bottles &amp; Closures Bundles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottles &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottles &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7305/cages-and-mesh">Cages &amp; Mesh</a>

                			<div class="sub-menu">

        			<h3>Cages &amp; Mesh</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7306/embryo-collection-cages">Embryo Collection Cages</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Embryo Collection Cages" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Embryo Collection Cages" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7310/fly-condo">Fly Condo</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fly Condo" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fly Condo" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4957/mesh-and-mesh-baskets">Mesh &amp; Mesh Baskets</a>

                			<div class="sub-menu">

        			<h3>Mesh &amp; Mesh Baskets</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7768/new-node">New node</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="New node" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="New node" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mesh and Mesh Baskets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mesh and Mesh Baskets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4959/petri-dishes">Petri Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7309/population-cages">Population Cages</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Population Cages" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Population Cages" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cages and Mesh" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cages and Mesh" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7282/closures">Closures</a>

                			<div class="sub-menu">

        			<h3>Closures</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7283/narrow-vial-closures">Narrow Vial Closures</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vial Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vial Closures" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7286/narrow-vials--and--closures-bundles">Narrow Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Narrow Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7290/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7292/polypropylene-pp-vials--and--rayon">Polypropylene (PP) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7291/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7293/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7294/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7295/polystyrene-ps-vials--and--rayon">Polystyrene (PS) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7285/stock-bottle-closures">Stock Bottle Closures</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stock Bottle Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stock Bottle Closures" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7288/wide-vials--and--closures-bundles">Wide Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Wide Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7296/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7297/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7298/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7299/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7287/wide-vial-closures">Wide Vial Closures</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vial Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vial Closures" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Closures" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4955/drosophila-incubators"><i>Drosophila</i> Incubators</a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i> Incubators</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6368/thermoelectric">Thermoelectric</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermoelectric" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermoelectric" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/6369/standard">Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4928/drosophila-food-ingredients"><i>Drosophila</i> Food Ingredients</a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i> Food Ingredients</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4945/apple-cider-vinegar">Apple Cider Vinegar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apple Cider Vinegar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apple Cider Vinegar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4933/cornmeal">Cornmeal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cornmeal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cornmeal" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4944/corn-syrup-solids">Corn Syrup Solids</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Corn Syrup Solids" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Corn Syrup Solids" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4943/dextrose">Dextrose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dextrose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dextrose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4932/drosophila-agar"><i>Drosophila</i> Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4941/malt-extract">Malt Extract</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Malt Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Malt Extract" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4937/molasses">Molasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molasses" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4940/propionic-acid-sodium-salt">Propionic Acid, Sodium Salt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Propionic Acid, Sodium Salt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Propionic Acid, Sodium Salt" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4938/soy-flour">Soy Flour</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soy Flour" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soy Flour" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4942/sucrose">Sucrose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sucrose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sucrose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4939/tegosept">Tegosept</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tegosept" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tegosept" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4934/yeast">Yeast</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yeast" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yeast" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Food Ingredients" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Food Ingredients" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4930/nutri-fly-pre-mixed-fly-food">Nutri-Fly® Pre-Mixed Fly Food</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nutri-Fly® Pre-Mixed Fly Food" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nutri-Fly® Pre-Mixed Fly Food" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4931/grape-agar-pre-mix">Grape Agar Pre-Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Grape Agar Pre-Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Grape Agar Pre-Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/4946/fly-food-dispensers">Fly Food Dispensers</a>

                			<div class="sub-menu">

        			<h3>Fly Food Dispensers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7300/droso-fillers">Droso-Fillers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Droso-Fillers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Droso-Fillers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7301/droso-filler-accessories">Droso-Filler Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Droso-Filler Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Droso-Filler Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7303/gilson-fly-food-dispensers">Gilson Fly Food Dispensers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson Fly Food Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson Fly Food Dispensers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fly Food Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fly Food Dispensers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7769/miscellaneous">Miscellaneous</a>

                			<div class="sub-menu">

        			<h3>Miscellaneous</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7304/halocarbon-oil">Halocarbon Oil</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7311/cheesecloth">Cheesecloth</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cheesecloth" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cheesecloth" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7312/fly-collar">Fly Collar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fly Collar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fly Collar" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7307/rubber-bands">Rubber Bands</a>

                			<div class="sub-menu">

        			<h3>Rubber Bands</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5735/indestructible-rubber-bands">Indestructible Rubber Bands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Indestructible Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Indestructible Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7308/standard-rubber-bands">Standard Rubber Bands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/4958/mite-control-">Mite Control </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mite Control " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mite Control " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/5190/stereo-dissecting-microscopes">Stereo/Dissecting Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7250/trays--and--dividers">Trays &amp; Dividers</a>

                			<div class="sub-menu">

        			<h3>Trays &amp; Dividers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7254/dividers-for-narrow-vials">Dividers for Narrow Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dividers for Narrow Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dividers for Narrow Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7255/dividers-for-wide-vials--and--bottles">Dividers for Wide Vials &amp; Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dividers for Wide Vials &amp; Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dividers for Wide Vials &amp; Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7256/trays--and--dividers-bundles">Trays &amp; Dividers Bundles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays &amp; Dividers Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays &amp; Dividers Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7252/trays-for-narrow-vials">Trays for Narrow Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays for Narrow Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays for Narrow Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7251/trays-for-stock-bottles">Trays for Stock Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays for Stock Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays for Stock Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7253/trays-for-wide-vials">Trays for Wide Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays for Wide Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays for Wide Vials" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays &amp; Dividers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays &amp; Dividers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7257/vials">Vials</a>

                			<div class="sub-menu">

        			<h3>Vials</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7260/narrow-vials">Narrow Vials</a>

                			<div class="sub-menu">

        			<h3>Narrow Vials</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7261/polystyrene-ps">Polystyrene (PS)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7262/polypropylene-pp">Polypropylene (PP)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7263/k-resin-kr">K-Resin (KR)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7269/glass">Glass</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7265/wide-vials">Wide Vials</a>

                			<div class="sub-menu">

        			<h3>Wide Vials</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7266/polystyrene-ps">Polystyrene (PS)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7267/polypropylene-pp">Polypropylene (PP)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7268/k-resin-kr">K-Resin (KR)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7270/narrow-vials--and--closures-bundles">Narrow Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Narrow Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7275/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7274/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7276/polypropylene-pp-vials--and--rayon">Polypropylene (PP) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7272/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7271/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7273/polystyrene-ps-vials--and--rayon">Polystyrene (PS) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbproduct/7277/wide-vials--and--closures-bundles">Wide Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Wide Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7281/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7280/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7279/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbproduct/7278/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vials" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila" data-url="https://geneseesci.com/brands-zymo/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>
        					</ul>
				</div>
				<div class="col-auto">
					<div class="ads">
						<div id="ad_block_1" class="ad-block-1"><a href="https://geneseesci.com/brands-zymo/"><img class="img-fluid ad-block-1" src="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners-270x300-1.webp"></a></div>
						<div id="ad_block_2" class="ad-block-2"><a href="https://geneseesci.com/genesee-brochure"><img class="img-fluid ad-block-2" src="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></a></div>
					</div>
				</div>
			</div>
		</div><!-- .root-container -->
	</li>

	<li id="by-application" class="menu-item-has-children hide-600-down"><a href="#"><span class="hide-650-down d-inline">By </span>Application</a>
        <div class="root-container sub-menu">
			<div class="row no-gutters">
				<div class="col">
					<h3>Browse By Application</h3>
					<ul class="t2 list-unstyled" data-tier="2">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7314/drosophila"><i>Drosophila</i></a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i></h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7315/anesthesia-apparatus">Anesthesia Apparatus</a>

                			<div class="sub-menu">

        			<h3>Anesthesia Apparatus</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7424/anesthesia-accessories">Anesthesia Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anesthesia Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anesthesia Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7325/anesthesia-complete-systems">Anesthesia Complete Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anesthesia Complete Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anesthesia Complete Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7326/blowguns">Blowguns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blowguns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blowguns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7327/co2-bubblers">CO2 Bubblers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Bubblers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Bubblers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7328/co2-regulators">CO2 Regulators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Regulators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Regulators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7329/flowbuddy-flow-regulators">Flowbuddy Flow Regulators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flowbuddy Flow Regulators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flowbuddy Flow Regulators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7425/flypads">Flypads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flypads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flypads" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7331/foot-pedals">Foot Pedals</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Foot Pedals" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Foot Pedals" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7332/trade-in-flypads">Trade-In Flypads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trade-In Flypads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trade-In Flypads" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anesthesia Apparatus" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anesthesia Apparatus" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7316/bottles">Bottles</a>

                			<div class="sub-menu">

        			<h3>Bottles</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7333/6oz-square-bottom">6oz Square Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="6oz Square Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="6oz Square Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7334/8oz-round-bottom">8oz Round Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8oz Round Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8oz Round Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7335/glass-stock-bottles">Glass Stock Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass Stock Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass Stock Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7336/bottles--and--closures-bundles">Bottles &amp; Closures Bundles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottles &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottles &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7317/cages-and-mesh">Cages &amp; Mesh</a>

                			<div class="sub-menu">

        			<h3>Cages &amp; Mesh</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7379/mesh-and-mesh-baskets">Mesh &amp; Mesh Baskets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mesh and Mesh Baskets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mesh and Mesh Baskets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7337/embryo-collection-cages">Embryo Collection Cages</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Embryo Collection Cages" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Embryo Collection Cages" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7426/fly-condo">Fly Condo</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fly Condo" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fly Condo" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7338/petri-dishes">Petri Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7339/population-cages">Population Cages</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Population Cages" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Population Cages" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cages and Mesh" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cages and Mesh" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7319/closures">Closures</a>

                			<div class="sub-menu">

        			<h3>Closures</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7341/narrow-vial-closures">Narrow Vial Closures</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vial Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vial Closures" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7342/narrow-vials--and--closures-bundles">Narrow Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Narrow Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7346/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7347/polypropylene-pp-vials--and--rayon">Polypropylene (PP) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7348/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7349/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7350/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7351/polystyrene-ps-vials--and--rayon">Polystyrene (PS) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7345/stock-bottle-closures">Stock Bottle Closures</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stock Bottle Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stock Bottle Closures" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7344/wide-vials--and--closures-bundles">Wide Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Wide Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7352/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7353/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7354/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7355/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7343/wide-vial-closures">Wide Vial Closures</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vial Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vial Closures" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Closures" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Closures" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7320/drosophila-incubators"><i>Drosophila</i> Incubators</a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i> Incubators</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7356/thermoelectric">Thermoelectric</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermoelectric" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermoelectric" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7427/standard">Standard</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7321/drosophila-media"><i>Drosophila</i> Media</a>

                			<div class="sub-menu">

        			<h3><i>Drosophila</i> Media</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7428/nutri-fly-pre-mixed-fly-food">Nutri-Fly® Pre-Mixed Fly Food</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nutri-Fly® Pre-Mixed Fly Food" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nutri-Fly® Pre-Mixed Fly Food" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7358/apple-cider-vinegar">Apple Cider Vinegar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apple Cider Vinegar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apple Cider Vinegar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7360/cornmeal">Cornmeal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cornmeal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cornmeal" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7361/corn-syrup-solids">Corn Syrup Solids</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Corn Syrup Solids" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Corn Syrup Solids" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7363/dextrose">Dextrose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dextrose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dextrose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7364/drosophila-agar"><i>Drosophila</i> Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7366/grape-agar-pre-mix">Grape Agar Pre-Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Grape Agar Pre-Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Grape Agar Pre-Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7367/malt-extract">Malt Extract</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Malt Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Malt Extract" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7368/molasses">Molasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molasses" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7369/propionic-acid-sodium-salt">Propionic Acid, Sodium Salt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Propionic Acid, Sodium Salt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Propionic Acid, Sodium Salt" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7370/soy-flour">Soy Flour</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Soy Flour" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Soy Flour" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7371/sucrose">Sucrose</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sucrose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sucrose" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7372/tegosept">Tegosept</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tegosept" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tegosept" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7373/yeast">Yeast</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yeast" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yeast" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7322/fly-food-dispensers">Fly Food Dispensers</a>

                			<div class="sub-menu">

        			<h3>Fly Food Dispensers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7374/droso-filler">Droso-Filler</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Droso-Filler" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Droso-Filler" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7375/droso-filler-accessories">Droso-Filler Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Droso-Filler Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Droso-Filler Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7377/gilson-fly-food-dispensers">Gilson Fly Food Dispensers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson Fly Food Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson Fly Food Dispensers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fly Food Dispensers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fly Food Dispensers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7767/miscellaneous">Miscellaneous</a>

                			<div class="sub-menu">

        			<h3>Miscellaneous</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7323/fly-collar">Fly Collar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fly Collar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fly Collar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7318/cheesecloth">Cheesecloth</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cheesecloth" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cheesecloth" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7378/halocarbon-oil">Halocarbon Oil</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7381/rubber-bands">Rubber Bands</a>

                			<div class="sub-menu">

        			<h3>Rubber Bands</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7382/indestructible-rubber-bands">Indestructible Rubber Bands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Indestructible Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Indestructible Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7383/standard-rubber-bands">Standard Rubber Bands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7380/mite-control">Mite Control</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mite Control" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mite Control" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7429/stereo-dissecting-microscopes">Stereo/Dissecting Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7385/trays--and--dividers">Trays &amp; Dividers</a>

                			<div class="sub-menu">

        			<h3>Trays &amp; Dividers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7386/dividers-for-narrow-vials">Dividers for Narrow Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dividers for Narrow Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dividers for Narrow Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7387/dividers-for-wide-vials--and--bottles">Dividers for Wide Vials &amp; Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dividers for Wide Vials &amp; Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dividers for Wide Vials &amp; Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7388/trays--and--dividers-bundles">Trays &amp; Dividers Bundles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays &amp; Dividers Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays &amp; Dividers Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7430/trays-for-narrow-vials">Trays for Narrow Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays for Narrow Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays for Narrow Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7391/trays-for-stock-bottles">Trays for Stock Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays for Stock Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays for Stock Bottles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7390/trays-for-wide-vials">Trays for Wide Vials</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays for Wide Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays for Wide Vials" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Trays &amp; Dividers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Trays &amp; Dividers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7393/vials">Vials</a>

                			<div class="sub-menu">

        			<h3>Vials</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7397/narrow-vials">Narrow Vials</a>

                			<div class="sub-menu">

        			<h3>Narrow Vials</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7432/polystyrene-ps">Polystyrene (PS)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7433/polypropylene-pp">Polypropylene (PP)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7434/k-resin-kr">K-Resin (KR)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7401/glass">Glass</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Glass" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Glass" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7402/wide-vials">Wide Vials</a>

                			<div class="sub-menu">

        			<h3>Wide Vials</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7403/polystyrene-ps">Polystyrene (PS)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7404/polypropylene-pp">Polypropylene (PP)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7405/k-resin-kr">K-Resin (KR)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="K-Resin (KR)" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vials" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7435/narrow-vials--and--closures-bundles">Narrow Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Narrow Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7436/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7437/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7438/polypropylene-pp-vials--and--rayon">Polypropylene (PP) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7439/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7440/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7441/polystyrene-ps-vials--and--rayon">Polystyrene (PS) Vials &amp; Rayon</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Rayon" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Narrow Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7413/wide-vials--and--closures-bundles">Wide Vials &amp; Closures Bundles</a>

                			<div class="sub-menu">

        			<h3>Wide Vials &amp; Closures Bundles</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7442/polypropylene-pp-vials--and--cotton">Polypropylene (PP) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7443/polypropylene-pp-vials--and--flugs">Polypropylene (PP) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene (PP) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7444/polystyrene-ps-vials--and--cotton">Polystyrene (PS) Vials &amp; Cotton</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Cotton" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7445/polystyrene-ps-vials--and--flugs">Polystyrene (PS) Vials &amp; Flugs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene (PS) Vials &amp; Flugs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wide Vials &amp; Closures Bundles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vials" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vials" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1240/c.-elegans"><i>C. elegans</i></a>

                			<div class="sub-menu">

        			<h3><i>C. elegans</i></h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1241/picks--and--platinum">Picks &amp; Platinum</a>

                			<div class="sub-menu">

        			<h3>Picks &amp; Platinum</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1242/wormstuff-worm-pick">WormStuff Worm Pick</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="WormStuff Worm Pick" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="WormStuff Worm Pick" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1243/platinum-tips--and--wire">Platinum Tips &amp; Wire</a>

                			<div class="sub-menu">

        			<h3>Platinum Tips &amp; Wire</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1244/tips-for-wormstuff-worm-pick">Tips for WormStuff Worm Pick</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tips for WormStuff Worm Pick" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tips for WormStuff Worm Pick" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1245/bulk-platinum-wire">Bulk Platinum Wire</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk Platinum Wire" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk Platinum Wire" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Platinum Tips &amp; Wire" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Platinum Tips &amp; Wire" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Picks &amp; Platinum" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Picks &amp; Platinum" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1246/petri-dishes-vented">Petri Dishes, Vented</a>

                			<div class="sub-menu">

        			<h3>Petri Dishes, Vented</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1247/standard-dishes">Standard Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1248/dishes-w--gripping-ring">Dishes w/ Gripping Ring</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dishes w/ Gripping Ring" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dishes w/ Gripping Ring" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Petri Dishes, Vented" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Petri Dishes, Vented" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1249/microscope-slides">Microscope Slides</a>

                			<div class="sub-menu">

        			<h3>Microscope Slides</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1250/plain-slides-beveled-edges">Plain Slides, Beveled Edges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Beveled Edges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Beveled Edges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1251/concavity-slides">Concavity Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1252/cover-glasses">Cover Glasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1253/slide-storage-boxes--and--mailers">Slide Storage Boxes &amp; Mailers</a>

                			<div class="sub-menu">

        			<h3>Slide Storage Boxes &amp; Mailers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1254/25-slide-storage-box">25 Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25 Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25 Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1255/50-slide-storage-box">50 Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50 Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50 Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1256/100-slide-storage-box">100 Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100 Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100 Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1257/slide-mailers">Slide Mailers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Slide Mailers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Slide Mailers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Slide Storage Boxes &amp; Mailers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Slide Storage Boxes &amp; Mailers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1258/media">Media</a>

                			<div class="sub-menu">

        			<h3>Media</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1259/agar-bacteriological-grade">Agar, Bacteriological Grade</a>

                			<div class="sub-menu">

        			<h3>Agar, Bacteriological Grade</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1260/granulated-agar">Granulated Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Granulated Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Granulated Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1261/powdered-agar">Powdered Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Powdered Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Powdered Agar" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agar, Bacteriological Grade" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agar, Bacteriological Grade" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1262/growth-media-nutrients">Growth Media Nutrients</a>

                			<div class="sub-menu">

        			<h3>Growth Media Nutrients</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1263/tryptone">Tryptone</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tryptone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tryptone" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1264/yeast-extract">Yeast Extract</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yeast Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yeast Extract" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1265/peptone">Peptone</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Peptone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Peptone" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Growth Media Nutrients" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Growth Media Nutrients" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1266/miscellaneous">Miscellaneous</a>

                			<div class="sub-menu">

        			<h3>Miscellaneous</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1267/mite-control">Mite Control</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mite Control" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mite Control" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1268/rubber-bands">Rubber Bands</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rubber Bands" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1269/parafilm">Parafilm</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Parafilm" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Parafilm" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1270/other">Other</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Other" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Other" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Miscellaneous" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="C. elegans" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="C. elegans" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/507/cell--and--tissue-culture">Cell &amp; Tissue Culture</a>

                			<div class="sub-menu">

        			<h3>Cell &amp; Tissue Culture</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7471/fetal-bovine-serum--and--bioequivalents">Fetal Bovine Serum &amp; Bioequivalents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fetal Bovine Serum &amp; Bioequivalents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fetal Bovine Serum &amp; Bioequivalents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4992/cell-culture-media--and--reagents">Cell Culture Media &amp; Reagents</a>

                			<div class="sub-menu">

        			<h3>Cell Culture Media &amp; Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7474/classical-media">Classical Media</a>

                			<div class="sub-menu">

        			<h3>Classical Media</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7475/dmem">DMEM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DMEM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DMEM" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7476/rpmi-1640">RPMI 1640</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RPMI 1640" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RPMI 1640" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7477/mem">MEM</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="MEM" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="MEM" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7478/hams-f10--and--f12">Hams F10 &amp; F12</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hams F10 &amp; F12" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hams F10 &amp; F12" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7479/mccoys-5a">McCoys 5A</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="McCoys 5A" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="McCoys 5A" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Classical Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Classical Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7482/buffers--and--balanced-salts">Buffers &amp; Balanced Salts</a>

                			<div class="sub-menu">

        			<h3>Buffers &amp; Balanced Salts</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7483/dpbs">DPBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DPBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DPBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7484/pbs">PBS</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PBS" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PBS" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7485/hepes">HEPES</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HEPES" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HEPES" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Buffers &amp; Balanced Salts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Buffers &amp; Balanced Salts" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7486/cell-dissociation-reagents">Cell Dissociation Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Dissociation Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Dissociation Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7487/antibiotics--and--selection-agents">Antibiotics &amp; Selection Agents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibiotics &amp; Selection Agents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibiotics &amp; Selection Agents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7488/media-supplements">Media Supplements</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Media Supplements" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Media Supplements" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7489/cell-culture-grade-water">Cell Culture Grade Water</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Culture Grade Water" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Culture Grade Water" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Culture Media &amp; Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Culture Media &amp; Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7466/tissue-culture-plastics">Tissue Culture Plastics</a>

                			<div class="sub-menu">

        			<h3>Tissue Culture Plastics</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/513/tissue-culture-plates">Tissue Culture Plates</a>

                			<div class="sub-menu">

        			<h3>Tissue Culture Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/514/tc-treated-plates">TC Treated Plates</a>

                			<div class="sub-menu">

        			<h3>TC Treated Plates</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/515/clear-plates">Clear Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/516/black-white-plates">Black/White Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Treated Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Treated Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/517/non-treated-plates">Non-Treated Plates</a>

                			<div class="sub-menu">

        			<h3>Non-Treated Plates</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/518/clear-plates">Clear Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/519/black-white-plates">Black/White Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black/White Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/520/tissue-culture-dishes">Tissue Culture Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7657/tissue-culture-flasks">Tissue Culture Flasks</a>

                			<div class="sub-menu">

        			<h3>Tissue Culture Flasks</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7658/tc-treated-flasks">TC Treated Flasks</a>

                			<div class="sub-menu">

        			<h3>TC Treated Flasks</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7660/plug-seal-cap">Plug Seal Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plug Seal Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plug Seal Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7662/vented-cap">Vented Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vented Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vented Cap" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Treated Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Treated Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7661/non-treated-flasks">Non-Treated Flasks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Treated Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Treated Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7663/shaker-flasks">Shaker Flasks</a>

                			<div class="sub-menu">

        			<h3>Shaker Flasks</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7664/baffled-bottom">Baffled Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Baffled Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Baffled Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7665/flat-bottom">Flat Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flat Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flat Bottom" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaker Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaker Flasks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Flasks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Flasks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7467/tissue-culture-bundles">Tissue Culture Bundles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Bundles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Bundles" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7469/tc-plate-inserts">TC Plate Inserts</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="TC Plate Inserts" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="TC Plate Inserts" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7496/serological-pipets">Serological Pipets</a>

                			<div class="sub-menu">

        			<h3>Serological Pipets</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7497/individually-wrapped">Individually Wrapped</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7498/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7468/culture-tubes-w--caps">Culture Tubes w/ Caps</a>

                			<div class="sub-menu">

        			<h3>Culture Tubes w/ Caps</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7493/polystyrene">Polystyrene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7494/polypropylene">Polypropylene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Culture Tubes w/ Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Culture Tubes w/ Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5009/cell-scrapers--and--lifters">Cell Scrapers &amp; Lifters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Scrapers &amp; Lifters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Scrapers &amp; Lifters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tissue Culture Plastics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tissue Culture Plastics" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/595/transfection-reagents">Transfection Reagents</a>

                			<div class="sub-menu">

        			<h3>Transfection Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7783/in-vitro-transfection-reagents">in vitro Transfection Reagents</a>

                			<div class="sub-menu">

        			<h3>in vitro Transfection Reagents</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7163/jetoptimus-dna-and-transfection-reagent-">jetOPTIMUS® DNA &amp; Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetOPTIMUS® DNA and Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetOPTIMUS® DNA and Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6905/jetprime-dna-and-sirna-transfection-reagent-">jetPRIME® DNA &amp; siRNA Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPRIME® DNA and siRNA Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPRIME® DNA and siRNA Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6911/interferin-sirna-and-mirna-transfection-reagent">INTERFERin® siRNA &amp; miRNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="INTERFERin® siRNA and miRNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="INTERFERin® siRNA and miRNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6906/jetmessenger-mrna-transfection-reagent">jetMESSENGER™ mRNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetMESSENGER™ mRNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetMESSENGER™ mRNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6912/pulsin-protein-delivery-reagent">PULSin® protein Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PULSin® protein Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PULSin® protein Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6903/jetpei-hepatocyte-dna-transfection-reagent-">jetPEI®-Hepatocyte DNA Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPEI®-Hepatocyte DNA Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPEI®-Hepatocyte DNA Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6904/jetpei-macrophage-dna-transfection-reagent-">jetPEI®-Macrophage DNA Transfection Reagent </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPEI®-Macrophage DNA Transfection Reagent " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPEI®-Macrophage DNA Transfection Reagent " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6901/jetpei-hts-dna-transfection-reagent">jetPEI® HTS DNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="jetPEI® HTS DNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="jetPEI® HTS DNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vitro Transfection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vitro Transfection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7784/in-vivo-transfection-reagents">in vivo Transfection Reagents</a>

                			<div class="sub-menu">

        			<h3>in vivo Transfection Reagents</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6907/in-vivo-jetpei-in-vivo-delivery-reagent">in vivo-jetPEI®, in vivo Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetPEI®, in vivo Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetPEI®, in vivo Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7604/in-vivo-jetrna-delivery-reagent">in vivo-jetRNA® Delivery reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetRNA® Delivery reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetRNA® Delivery reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6908/in-vivo-jetpei-gal-in-vivo-delivery-reagent">in vivo-jetPEI®-Gal, in vivo Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetPEI®-Gal, in vivo Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetPEI®-Gal, in vivo Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6909/in-vivo-jetpei-man-in-vivo-delivery-reagent">in vivo-jetPEI®-Man, in vivo Delivery Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo-jetPEI®-Man, in vivo Delivery Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo-jetPEI®-Man, in vivo Delivery Reagent" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="in vivo Transfection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="in vivo Transfection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7785/protein-production">Protein Production</a>

                			<div class="sub-menu">

        			<h3>Protein Production</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7786/fectopro">FectoPRO®</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FectoPRO®" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FectoPRO®" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7787/fectocho-expression-system">FectoCHO® Expression System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FectoCHO® Expression System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FectoCHO® Expression System" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Production" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Production" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7788/virus-production">Virus Production</a>

                			<div class="sub-menu">

        			<h3>Virus Production</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7789/fectovir-aav">FectoVIR®-AAV</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FectoVIR®-AAV" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FectoVIR®-AAV" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7790/peipro-dna-transfection-reagent">PEIpro® DNA Transfection Reagent</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PEIpro® DNA Transfection Reagent" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PEIpro® DNA Transfection Reagent" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Virus Production" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Virus Production" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transfection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transfection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/636/liquid-handling">Liquid Handling</a>

                			<div class="sub-menu">

        			<h3>Liquid Handling</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7500/pipet-tips">Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Pipet Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7527/olympus-premium-universal-pipet-tips">Olympus Premium Universal Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Olympus Premium Universal Pipet Tips</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7528/barrier-pipet-tips">Barrier Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7529/standard-pipet-tips">Standard Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Pipet Tips</h3>
        			<ul class="t7 list-unstyled" data-tier="7">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7536/10ul-premium-pipet-tip">10µl Premium Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Premium Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Premium Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7537/10ul-reach-ergonomic-tips">10µl Reach Ergonomic Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Reach Ergonomic Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Reach Ergonomic Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7538/200ul-ergonomic-tips">200µl Ergonomic Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Ergonomic Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Ergonomic Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7539/1250ul-reach-premium-pipet-tip">1250µl Reach Premium Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1250µl Reach Premium Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1250µl Reach Premium Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7540/5ml--and--10ml-pipet-tips">5ml &amp; 10ml Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5ml &amp; 10ml Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5ml &amp; 10ml Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7501/xtip4-pipette-tips-for-rainin-lts">xTIP4 Pipette Tips for Rainin™ LTS™</a>

                			<div class="sub-menu">

        			<h3>xTIP4 Pipette Tips for Rainin™ LTS™</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7502/barrier-pipet-tips">Barrier Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7508/standard-pipet-tips">Standard Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Pipet Tips</h3>
        			<ul class="t7 list-unstyled" data-tier="7">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7509/20ul-">20µl </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="20µl " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="20µl " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7511/300ul">300µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="300µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="300µl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7510/250ul">250µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250µl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7512/1000ul">1000µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7513/1200ul">1200µl</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1200µl" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1200µl" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="xTIP4 Pipette Tips for Rainin™ LTS™" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="xTIP4 Pipette Tips for Rainin™ LTS™" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7514/olympus-ergonomic-universal-pipet-tips">Olympus Ergonomic Universal Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Olympus Ergonomic Universal Pipet Tips</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7515/barrier-pipet-tips">Barrier Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7521/standard-pipet-tips">Standard Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Pipet Tips</h3>
        			<ul class="t7 list-unstyled" data-tier="7">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7522/10ul-ergonomic-tips">10µl Ergonomic Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Ergonomic Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Ergonomic Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7523/10ul-reach-ergonomic-tips">10µl Reach Ergonomic Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Reach Ergonomic Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Reach Ergonomic Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7524/200ul-ergonomic-tips">200µl Ergonomic Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Ergonomic Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Ergonomic Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7525/300ul-ergonomic-tips-">300µl Ergonomic Tips </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="300µl Ergonomic Tips " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="300µl Ergonomic Tips " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7526/1250ul-ergonomic-tips-">1250µl Ergonomic Tips </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1250µl Ergonomic Tips " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1250µl Ergonomic Tips " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Ergonomic Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Ergonomic Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4625/olympus-classic-universal-pipet-tips">Olympus Classic Universal Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Olympus Classic Universal Pipet Tips</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4626/barrier-tips">Barrier Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Barrier Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Barrier Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7541/standard-tips">Standard Tips</a>

                			<div class="sub-menu">

        			<h3>Standard Tips</h3>
        			<ul class="t7 list-unstyled" data-tier="7">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7556/10ul-classic-pipet-tip">10µl Classic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>10µl Classic Pipet Tip</h3>
        			<ul class="t8 list-unstyled" data-tier="8">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7542/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7557/non-low-binding">Non-Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Classic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Classic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7543/10ul-reach-classic-pipet-tip">10µl Reach Classic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>10µl Reach Classic Pipet Tip</h3>
        			<ul class="t8 list-unstyled" data-tier="8">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7548/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7551/non-low-binding">Non-Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10µl Reach Classic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10µl Reach Classic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7544/200ul-classic-pipet-tip">200µl Classic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>200µl Classic Pipet Tip</h3>
        			<ul class="t8 list-unstyled" data-tier="8">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7550/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7555/non-low-binding">Non-Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="200µl Classic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="200µl Classic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7545/300ul-classic-pipet-tip">300µl Classic Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="300µl Classic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="300µl Classic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7561/1000ul-classic-pipet-tip">1000µl Classic Pipet Tip</a>

                			<div class="sub-menu">

        			<h3>1000µl Classic Pipet Tip</h3>
        			<ul class="t8 list-unstyled" data-tier="8">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7560/low-binding">Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Binding" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7562/non-low-binding">Non-Low Binding</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Low Binding" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl Classic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl Classic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7558/1000ul-reach-classic-pipet-tip">1000µl Reach Classic Pipet Tip</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000µl Reach Classic Pipet Tip" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000µl Reach Classic Pipet Tip" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Classic Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Classic Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/523/serological-pipets">Serological Pipets</a>

                			<div class="sub-menu">

        			<h3>Serological Pipets</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/524/individually-wrapped">Individually Wrapped</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/527/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/637/pipette-controllers">Pipette Controllers</a>

                			<div class="sub-menu">

        			<h3>Pipette Controllers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7495/accu-jet-s-pipet-controller">Accu-jet S Pipet Controller</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accu-jet S Pipet Controller" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accu-jet S Pipet Controller" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/638/labnet-pipette-controllers">Labnet Pipette Controllers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Pipette Controllers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Pipette Controllers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/639/gilson-pipette-controllers">Gilson Pipette Controllers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gilson Pipette Controllers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gilson Pipette Controllers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/8009/poseidon-pipette-controller">Poseidon Pipette Controller</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Poseidon Pipette Controller" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Poseidon Pipette Controller" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Pipette Controllers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Pipette Controllers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/640/aspiration-stations">Aspiration Stations</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aspiration Stations" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aspiration Stations" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5112/peristaltic-pumps">Peristaltic Pumps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Peristaltic Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Peristaltic Pumps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Handling" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Handling" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7472/filtration">Filtration</a>

                			<div class="sub-menu">

        			<h3>Filtration</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/537/syringe-filters">Syringe Filters</a>

                			<div class="sub-menu">

        			<h3>Syringe Filters</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7481/pvdf-membrane">PVDF Membrane</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PVDF Membrane" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PVDF Membrane" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7480/pes-membrane">PES Membrane</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PES Membrane" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PES Membrane" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7473/cell-strainers">Cell Strainers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Strainers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Strainers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/528/vacuum-filtration">Vacuum Filtration</a>

                			<div class="sub-menu">

        			<h3>Vacuum Filtration</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/529/complete-systems">Complete Systems</a>

                			<div class="sub-menu">

        			<h3>Complete Systems</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7043/15ml-systems">15ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7044/50ml-systems">50ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/530/250ml-systems">250ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/531/500ml-systems">500ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/532/1000ml-systems">1000ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Complete Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Complete Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/533/bottle-top-filter-cups">Bottle Top Filter Cups</a>

                			<div class="sub-menu">

        			<h3>Bottle Top Filter Cups</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/534/250ml-filter-cups">250ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/535/500ml-filter-cups">500ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/536/1000ml-filter-cups">1000ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottle Top Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottle Top Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Filtration" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Filtration" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5159/heavy-duty-vacuum-bottles">Heavy Duty Vacuum Bottles</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Heavy Duty Vacuum Bottles" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Heavy Duty Vacuum Bottles" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filtration" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filtration" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7499/equipment">Equipment</a>

                			<div class="sub-menu">

        			<h3>Equipment</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/610/centrifuges">Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Centrifuges</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/611/compact--and--general-purpose-centrifuges">Compact &amp; General Purpose Centrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Compact &amp; General Purpose Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Compact &amp; General Purpose Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/612/universal-centrifuges">Universal Centrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Universal Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Universal Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/614/co2-incubators">CO2 Incubators</a>

                			<div class="sub-menu">

        			<h3>CO2 Incubators</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/615/water-jacket-co2-incubators">Water Jacket CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Water Jacket CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Water Jacket CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/616/air-jacket-co2-incubators">Air Jacket CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Air Jacket CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Air Jacket CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/617/high-capacity-co2-incubators">High Capacity CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Capacity CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Capacity CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/618/shaking-incubators">Shaking Incubators</a>

                			<div class="sub-menu">

        			<h3>Shaking Incubators</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5110/major-science-shaking-incubators">Major Science Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Major Science Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Major Science Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/619/benchmark-scientific-shaking-incubators">Benchmark Scientific Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/620/shel-lab-shaking-incubators">Shel Lab Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shel Lab Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shel Lab Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/621/labnet-shaking-incubators">Labnet Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/622/shaking-incubator-accessories">Shaking Incubator Accessories</a>

                			<div class="sub-menu">

        			<h3>Shaking Incubator Accessories</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/623/benchmark-scientific-accessories">Benchmark Scientific Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/624/shel-lab-accessories">Shel Lab Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shel Lab Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shel Lab Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/625/labnet-accessories">Labnet Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Incubator Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Incubator Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5192/inverted-compound-microscopes">Inverted Compound Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Inverted Compound Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Inverted Compound Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/626/water-baths">Water Baths</a>

                			<div class="sub-menu">

        			<h3>Water Baths</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5111/major-science-water-baths">Major Science Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Major Science Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Major Science Water Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/627/shel-lab-water-baths">Shel Lab Water Baths</a>

                			<div class="sub-menu">

        			<h3>Shel Lab Water Baths</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/628/standard-water-baths">Standard Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Water Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/629/shaking-water-baths">Shaking Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Water Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/630/speciatly-water-baths">Speciatly Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Speciatly Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Speciatly Water Baths" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shel Lab Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shel Lab Water Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/631/lab-armor-bead-baths">Lab Armor Bead Baths</a>

                			<div class="sub-menu">

        			<h3>Lab Armor Bead Baths</h3>
        			<ul class="t6 list-unstyled" data-tier="6">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/632/bead-baths">Bead Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bead Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bead Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/633/thermal-beads">Thermal Beads</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Beads" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Beads" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lab Armor Bead Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lab Armor Bead Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/634/benchmark-scientific-water-baths">Benchmark Scientific Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Water Baths" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/635/labnet-water-baths">Labnet Water Baths</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Water Baths" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Water Baths" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Water Baths" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Equipment" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/593/biohazard--and--safety">Biohazard &amp; Safety</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biohazard &amp; Safety" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biohazard &amp; Safety" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Tissue Culture" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Tissue Culture" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/918/pcr">PCR</a>

                			<div class="sub-menu">

        			<h3>PCR</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/919/pcr-tubes">PCR Tubes</a>

                			<div class="sub-menu">

        			<h3>PCR Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7047/4-strip-pcr-tubes--and--caps">4-Strip PCR Tubes &amp; Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="4-Strip PCR Tubes &amp; Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="4-Strip PCR Tubes &amp; Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/924/8-strip-pcr-tubes--and--strip-caps">8-Strip PCR Tubes &amp; Strip Caps</a>

                			<div class="sub-menu">

        			<h3>8-Strip PCR Tubes &amp; Strip Caps</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/925/packed-together">Packed Together</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Packed Together" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Packed Together" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/926/packed-separate">Packed Separate</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Packed Separate" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Packed Separate" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/927/assorted-colors">Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/928/8-strip-pcr-tubes-individual-attached-caps">8-Strip PCR Tubes, Individual Attached Caps</a>

                			<div class="sub-menu">

        			<h3>8-Strip PCR Tubes, Individual Attached Caps</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/929/individual-dome-caps">Individual Dome Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Dome Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Dome Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/930/individual-flat-caps">Individual Flat Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Flat Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Flat Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/931/individual-flat-caps-low-profile">Individual Flat Caps, Low Profile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Flat Caps, Low Profile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Flat Caps, Low Profile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7449/assorted-colors">Assorted Colors</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Assorted Colors" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip PCR Tubes, Individual Attached Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip PCR Tubes, Individual Attached Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/920/0.2ml-individual-pcr-tubes">0.2ml Individual PCR Tubes</a>

                			<div class="sub-menu">

        			<h3>0.2ml Individual PCR Tubes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/921/flat-cap">Flat Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flat Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flat Cap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/922/dome-cap">Dome Cap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dome Cap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dome Cap" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.2ml Individual PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.2ml Individual PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/923/0.5ml-individual-pcr-tubes">0.5ml Individual PCR Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.5ml Individual PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.5ml Individual PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/932/12-strip-pcr-tubes--and--strip-caps">12-Strip PCR Tubes &amp; Strip Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/933/pcr-plates">PCR Plates</a>

                			<div class="sub-menu">

        			<h3>PCR Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/934/olympus-96-well-plates">Olympus 96-Well Plates</a>

                			<div class="sub-menu">

        			<h3>Olympus 96-Well Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/935/96-well-non-skirted">96-Well Non-Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Non-Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Non-Skirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/936/96-well-semi-skirt">96-Well Semi-Skirt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Semi-Skirt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Semi-Skirt" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/937/96-well-full-skirt">96-Well Full-Skirt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Full-Skirt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Full-Skirt" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus 96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus 96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/938/olympus-384-well-plates">Olympus 384-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus 384-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus 384-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/947/24--and--48-well-pcr-plates">24 &amp; 48-Well PCR Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="24 &amp; 48-Well PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="24 &amp; 48-Well PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/948/sealing-films-caps--and--mats">Sealing Films, Caps &amp; Mats</a>

                			<div class="sub-menu">

        			<h3>Sealing Films, Caps &amp; Mats</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/952/real-time-pcr-films">Real-Time PCR Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real-Time PCR Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real-Time PCR Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7038/pcr-strip-films">PCR Strip Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Strip Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Strip Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/949/standard-pcr-films">Standard PCR Films</a>

                			<div class="sub-menu">

        			<h3>Standard PCR Films</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/950/transparent-films">Transparent Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transparent Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transparent Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/951/aluminum-foil-films">Aluminum Foil Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aluminum Foil Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aluminum Foil Films" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard PCR Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard PCR Films" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Films, Caps &amp; Mats" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Films, Caps &amp; Mats" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/957/pcr-purification-kits">PCR Purification Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Purification Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Purification Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/958/pcr-workstation-racks">PCR Workstation Racks</a>

                			<div class="sub-menu">

        			<h3>PCR Workstation Racks</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/959/standard-racks">Standard Racks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/960/temp.-maintenance-racks">Temp. Maintenance Racks</a>

                			<div class="sub-menu">

        			<h3>Temp. Maintenance Racks</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6845/maintains--plus-4ºc-">Maintains +4ºC </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maintains +4ºC " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maintains +4ºC " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/961/maintains-0ºc">Maintains 0ºC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maintains 0ºC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maintains 0ºC" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/962/maintains--4ºc">Maintains -4ºC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maintains -4ºC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maintains -4ºC" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/963/maintains--20ºc">Maintains -20ºC</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maintains -20ºC" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maintains -20ºC" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Temp. Maintenance Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Temp. Maintenance Racks" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Workstation Racks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Workstation Racks" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/964/aerosol-barrier-pipet-tips">Aerosol Barrier Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Aerosol Barrier Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7808/olympus-premium-universal-pipet-tips">Olympus Premium Universal Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7809/xtip4-pipette-tips-for-rainin-lts">xTIP4 Pipette Tips for Rainin™ LTS™</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="xTIP4 Pipette Tips for Rainin™ LTS™" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="xTIP4 Pipette Tips for Rainin™ LTS™" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aerosol Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aerosol Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/968/apex-taq-dna-polymerase">Apex <i>Taq</i> DNA Polymerase</a>

                			<div class="sub-menu">

        			<h3>Apex <i>Taq</i> DNA Polymerase</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/969/standard-taq-5-unit-ul">Standard <i>Taq</i>, 5 Unit/ul</a>

                			<div class="sub-menu">

        			<h3>Standard <i>Taq</i>, 5 Unit/ul</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/970/w--1.5mm-mg-buffers">w/ 1.5mM Mg Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ 1.5mM Mg Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ 1.5mM Mg Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/971/w--mg-free-buffers">w/ Mg Free Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/972/w--multiplex-buffers">w/ Multiplex Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Multiplex Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Multiplex Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/973/no-buffers-included">No Buffers Included</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="No Buffers Included" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="No Buffers Included" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Taq, 5 Unit/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Taq, 5 Unit/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/974/standard-taq-1-unit-ul">Standard <i>Taq</i>, 1 Unit/ul</a>

                			<div class="sub-menu">

        			<h3>Standard <i>Taq</i>, 1 Unit/ul</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/975/w--mg-free-buffers">w/ Mg Free Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/976/red-mg-free-buffers">RED, Mg Free Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RED, Mg Free Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RED, Mg Free Buffers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Taq, 1 Unit/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Taq, 1 Unit/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/977/hot-start-taq-5-units-ul">Hot Start <i>Taq</i>, 5 Units/ul</a>

                			<div class="sub-menu">

        			<h3>Hot Start <i>Taq</i>, 5 Units/ul</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/978/w--mg-free-buffers">w/ Mg Free Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="w/ Mg Free Buffers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start Taq, 5 Units/ul" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start Taq, 5 Units/ul" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/980/high-fidelity-polymerase">High Fidelity Polymerase</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Fidelity Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Fidelity Polymerase" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Taq DNA Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Taq DNA Polymerase" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/981/apex-taq-master-mixes">Apex <i>Taq</i> Master Mixes</a>

                			<div class="sub-menu">

        			<h3>Apex <i>Taq</i> Master Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/982/standard-colorless">Standard, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/983/standard-red">Standard, RED</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard, RED" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard, RED" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/984/hot-start--colorless">Hot Start,  Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start,  Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start,  Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/985/hot-start-blue">Hot Start, Blue</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start, Blue" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start, Blue" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex Taq Master Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex Taq Master Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/986/apex-dntps->99%-pure">Apex dNTPs, &gt;99% Pure</a>

                			<div class="sub-menu">

        			<h3>Apex dNTPs, &gt;99% Pure</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/987/dntp-sets">dNTP Sets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Sets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Sets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/988/dntp-mixes">dNTP Mixes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex dNTPs, >99% Pure" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex dNTPs, >99% Pure" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/990/pcr-reaction-buffers">PCR Reaction Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Reaction Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Reaction Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/991/surface-decontaminants">Surface Decontaminants</a>

                			<div class="sub-menu">

        			<h3>Surface Decontaminants</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/992/rnase-dnase-removal">RNase, DNase Removal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNase, DNase Removal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNase, DNase Removal" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/993/thermal-cyclers">Thermal Cyclers</a>

                			<div class="sub-menu">

        			<h3>Thermal Cyclers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7728/non-gradient">Non-Gradient</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Gradient" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Gradient" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7729/gradient">Gradient</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gradient" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gradient" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Thermal Cyclers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Thermal Cyclers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/994/centrifuges">Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Centrifuges</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/995/benchmark-scientific-microcentrifuges">Benchmark Scientific Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/996/labnet-microcentrifuges">Labnet Microcentrifuges</a>

                			<div class="sub-menu">

        			<h3>Labnet Microcentrifuges</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/997/pcr-plate-centrifuge">PCR Plate Centrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Plate Centrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Plate Centrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/998/mini-microcentrifuge">Mini Microcentrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Microcentrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Microcentrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/999/high-speed-microcentrifuges">High Speed Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Speed Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Speed Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7732/imaging-systems">Imaging Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Imaging Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Imaging Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1000/electrophoresis">Electrophoresis</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1001/horizontal-gel-boxes">Horizontal Gel Boxes</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Boxes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1002/mini-horizontal-gel-boxes">Mini Horizontal Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1003/midi-horizontal-gel-boxes">Midi Horizontal Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1004/maxi-horiztonal-gel-boxes">Maxi Horiztonal Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maxi Horiztonal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maxi Horiztonal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1005/power-supplies">Power Supplies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Power Supplies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Power Supplies" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7611/pcrbio-high-fidelity-polymerases">PCRBIO High-Fidelity Polymerases</a>

                			<div class="sub-menu">

        			<h3>PCRBIO High-Fidelity Polymerases</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7612/standard-polymerase">Standard Polymerase</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Polymerase" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7613/hot-start-polymerase">Hot Start Polymerase</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start Polymerase" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO High-Fidelity Polymerases" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO High-Fidelity Polymerases" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7194/pcrbio-high-fidelity-mixes">PCRBIO High-Fidelity Mixes</a>

                			<div class="sub-menu">

        			<h3>PCRBIO High-Fidelity Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7195/standard-mix">Standard Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7196/standard-mix-red">Standard Mix, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Mix, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Mix, Red" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7197/hot-start-mix">Hot Start Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7606/hot-start-mix-red">Hot Start Mix, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start Mix, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start Mix, Red" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO High-Fidelity Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO High-Fidelity Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6946/pcrbio-taq-dna-polymerase">PCRBIO <i>Taq</i> DNA Polymerase</a>

                			<div class="sub-menu">

        			<h3>PCRBIO <i>Taq</i> DNA Polymerase</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6947/robust-pcr-standard-taq">Robust PCR Standard <i>Taq</i></a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Robust PCR Standard Taq" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Robust PCR Standard Taq" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6948/classic-taq-w--30mm-mgcl2-buffer">Classic <i>Taq</i> w/ 30mM MgCl2 Buffer</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Classic Taq w/ 30mM MgCl2 Buffer" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Classic Taq w/ 30mM MgCl2 Buffer" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6949/hot-start-taq">Hot Start <i>Taq</i></a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start Taq" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start Taq" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6950/for-difficult-pcr">For Difficult PCR</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For Difficult PCR" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For Difficult PCR" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Taq DNA Polymerase" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Taq DNA Polymerase" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6952/pcrbio-taq-master-mixes">PCRBIO <i>Taq</i> Master Mixes</a>

                			<div class="sub-menu">

        			<h3>PCRBIO <i>Taq</i> Master Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6953/standard-colorless">Standard, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6954/standard-red">Standard, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard, Red" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6955/hot-start-colorless">Hot Start, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6956/hot-start-red">Hot Start, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Hot Start, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Hot Start, Red" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6957/for-difficult-pcr-colorless">For Difficult PCR, Colorless</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For Difficult PCR, Colorless" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For Difficult PCR, Colorless" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6958/for-difficult-pcr-red">For Difficult PCR, Red</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="For Difficult PCR, Red" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="For Difficult PCR, Red" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Taq Master Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Taq Master Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6959/pcrbio-dntps">PCRBIO dNTPs</a>

                			<div class="sub-menu">

        			<h3>PCRBIO dNTPs</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6960/dntp-mixes">dNTP Mixes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO dNTPs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO dNTPs" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6961/dna-extraction-kits">DNA Extraction Kits</a>

                			<div class="sub-menu">

        			<h3>DNA Extraction Kits</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6962/rapid-extract-pcr-kit">Rapid Extract PCR Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rapid Extract PCR Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rapid Extract PCR Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6963/rapid-extract-lysis-only-kit">Rapid Extract Lysis Only Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Rapid Extract Lysis Only Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Rapid Extract Lysis Only Kit" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA Extraction Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA Extraction Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6964/kits-for-end-point-pcr-from-rna">Kits for End Point PCR from RNA</a>

                			<div class="sub-menu">

        			<h3>Kits for End Point PCR from RNA</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6965/pcrbio-1-step-rt-pcr-kits">PCRBio 1-Step RT-PCR Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBio 1-Step RT-PCR Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBio 1-Step RT-PCR Kits" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Kits for End Point PCR from RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Kits for End Point PCR from RNA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1027/real-time-pcr">Real-Time PCR</a>

                			<div class="sub-menu">

        			<h3>Real-Time PCR</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1058/aerosol-barrier-pipet-tips">Aerosol Barrier Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>Aerosol Barrier Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1059/olympus-premium-universal-pipet-tips">Olympus Premium Universal Pipet Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus Premium Universal Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7806/xtip4-pipette-tips-for-rainin-lts">xTIP4 Pipette Tips for Rainin™ LTS™</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="xTIP4 Pipette Tips for Rainin™ LTS™" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="xTIP4 Pipette Tips for Rainin™ LTS™" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Aerosol Barrier Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Aerosol Barrier Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/5026/apex-qpcr-master-mixes">Apex qPCR Master Mixes</a>

                			<div class="sub-menu">

        			<h3>Apex qPCR Master Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5105/for-probe">for Probe</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="for Probe" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="for Probe" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5106/with-green-dye">with Green Dye</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="with Green Dye" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="with Green Dye" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex qPCR Master Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex qPCR Master Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1055/apex-dntps--and-gt;99%-pure">Apex dNTPs, &gt;99% Pure</a>

                			<div class="sub-menu">

        			<h3>Apex dNTPs, &gt;99% Pure</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1056/dntp-sets">dNTP Sets</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Sets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Sets" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1057/dntp-mixes">dNTP Mixes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="dNTP Mixes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Apex dNTPs, >99% Pure" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Apex dNTPs, >99% Pure" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6977/pcrbio-cdna-synthesis-kits">PCRBIO cDNA Synthesis Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO cDNA Synthesis Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO cDNA Synthesis Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6973/pcrbio-one-step-rt-qpcr">PCRBIO One Step RT-qPCR</a>

                			<div class="sub-menu">

        			<h3>PCRBIO One Step RT-qPCR</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6974/1-step-detect-kits-for-sensitivity">1-Step Detect Kits for Sensitivity</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1-Step Detect Kits for Sensitivity" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1-Step Detect Kits for Sensitivity" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6975/1-step-go-kits-for-rapid-results">1-Step Go Kits for Rapid Results</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1-Step Go Kits for Rapid Results" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1-Step Go Kits for Rapid Results" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6976/1-step-go-kits-for-probe">1-Step Go Kits for Probe</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1-Step Go Kits for Probe" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1-Step Go Kits for Probe" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7739/1-step-virus-detect-probe">1-Step Virus Detect Probe</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1-Step Virus Detect Probe" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1-Step Virus Detect Probe" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO One Step RT-qPCR" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO One Step RT-qPCR" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6966/pcrbio-real-time-pcr-mixes">PCRBIO Real-Time PCR Mixes</a>

                			<div class="sub-menu">

        			<h3>PCRBIO Real-Time PCR Mixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6967/sygreen-mix">SyGreen Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6968/sygreen-mix-w--blue-dye">SyGreen Mix w/ Blue Dye</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SyGreen Mix w/ Blue Dye" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SyGreen Mix w/ Blue Dye" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6969/standard-mix-for-probe">Standard Mix for Probe</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Mix for Probe" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Mix for Probe" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6970/standard-mix-for-probe-w--blue-dye">Standard Mix for Probe w/ Blue Dye</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Mix for Probe w/ Blue Dye" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Mix for Probe w/ Blue Dye" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6971/hrm-mix">HRM Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HRM Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HRM Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6972/genotyping-mix">Genotyping Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Genotyping Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Genotyping Mix" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7717/fluorescein-sygreen-mix">Fluorescein SyGreen Mix</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fluorescein SyGreen Mix" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fluorescein SyGreen Mix" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Real-Time PCR Mixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Real-Time PCR Mixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6978/pcrbio-reverse-transcriptases">PCRBIO Reverse Transcriptases</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCRBIO Reverse Transcriptases" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCRBIO Reverse Transcriptases" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1028/real-time-pcr-plates">Real-Time PCR Plates</a>

                			<div class="sub-menu">

        			<h3>Real-Time PCR Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1029/96-well-plates">96-Well Plates</a>

                			<div class="sub-menu">

        			<h3>96-Well Plates</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1030/non-skirted">Non-Skirted</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Skirted" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Skirted" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1031/non-skirted-low-profile">Non-Skirted, Low Profile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Non-Skirted, Low Profile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Non-Skirted, Low Profile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1032/semi-skirted-raised-rim-">Semi-Skirted, Raised Rim </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Skirted, Raised Rim " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Skirted, Raised Rim " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1033/semi-skirted-flat-rim">Semi-Skirted, Flat Rim</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Skirted, Flat Rim" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Skirted, Flat Rim" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1034/semi-skirted-straight-sided">Semi-Skirted, Straight-Sided</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Skirted, Straight-Sided" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Skirted, Straight-Sided" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1035/semi-skirted-low-profile">Semi-Skirted, Low Profile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Skirted, Low Profile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Skirted, Low Profile" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1036/full-skirted-low-profile">Full-Skirted, Low Profile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Full-Skirted, Low Profile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Full-Skirted, Low Profile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1037/384-well-plates">384-Well Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1038/plates-by-cycler-type">Plates by Cycler Type</a>

                			<div class="sub-menu">

        			<h3>Plates by Cycler Type</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1039/lightcycler-type-plates">LightCycler-type Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="LightCycler-type Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="LightCycler-type Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1040/icycler-type-plates-">iCycler-type Plates </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="iCycler-type Plates " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="iCycler-type Plates " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1041/cfx-type-plates-">CFX-type Plates </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CFX-type Plates " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CFX-type Plates " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1042/abi-type-plates">ABI-type Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ABI-type Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ABI-type Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1043/fast-type-plates">FAST-type Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FAST-type Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FAST-type Plates" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plates by Cycler Type" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plates by Cycler Type" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real-Time PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real-Time PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7730/real-time-thermal-cycler">Real-Time Thermal Cycler</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real-Time Thermal Cycler" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real-Time Thermal Cycler" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1044/strip-caps-for-pcr-plates">Strip Caps for PCR Plates</a>

                			<div class="sub-menu">

        			<h3>Strip Caps for PCR Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1045/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1046/genesee-brand">Genesee Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Genesee Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Genesee Brand" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Strip Caps for PCR Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Strip Caps for PCR Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1047/sealing-films-for-real-time">Sealing Films for Real-Time</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Films for Real-Time" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Films for Real-Time" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1048/8-strip-pcr-tubes--and--strip-caps">8-Strip PCR Tubes &amp; Strip Caps</a>

                			<div class="sub-menu">

        			<h3>8-Strip PCR Tubes &amp; Strip Caps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1049/8-strip-tubes">8-Strip Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1050/8-strip-flat-caps">8-Strip Flat Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip Flat Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip Flat Caps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1051/8-strip-pcr-tubes-individual-flat-caps">8-Strip PCR Tubes, Individual Flat Caps</a>

                			<div class="sub-menu">

        			<h3>8-Strip PCR Tubes, Individual Flat Caps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1052/standard-0.2ml">Standard, 0.2ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard, 0.2ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard, 0.2ml" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1053/low-profile-0.1ml">Low Profile, 0.1ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Profile, 0.1ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Profile, 0.1ml" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Strip PCR Tubes, Individual Flat Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Strip PCR Tubes, Individual Flat Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1054/12-strip-pcr-tubes--and--strip-caps">12-Strip PCR Tubes &amp; Strip Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Strip PCR Tubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7742/mic--and--myra">Mic &amp; Myra</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mic &amp; Myra" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mic &amp; Myra" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Real-Time PCR" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Real-Time PCR" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/481/filtration">Filtration</a>

                			<div class="sub-menu">

        			<h3>Filtration</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7039/cell-strainers">Cell Strainers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell Strainers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell Strainers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/482/vacuum-filtration">Vacuum Filtration</a>

                			<div class="sub-menu">

        			<h3>Vacuum Filtration</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/483/complete-systems">Complete Systems</a>

                			<div class="sub-menu">

        			<h3>Complete Systems</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5367/50ml">50ml</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/484/250ml-systems">250ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/485/500ml-systems">500ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/486/1000ml-systems">1000ml Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Complete Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Complete Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/487/bottle-top-filter-cups">Bottle Top Filter Cups</a>

                			<div class="sub-menu">

        			<h3>Bottle Top Filter Cups</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/488/250ml-filter-cups">250ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="250ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="250ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/489/500ml-filter-cups">500ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="500ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="500ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/490/1000ml-filter-cups">1000ml Filter Cups</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1000ml Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1000ml Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bottle Top Filter Cups" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bottle Top Filter Cups" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Filtration" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Filtration" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/491/syringe-filters">Syringe Filters</a>

                			<div class="sub-menu">

        			<h3>Syringe Filters</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/492/pes-membrane">PES Membrane</a>

                			<div class="sub-menu">

        			<h3>PES Membrane</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/493/0.22um-">0.22um </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.22um " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.22um " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/494/0.45um">0.45um</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.45um" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.45um" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PES Membrane" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PES Membrane" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/495/pvdf-membrane">PVDF Membrane</a>

                			<div class="sub-menu">

        			<h3>PVDF Membrane</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/497/0.22um-">0.22um </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.22um " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.22um " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/498/0.45um">0.45um</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.45um" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.45um" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PVDF Membrane" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PVDF Membrane" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Syringe Filters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/506/vacuum-controlled-aspiration-system">Vacuum Controlled Aspiration System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacuum Controlled Aspiration System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacuum Controlled Aspiration System" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5113/peristaltic-pumps">Peristaltic Pumps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Peristaltic Pumps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Peristaltic Pumps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Filtration" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Filtration" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/720/electrophoresis">Electrophoresis</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4506/agarose">Agarose</a>

                			<div class="sub-menu">

        			<h3>Agarose</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4507/general-purpose--and--quick-dissolve-le">General Purpose &amp; Quick Dissolve LE</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General Purpose &amp; Quick Dissolve LE" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General Purpose &amp; Quick Dissolve LE" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4510/super-fine-resolution">Super Fine Resolution</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Super Fine Resolution" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Super Fine Resolution" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4511/super-resolution-3:1-blend">Super Resolution 3:1 Blend</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Super Resolution 3:1 Blend" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Super Resolution 3:1 Blend" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4512/low-melt">Low Melt</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Melt" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Melt" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4513/low-melt-sieve">Low Melt Sieve</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Melt Sieve" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Melt Sieve" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agarose" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agarose" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4514/electrophoresis-buffers">Electrophoresis Buffers</a>

                			<div class="sub-menu">

        			<h3>Electrophoresis Buffers</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4515/liquid-concentrate-buffers">Liquid Concentrate Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Liquid Concentrate Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Liquid Concentrate Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4516/dry-pack-premix-buffers">Dry Pack Premix Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dry Pack Premix Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dry Pack Premix Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4517/tris-tricine-edta">Tris/Tricine/EDTA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tris/Tricine/EDTA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tris/Tricine/EDTA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4525/gel-extraction-kits">Gel Extraction Kits</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Extraction Kits" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Extraction Kits" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4519/ethidium-bromide">Ethidium Bromide</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Ethidium Bromide" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Ethidium Bromide" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4522/page-reagents">PAGE Reagents</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PAGE Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PAGE Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4523/surface-decontaminants">Surface Decontaminants</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Surface Decontaminants" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4526/gel-loading-tips">Gel Loading Tips</a>

                			<div class="sub-menu">

        			<h3>Gel Loading Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4527/round-gel-loading-tips">Round Gel Loading Tips</a>

                			<div class="sub-menu">

        			<h3>Round Gel Loading Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4528/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4529/racked">Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4530/racked-sterile">Racked, Sterile</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, Sterile" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, Sterile" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Round Gel Loading Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Round Gel Loading Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4531/flat-gel-loading-tips">Flat Gel Loading Tips</a>

                			<div class="sub-menu">

        			<h3>Flat Gel Loading Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4532/racked-0.37mm-o.d.">Racked, 0.37mm O.D.</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, 0.37mm O.D." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, 0.37mm O.D." data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4533/racked-0.17mm-o.d">Racked, 0.17mm O.D</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Racked, 0.17mm O.D" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Racked, 0.17mm O.D" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flat Gel Loading Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flat Gel Loading Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Loading Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Loading Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4534/autoradiography-film">Autoradiography Film</a>

                			<div class="sub-menu">

        			<h3>Autoradiography Film</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5894/blue-devil-premium-film">Blue Devil Premium Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil Premium Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil Premium Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6301/blue-devil-west">Blue Devil West</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil West" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil West" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4535/blue-devil-film">Blue Devil Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4536/blue-devil-lite-film">Blue Devil Lite Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blue Devil Lite Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blue Devil Lite Film" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Autoradiography Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Autoradiography Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4537/blotting-paper">Blotting Paper</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4538/dna-ladders">DNA Ladders</a>

                			<div class="sub-menu">

        			<h3>DNA Ladders</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7051/up-to-500-bp">Up to 500 bp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Up to 500 bp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Up to 500 bp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7049/100-bp---1-kb">100 bp - 1 kb</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100 bp - 1 kb" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100 bp - 1 kb" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7050/100-bp---3-kb">100 bp - 3 kb</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100 bp - 3 kb" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100 bp - 3 kb" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7052/up-to-5-000-bp">Up to 5,000 bp</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Up to 5,000 bp" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Up to 5,000 bp" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7053/up-to-10-000-bp--plus-">Up to 10,000 bp +</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Up to 10,000 bp +" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Up to 10,000 bp +" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4541/gel-loading-dye">Gel Loading Dye</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Loading Dye" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Loading Dye" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA Ladders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA Ladders" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4542/gel-boxes--and--accessories">Gel Boxes &amp; Accessories</a>

                			<div class="sub-menu">

        			<h3>Gel Boxes &amp; Accessories</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4543/horizontal-gel-boxes">Horizontal Gel Boxes</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Boxes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4544/mini-horizontal-systems">Mini Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4545/midi-horizontal-systems">Midi Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4546/maxi-horizontal-systems">Maxi Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maxi Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maxi Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4547/vetical-gel-boxes">Vetical Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vetical Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vetical Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4548/horizontal-gel-box-accessories">Horizontal Gel Box Accessories</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Box Accessories</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4549/gel-casting-systems">Gel Casting Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Casting Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Casting Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4550/mini-horizontal-system-accessories">Mini Horizontal System Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal System Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal System Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4551/midi-horizontal-system-accessories">Midi Horizontal System Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal System Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal System Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Box Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Box Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4552/vertical-gel-box-accessories">Vertical Gel Box Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vertical Gel Box Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vertical Gel Box Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Boxes &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Boxes &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4553/electroblotting-systems">Electroblotting Systems</a>

                			<div class="sub-menu">

        			<h3>Electroblotting Systems</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4554/semi-dry-electroblotters">Semi-Dry Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Semi-Dry Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Semi-Dry Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4555/tank-electroblotters">Tank Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tank Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tank Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroblotting Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroblotting Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4556/power-supplies">Power Supplies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Power Supplies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Power Supplies" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4557/gel-documentation-systems">Gel Documentation Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Documentation Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Documentation Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4518/weighing-dishes">Weighing Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Weighing Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Weighing Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4558/transilluminators">Transilluminators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Transilluminators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Transilluminators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4559/gel-blotting--and--staining-equipment">Gel Blotting &amp; Staining Equipment</a>

                			<div class="sub-menu">

        			<h3>Gel Blotting &amp; Staining Equipment</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4560/benchmark-scientific-rockers">Benchmark Scientific Rockers</a>

                			<div class="sub-menu">

        			<h3>Benchmark Scientific Rockers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4561/2d-rockers">2D Rockers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2D Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2D Rockers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4562/3d-rockers">3D Rockers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3D Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3D Rockers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4563/2d-rocker-accessories">2D Rocker Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2D Rocker Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2D Rocker Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4564/3d-rocker-accessories">3D Rocker Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3D Rocker Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3D Rocker Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Rockers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/4565/labnet-shakers--and--rockers">Labnet Shakers &amp; Rockers</a>

                			<div class="sub-menu">

        			<h3>Labnet Shakers &amp; Rockers</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4566/orbital-shakers">Orbital Shakers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Orbital Shakers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Orbital Shakers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4567/orbital-shaker-accessories">Orbital Shaker Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Orbital Shaker Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Orbital Shaker Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4568/2d-rockers">2D Rockers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="2D Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="2D Rockers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4569/3d-rockers">3D Rockers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3D Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3D Rockers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4570/3d-rocker-accessories">3D Rocker Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3D Rocker Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3D Rocker Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Shakers &amp; Rockers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Shakers &amp; Rockers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Blotting &amp; Staining Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Blotting &amp; Staining Equipment" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electrophoresis" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electrophoresis" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7811/flow-cytometry">Flow Cytometry</a>

                			<div class="sub-menu">

        			<h3>Flow Cytometry</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7812/flow-cytometry-tubes">Flow Cytometry Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flow Cytometry Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flow Cytometry Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7813/primary-antibodies">Primary Antibodies</a>

                			<div class="sub-menu">

        			<h3>Primary Antibodies</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7838/anti-human-antibodies">Anti-Human Antibodies</a>

                			<div class="sub-menu">

        			<h3>Anti-Human Antibodies</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7835/hla-dr-dp-dq">HLA-DR, DP, DQ</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="HLA-DR, DP, DQ" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="HLA-DR, DP, DQ" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7815/cd10">CD10</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD10" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD10" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7816/cd11a">CD11a</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD11a" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD11a" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7830/cd14">CD14</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD14" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD14" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7817/cd15">CD15</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD15" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD15" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7818/cd16">CD16</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD16" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD16" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7828/cd117">CD117</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD117" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD117" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7819/cd19">CD19</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD19" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD19" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7832/cd2">CD2</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD2" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD2" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7821/cd20">CD20</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD20" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD20" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7822/cd22">CD22</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD22" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD22" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7823/cd3">CD3</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD3" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD3" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7824/cd32">CD32</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD32" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD32" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7831/cd33">CD33</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD33" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD33" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7833/cd38">CD38</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD38" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD38" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7825/cd4">CD4</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD4" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD4" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7826/cd45">CD45</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD45" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD45" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7827/cd8">CD8</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD8" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD8" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7820/p53">p53</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="p53" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="p53" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anti-Human Antibodies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anti-Human Antibodies" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7839/anti-non-human-primate-antibodies">Anti-Non-Human Primate Antibodies</a>

                			<div class="sub-menu">

        			<h3>Anti-Non-Human Primate Antibodies</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7845/cd14">CD14</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD14" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD14" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7842/cd16">CD16</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD16" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD16" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7843/cd20">CD20</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD20" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD20" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7846/cd38">CD38</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD38" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD38" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7844/cd4">CD4</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CD4" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CD4" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Anti-Non-Human Primate Antibodies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Anti-Non-Human Primate Antibodies" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Primary Antibodies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Primary Antibodies" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7814/flaer-mammalian-gpi-anchor">FLAER Mammalian GPI Anchor</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="FLAER Mammalian GPI Anchor" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="FLAER Mammalian GPI Anchor" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Flow Cytometry" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Flow Cytometry" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/5608/western-blotting">Western Blotting</a>

                			<div class="sub-menu">

        			<h3>Western Blotting</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6711/blotting-membranes">Blotting Membranes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Membranes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Membranes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/5724/blotting-paper">Blotting Paper</a>

                			<div class="sub-menu">

        			<h3>Blotting Paper</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6709/0.34mm-thick-3mm-chr">0.34mm thick (3MM Chr)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.34mm thick (3MM Chr)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.34mm thick (3MM Chr)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6710/0.83mm-thick-gb003">0.83mm thick (GB003)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="0.83mm thick (GB003)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="0.83mm thick (GB003)" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Paper" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5678/blotting-trays-w--lids">Blotting Trays w/ Lids</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting Trays w/ Lids" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting Trays w/ Lids" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6708/blotting-x-ray-film">Blotting X-Ray Film</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blotting X-Ray Film" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blotting X-Ray Film" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6712/blocking--and--transfer-buffers">Blocking &amp; Transfer Buffers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Blocking &amp; Transfer Buffers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Blocking &amp; Transfer Buffers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6583/ecl-detection-reagents">ECL Detection Reagents</a>

                			<div class="sub-menu">

        			<h3>ECL Detection Reagents</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6705/prosignal-pico">ProSignal Pico</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ProSignal Pico" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ProSignal Pico" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6706/prosignal-dura">ProSignal Dura</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ProSignal Dura" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ProSignal Dura" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6707/prosignal-femto">ProSignal Femto</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ProSignal Femto" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ProSignal Femto" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ECL Detection Reagents" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ECL Detection Reagents" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6716/electroblotters">Electroblotters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroblotters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroblotters" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6717/gel-boxes">Gel Boxes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6714/protein-ladders">Protein Ladders</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Ladders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Ladders" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6584/secondary-antibodies">Secondary Antibodies</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Secondary Antibodies" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Secondary Antibodies" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Western Blotting" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Western Blotting" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1062/dna--and--rna-purification">DNA &amp; RNA Purification</a>

                			<div class="sub-menu">

        			<h3>DNA &amp; RNA Purification</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/8119/accuris-isopure-systems">Accuris IsoPure™ Systems</a>

                			<div class="sub-menu">

        			<h3>Accuris IsoPure™ Systems</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/8120/isopure-96-automated-purification-system">IsoPure™ 96 Automated Purification System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="IsoPure™ 96 Automated Purification System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="IsoPure™ 96 Automated Purification System" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/8121/isopure-mini-automated-purification-system">IsoPure™ Mini Automated Purification System</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="IsoPure™ Mini Automated Purification System" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="IsoPure™ Mini Automated Purification System" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Accuris IsoPure™ Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Accuris IsoPure™ Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7085/sample-collection--and--preservation">Sample Collection &amp; Preservation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sample Collection &amp; Preservation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sample Collection &amp; Preservation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1086/pcr-purification---dna-clean-up">PCR Purification / DNA Clean-up</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="PCR Purification / DNA Clean-up" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="PCR Purification / DNA Clean-up" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1085/gel-dna-extraction">Gel DNA Extraction</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel DNA Extraction" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel DNA Extraction" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1077/plasmid-dna-purification">Plasmid DNA Purification</a>

                			<div class="sub-menu">

        			<h3>Plasmid DNA Purification</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5741/plasmid-miniprep">Plasmid Miniprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Miniprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Miniprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5742/plasmid-midiprep">Plasmid Midiprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Midiprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Midiprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5743/plasmid-maxiprep">Plasmid Maxiprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Maxiprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Maxiprep" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5744/plasmid-gigaprep">Plasmid Gigaprep</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid Gigaprep" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid Gigaprep" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plasmid DNA Purification" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plasmid DNA Purification" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5068/genomic-dna-isolation">Genomic DNA Isolation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Genomic DNA Isolation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Genomic DNA Isolation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5066/total-rna-isolation">Total RNA Isolation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Total RNA Isolation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Total RNA Isolation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5069/rna-clean-up--and--concentration">RNA Clean-up &amp; Concentration</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA Clean-up &amp; Concentration" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA Clean-up &amp; Concentration" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7624/epigenetics">Epigenetics</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Epigenetics" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Epigenetics" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1091/cuvettes">Cuvettes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cuvettes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cuvettes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1092/centrifuges">Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Centrifuges</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1093/benchmark-scientific-microcentrifuges">Benchmark Scientific Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1094/labnet-microcentrifuges">Labnet Microcentrifuges</a>

                			<div class="sub-menu">

        			<h3>Labnet Microcentrifuges</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1095/mini-microcentrifuge">Mini Microcentrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Microcentrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Microcentrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1096/high-speed-microcentrifuges">High Speed Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Speed Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Speed Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1097/vortex-mixers">Vortex Mixers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vortex Mixers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vortex Mixers" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1100/gel-apparatus--and--accessories">Gel Apparatus &amp; Accessories</a>

                			<div class="sub-menu">

        			<h3>Gel Apparatus &amp; Accessories</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1101/horizontal-gel-boxes">Horizontal Gel Boxes</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Boxes</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1102/mini-horizontal-systems">Mini Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1103/midi-horizontal-systems">Midi Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1104/maxi-horizontal-systems">Maxi Horizontal Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Maxi Horizontal Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Maxi Horizontal Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1105/horizontal-gel-box-accessories">Horizontal Gel Box Accessories</a>

                			<div class="sub-menu">

        			<h3>Horizontal Gel Box Accessories</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1106/gel-casting-systems">Gel Casting Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Casting Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Casting Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1107/mini-horizontal-system-accessories">Mini Horizontal System Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Horizontal System Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Horizontal System Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1108/midi-horizontal-system-accessories">Midi Horizontal System Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Midi Horizontal System Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Midi Horizontal System Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Horizontal Gel Box Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Horizontal Gel Box Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Apparatus &amp; Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Apparatus &amp; Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1063/spin-columns">Spin Columns</a>

                			<div class="sub-menu">

        			<h3>Spin Columns</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5163/zymo-spin-columns">Zymo Spin Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Zymo Spin Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Zymo Spin Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1064/uprep-spin-columns">UPrep Spin Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="UPrep Spin Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="UPrep Spin Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1065/uprep-midi-maxi-columns">UPrep Midi/Maxi Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="UPrep Midi/Maxi Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="UPrep Midi/Maxi Columns" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Spin Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Spin Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/7734/viral-rna-collection-and-transport">Viral RNA Collection &amp; Transport</a>

                			<div class="sub-menu">

        			<h3>Viral RNA Collection &amp; Transport</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7735/sample-collection-devices">Sample Collection Devices</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sample Collection Devices" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sample Collection Devices" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7736/viral-transport-media">Viral Transport Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Viral Transport Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Viral Transport Media" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Viral RNA Collection and Transport" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Viral RNA Collection and Transport" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7747/micro-volume-spectrophotometers">Micro-Volume Spectrophotometers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Micro-Volume Spectrophotometers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Micro-Volume Spectrophotometers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="DNA &amp; RNA Purification" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="DNA &amp; RNA Purification" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/787/protein-purification">Protein Purification</a>

                			<div class="sub-menu">

        			<h3>Protein Purification</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7067/protein-extraction">Protein Extraction</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Extraction" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Extraction" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7068/protein-quantification">Protein Quantification</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Quantification" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Quantification" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/7069/protease-inhibitor-cocktails">Protease Inhibitor Cocktails</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protease Inhibitor Cocktails" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protease Inhibitor Cocktails" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6724/biotin-agarose-sepharose">Biotin Agarose (Sepharose)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biotin Agarose (Sepharose)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biotin Agarose (Sepharose)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6722/gst-tag-glutathione-agarose-resins">GST-Tag (Glutathione Agarose) Resins</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GST-Tag (Glutathione Agarose) Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GST-Tag (Glutathione Agarose) Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6718/his-tag-nickel--and--cobalt-columns">His-Tag (Nickel &amp; Cobalt) Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="His-Tag (Nickel &amp; Cobalt) Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="His-Tag (Nickel &amp; Cobalt) Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5683/his-tag-nickel--and--cobalt-resins">His-Tag (Nickel &amp; Cobalt) Resins</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="His-Tag (Nickel &amp; Cobalt) Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="His-Tag (Nickel &amp; Cobalt) Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6719/protein-a-agarose-sepharose">Protein A Agarose (Sepharose)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein A Agarose (Sepharose)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein A Agarose (Sepharose)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6721/protein-a-g-agarose-sepharose">Protein A/G Agarose (Sepharose)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein A/G Agarose (Sepharose)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein A/G Agarose (Sepharose)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6874/protein-concentrators">Protein Concentrators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Concentrators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Concentrators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6720/protein-g-agarose-sepharose">Protein G Agarose (Sepharose)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein G Agarose (Sepharose)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein G Agarose (Sepharose)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6723/protein-l-agarose-sepharose">Protein L Agarose (Sepharose)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein L Agarose (Sepharose)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein L Agarose (Sepharose)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6726/size-exclusion-sephadex">Size Exclusion (Sephadex)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Size Exclusion (Sephadex)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Size Exclusion (Sephadex)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6725/streptavidin-agarose-sepharose">Streptavidin Agarose (Sepharose)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Streptavidin Agarose (Sepharose)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Streptavidin Agarose (Sepharose)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6727/empty-fplc-columns-cartridges">Empty FPLC Columns/Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Empty FPLC Columns/Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Empty FPLC Columns/Cartridges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Protein Purification" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Protein Purification" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/812/microbiology">Microbiology</a>

                			<div class="sub-menu">

        			<h3>Microbiology</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/813/growth-media-premixes">Growth Media Premixes</a>

                			<div class="sub-menu">

        			<h3>Growth Media Premixes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/815/lb-agar">LB Agar</a>

                			<div class="sub-menu">

        			<h3>LB Agar</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/816/millers-lb-agar">Millers LB Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Millers LB Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Millers LB Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/817/lennox-lb-agar">Lennox LB Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lennox LB Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lennox LB Agar" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="LB Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="LB Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/818/lb-broth">LB Broth</a>

                			<div class="sub-menu">

        			<h3>LB Broth</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/819/millers-lb-broth">Millers LB Broth</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Millers LB Broth" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Millers LB Broth" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/820/lennox-lb-broth">Lennox LB Broth</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Lennox LB Broth" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Lennox LB Broth" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="LB Broth" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="LB Broth" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/821/soc-medium">SOC Medium</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SOC Medium" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SOC Medium" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Growth Media Premixes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Growth Media Premixes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/822/agar-bacteriological-grade">Agar, Bacteriological Grade</a>

                			<div class="sub-menu">

        			<h3>Agar, Bacteriological Grade</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/823/granulated-agar">Granulated Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Granulated Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Granulated Agar" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/824/powdered-agar">Powdered Agar</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Powdered Agar" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Powdered Agar" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agar, Bacteriological Grade" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agar, Bacteriological Grade" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/825/growth-media-nutrients">Growth Media Nutrients</a>

                			<div class="sub-menu">

        			<h3>Growth Media Nutrients</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/826/tryptone">Tryptone</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tryptone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tryptone" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/827/yeast-extract">Yeast Extract</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Yeast Extract" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Yeast Extract" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/828/peptone">Peptone</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Peptone" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Peptone" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Growth Media Nutrients" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Growth Media Nutrients" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/829/x-gal--and--iptg">X-Gal &amp; IPTG</a>

                			<div class="sub-menu">

        			<h3>X-Gal &amp; IPTG</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/830/x-gal">X-Gal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="X-Gal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="X-Gal" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/831/x-glu">X-Glu</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="X-Glu" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="X-Glu" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/832/iptg">IPTG</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="IPTG" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="IPTG" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="X-Gal &amp; IPTG" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="X-Gal &amp; IPTG" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/837/petri-dishes">Petri Dishes</a>

                			<div class="sub-menu">

        			<h3>Petri Dishes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/838/standard-dishes">Standard Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Standard Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Standard Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/839/dishes-w--gripping-ring">Dishes w/ Gripping Ring</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Dishes w/ Gripping Ring" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Dishes w/ Gripping Ring" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Petri Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/840/multiwell-plates">Multiwell Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Multiwell Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Multiwell Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/843/serological-pipets">Serological Pipets</a>

                			<div class="sub-menu">

        			<h3>Serological Pipets</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/844/individually-wrapped">Individually Wrapped</a>

                			<div class="sub-menu">

        			<h3>Individually Wrapped</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/845/genclone-brand">GenClone® Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GenClone® Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GenClone® Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/846/olympus-brand">Olympus™ Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Olympus™ Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Olympus™ Brand" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individually Wrapped" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/847/bulk">Bulk</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Serological Pipets" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/848/15--and--50ml-centrifuge-tubes">15 &amp; 50ml Centrifuge Tubes</a>

                			<div class="sub-menu">

        			<h3>15 &amp; 50ml Centrifuge Tubes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/849/15ml-centrifuge-tubes">15ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/850/50ml-centrifuge-tubes">50ml Centrifuge Tubes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15 &amp; 50ml Centrifuge Tubes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15 &amp; 50ml Centrifuge Tubes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/851/culture-tubes-w--caps">Culture Tubes w/ Caps</a>

                			<div class="sub-menu">

        			<h3>Culture Tubes w/ Caps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/852/12x75mm">12x75mm</a>

                			<div class="sub-menu">

        			<h3>12x75mm</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/853/polypropylene">Polypropylene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/854/polystyrene">Polystyrene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12x75mm" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12x75mm" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/855/17x100mm">17x100mm</a>

                			<div class="sub-menu">

        			<h3>17x100mm</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/856/polypropylene">Polypropylene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polypropylene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polypropylene" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/857/polystyrene">Polystyrene</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Polystyrene" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Polystyrene" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="17x100mm" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="17x100mm" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Culture Tubes w/ Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Culture Tubes w/ Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/858/test-tubes-no-caps">Test Tubes, No Caps</a>

                			<div class="sub-menu">

        			<h3>Test Tubes, No Caps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/859/3.0ml-12mm">3.0ml (12mm)</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="3.0ml (12mm)" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="3.0ml (12mm)" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/860/5.0ml-12mm-">5.0ml (12mm) </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="5.0ml (12mm) " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="5.0ml (12mm) " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/861/8.0ml-13mm-">8.0ml (13mm) </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8.0ml (13mm) " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8.0ml (13mm) " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/862/14ml-16mm-">14ml (16mm) </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="14ml (16mm) " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="14ml (16mm) " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/863/16ml-17mm-">16ml (17mm) </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="16ml (17mm) " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="16ml (17mm) " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/864/19ml-16mm-">19ml (16mm) </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="19ml (16mm) " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="19ml (16mm) " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tubes, No Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tubes, No Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/865/test-tube-caps">Test Tube Caps</a>

                			<div class="sub-menu">

        			<h3>Test Tube Caps</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/866/12mm-caps">12mm Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12mm Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12mm Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/867/13mm-caps">13mm Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="13mm Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="13mm Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/868/16mm-caps">16mm Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="16mm Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="16mm Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/869/17mm-caps">17mm Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="17mm Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="17mm Caps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Test Tube Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Test Tube Caps" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/870/cuvettes">Cuvettes</a>

                			<div class="sub-menu">

        			<h3>Cuvettes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/871/spectrophotometry">Spectrophotometry</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Spectrophotometry" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Spectrophotometry" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/872/electroporation">Electroporation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Electroporation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Electroporation" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cuvettes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cuvettes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/873/convenience-items">Convenience Items</a>

                			<div class="sub-menu">

        			<h3>Convenience Items</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/874/plate-spreaders">Plate Spreaders</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plate Spreaders" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plate Spreaders" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/875/weighing-dishes">Weighing Dishes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Weighing Dishes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Weighing Dishes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/876/toothpicks">Toothpicks</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Toothpicks" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Toothpicks" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/877/film-foil-tape-wrap">Film, Foil, Tape, Wrap</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Film, Foil, Tape, Wrap" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Film, Foil, Tape, Wrap" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/878/wipes-soaps-bleach">Wipes, Soaps, Bleach</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wipes, Soaps, Bleach" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wipes, Soaps, Bleach" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Convenience Items" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Convenience Items" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/879/biohazard--and--safety">Biohazard &amp; Safety</a>

                			<div class="sub-menu">

        			<h3>Biohazard &amp; Safety</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/880/biohazard-bags">Biohazard Bags</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biohazard Bags" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biohazard Bags" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biohazard &amp; Safety" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biohazard &amp; Safety" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/881/stereo-microscopes">Stereo Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stereo Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stereo Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/882/microscope-slides">Microscope Slides</a>

                			<div class="sub-menu">

        			<h3>Microscope Slides</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/883/plain-slides-beveled">Plain Slides, Beveled</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/884/plain-slides-ground">Plain Slides, Ground</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Ground" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Ground" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/885/charged-slides">Charged Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Charged Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Charged Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/886/concavity-slides">Concavity Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/887/cover-glasses">Cover Glasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/888/slide-storage">Slide Storage</a>

                			<div class="sub-menu">

        			<h3>Slide Storage</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/889/25-slide-storage-box">25-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/890/50-slide-storage-box">50-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/891/100-slide-storage-box">100-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/892/slide-mailers">Slide Mailers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Slide Mailers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Slide Mailers" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Slide Storage" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Slide Storage" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/893/benchtop-sterilization-equipment">Benchtop Sterilization Equipment</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchtop Sterilization Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchtop Sterilization Equipment" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/894/centrifuges">Centrifuges</a>

                			<div class="sub-menu">

        			<h3>Centrifuges</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/895/benchmark-microcentrifuges">Benchmark Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/896/labnet-microcentrifuges">Labnet Microcentrifuges</a>

                			<div class="sub-menu">

        			<h3>Labnet Microcentrifuges</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/897/mini-microcentrifuge">Mini Microcentrifuge</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Mini Microcentrifuge" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Mini Microcentrifuge" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/898/high-speed-microcentrifuges">High Speed Microcentrifuges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Speed Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Speed Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Microcentrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Microcentrifuges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Centrifuges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Centrifuges" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/899/co2-incubators">CO2 Incubators</a>

                			<div class="sub-menu">

        			<h3>CO2 Incubators</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/900/water-jacket-co2-incubators">Water Jacket CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Water Jacket CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Water Jacket CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/901/air-jacket-co2-incubators">Air Jacket CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Air Jacket CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Air Jacket CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/902/high-capacity-co2-incubators">High Capacity CO2 Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Capacity CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Capacity CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="CO2 Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/903/low-temperature-incubators">Low Temperature Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Low Temperature Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Low Temperature Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/904/general-purpose-incubators">General Purpose Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="General Purpose Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="General Purpose Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/905/shaking-incubators">Shaking Incubators</a>

                			<div class="sub-menu">

        			<h3>Shaking Incubators</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/906/benchmark-scientific-shaking-incubators">Benchmark Scientific Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Scientific Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Scientific Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/907/shel-lab-shaking-incubators">Shel Lab Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shel Lab Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shel Lab Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/908/labnet-shaking-incubators">Labnet Shaking Incubators</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/909/shaking-incubator-accessories">Shaking Incubator Accessories</a>

                			<div class="sub-menu">

        			<h3>Shaking Incubator Accessories</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/910/benchmark-shaking-incubator-accessories">Benchmark Shaking Incubator Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Benchmark Shaking Incubator Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Benchmark Shaking Incubator Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/911/shel-lab-shaking-incubator-accessories">Shel Lab Shaking Incubator Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shel Lab Shaking Incubator Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shel Lab Shaking Incubator Accessories" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/912/labnet-shaking-incubator-accessories">Labnet Shaking Incubator Accessories</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Labnet Shaking Incubator Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Labnet Shaking Incubator Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Incubator Accessories" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Incubator Accessories" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Shaking Incubators" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microbiology" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microbiology" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1477/microscopy">Microscopy</a>

                			<div class="sub-menu">

        			<h3>Microscopy</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/5193/microscopes">Microscopes</a>

                			<div class="sub-menu">

        			<h3>Microscopes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5751/drosophila-microscopes"><i>Drosophila</i> Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Drosophila Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Drosophila Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5194/inverted-compound-microscopes">Inverted Compound Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Inverted Compound Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Inverted Compound Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5195/upright-compound-microscopes">Upright Compound Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Upright Compound Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Upright Compound Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5196/stereo-dissecting-microscopes">Stereo/Dissecting Microscopes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Stereo/Dissecting Microscopes" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscopes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscopes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5687/light-source">Light Source</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Light Source" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Light Source" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5688/halocarbon-oil">Halocarbon Oil</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Halocarbon Oil" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1479/microscope-slides">Microscope Slides</a>

                			<div class="sub-menu">

        			<h3>Microscope Slides</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1480/plain-slides-beveled">Plain Slides, Beveled</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Beveled" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1481/plain-slides-ground">Plain Slides, Ground</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plain Slides, Ground" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plain Slides, Ground" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1482/charged-slides">Charged Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Charged Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Charged Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1483/concavity-slides">Concavity Slides</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Concavity Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1484/cover-glasses">Cover Glasses</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cover Glasses" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscope Slides" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1485/slide-storage-boxes">Slide Storage Boxes</a>

                			<div class="sub-menu">

        			<h3>Slide Storage Boxes</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1486/25-slide-storage-box">25-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1487/50-slide-storage-box">50-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1488/100-slide-storage-box">100-Slide Storage Box</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="100-Slide Storage Box" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="100-Slide Storage Box" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Slide Storage Boxes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Slide Storage Boxes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1490/nail-polish">Nail Polish</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Nail Polish" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Nail Polish" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/4876/alcohol-wipes">Alcohol Wipes</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Alcohol Wipes" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Alcohol Wipes" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5005/wash-n-dry-coverslip-rack">Wash-N-Dry Coverslip Rack</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Wash-N-Dry Coverslip Rack" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Wash-N-Dry Coverslip Rack" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Microscopy" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Microscopy" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/913/chromatography">Chromatography</a>

                			<div class="sub-menu">

        			<h3>Chromatography</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6578/antibody-purification-resins">Antibody Purification Resins</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Antibody Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Antibody Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6580/empty-plastic-columns-cartridges">Empty Plastic Columns/Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Empty Plastic Columns/Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Empty Plastic Columns/Cartridges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6579/gel-filtration-sec-media">Gel Filtration (SEC) Media</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Gel Filtration (SEC) Media" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Gel Filtration (SEC) Media" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6577/gst-tag-purification-resins">GST-Tag Purification Resins</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="GST-Tag Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="GST-Tag Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6777/high-performance-glass-columns">High Performance Glass Columns</a>

                			<div class="sub-menu">

        			<h3>High Performance Glass Columns</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6778/complete-snap-columns">Complete SNAP Columns</a>

                			<div class="sub-menu">

        			<h3>Complete SNAP Columns</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6781/10mm-i.d-columns">10mm I.D Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10mm I.D Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10mm I.D Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6782/15mm-i.d.-columns">15mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6783/25mm-i.d.-columns">25mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6784/35mm-i.d.-columns">35mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="35mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="35mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6785/50mm-i.d.-columns">50mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Complete SNAP Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Complete SNAP Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6779/snap-cartridges-only">SNAP Cartridges Only</a>

                			<div class="sub-menu">

        			<h3>SNAP Cartridges Only</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6788/10mm-i.d.-cartridges">10mm I.D. Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="10mm I.D. Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="10mm I.D. Cartridges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6786/15mm-i.d.-cartridges">15mm I.D. Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="15mm I.D. Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="15mm I.D. Cartridges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6787/25mm-i.d.-cartridges">25mm I.D. Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="25mm I.D. Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="25mm I.D. Cartridges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6789/35mm-i.d.-cartridges">35mm I.D. Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="35mm I.D. Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="35mm I.D. Cartridges" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6790/50mm-i.d.-cartridges">50mm I.D. Cartridges</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="50mm I.D. Cartridges" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="50mm I.D. Cartridges" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SNAP Cartridges Only" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SNAP Cartridges Only" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6780/snap-column-packing-adapters">SNAP Column Packing Adapters</a>

                			<div class="sub-menu">

        			<h3>SNAP Column Packing Adapters</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6791/fits-10mm-i.d.-columns">Fits 10mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fits 10mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fits 10mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6792/fits-15mm-i.d.-columns">Fits 15mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fits 15mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fits 15mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6793/fits-25mm-i.d.-columns">Fits 25mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fits 25mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fits 25mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6794/fits-35mm-i.d.-columns">Fits 35mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fits 35mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fits 35mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6795/fits-50mm-i.d.-columns">Fits 50mm I.D. Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Fits 50mm I.D. Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Fits 50mm I.D. Columns" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SNAP Column Packing Adapters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SNAP Column Packing Adapters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="High Performance Glass Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="High Performance Glass Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6576/his-tag-purification-resins">His-Tag Purification Resins</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="His-Tag Purification Resins" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="His-Tag Purification Resins" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6581/his-tag-purification-columns">His-Tag Purification Columns</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="His-Tag Purification Columns" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="His-Tag Purification Columns" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/914/chromatography--and--blotting-paper">Chromatography &amp; Blotting Paper</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Chromatography &amp; Blotting Paper" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Chromatography &amp; Blotting Paper" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Chromatography" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Chromatography" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1235/elisa">ELISA</a>

                			<div class="sub-menu">

        			<h3>ELISA</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6370/plates">Plates</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1236/sealing-films-for-plates">Sealing Films for Plates</a>

                			<div class="sub-menu">

        			<h3>Sealing Films for Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1237/sealplate-films">SealPlate Films</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SealPlate Films" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SealPlate Films" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1238/sealmate-system-">SealMate System </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="SealMate System " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="SealMate System " data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Films for Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Films for Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6942/plate-reader-and-washers">Plate Reader &amp; Washers</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plate Reader and Washers" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plate Reader and Washers" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1239/vacumm-aspiration-systems">Vacumm Aspiration Systems</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Vacumm Aspiration Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Vacumm Aspiration Systems" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="ELISA" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="ELISA" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1109/rna">RNA</a>

                			<div class="sub-menu">

        			<h3>RNA</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5143/rna-stabilization-preservation">RNA Stabilization/Preservation</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA Stabilization/Preservation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA Stabilization/Preservation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5058/rna-clean-up--and--concentration">RNA Clean-up &amp; Concentration</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA Clean-up &amp; Concentration" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA Clean-up &amp; Concentration" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/5059/total-rna-purification">Total RNA Purification</a>

                			<div class="sub-menu">

        			<h3>Total RNA Purification</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5060/samples-in-tri-reagent-trizol-etc.">Samples in TRI-Reagent®, TRIzol®, etc.</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Samples in TRI-Reagent®, TRIzol®, etc." data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Samples in TRI-Reagent®, TRIzol®, etc." data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5061/cell--and--soft-tissue-rna">Cell &amp; Soft Tissue RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cell &amp; Soft Tissue RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cell &amp; Soft Tissue RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5062/bacterial--and--fungal-rna">Bacterial &amp; Fungal RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bacterial &amp; Fungal RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bacterial &amp; Fungal RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5144/rna-shield-purification-kit">RNA Shield Purification Kit</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA Shield Purification Kit" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA Shield Purification Kit" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5166/solid--and--ffpe-tissue-rna">Solid &amp; FFPE Tissue RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Solid &amp; FFPE Tissue RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Solid &amp; FFPE Tissue RNA" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5169/plant-rna">Plant RNA</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plant RNA" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plant RNA" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Total RNA Purification" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Total RNA Purification" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1113/rnase--and--dnase-removal">RNase &amp; DNase Removal</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNase &amp; DNase Removal" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNase &amp; DNase Removal" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="RNA" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="RNA" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1271/laboratory-automation">Laboratory Automation</a>

                			<div class="sub-menu">

        			<h3>Laboratory Automation</h3>
        			<ul class="t3 list-unstyled" data-tier="3">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6808/beckman-platform-tips">Beckman Platform Tips</a>

                			<div class="sub-menu">

        			<h3>Beckman Platform Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6809/384-well-filter-tips">384-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6810/384-well-standard-tips">384-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6811/96-well-standard-tips">96-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6812/96-well-filter-tips">96-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Beckman Platform Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Beckman Platform Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1301/agilent-platform-tips">Agilent Platform Tips</a>

                			<div class="sub-menu">

        			<h3>Agilent Platform Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6804/384-well-filter-tips">384-Well Filter Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Filter Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6805/384-well-standard-tips">384-Well Standard Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well Standard Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Agilent Platform Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Agilent Platform Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/6801/molecular-devices-flipr-platform-tips">Molecular Devices FLIPR Platform Tips</a>

                			<div class="sub-menu">

        			<h3>Molecular Devices FLIPR Platform Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6803/black">Black</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Black" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Black" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6802/clear">Clear</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Clear" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Clear" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Devices FLIPR Platform Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Devices FLIPR Platform Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/6813/qiagen-biorobot-platform-tips">QIAGEN Biorobot Platform Tips</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="QIAGEN Biorobot Platform Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="QIAGEN Biorobot Platform Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1294/biomek-1000-and-2000-tips">Biomek 1000 &amp; 2000 Tips</a>

                			<div class="sub-menu">

        			<h3>Biomek 1000 &amp; 2000 Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1295/96-well-non-filtered-tips">96-Well Non-Filtered Tips</a>

                			<div class="sub-menu">

        			<h3>96-Well Non-Filtered Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1296/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1297/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Non-Filtered Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Non-Filtered Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1298/96-well-filtered-tips">96-Well Filtered Tips</a>

                			<div class="sub-menu">

        			<h3>96-Well Filtered Tips</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1299/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1300/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filtered Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filtered Tips" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Biomek 1000 and 2000 Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Biomek 1000 and 2000 Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1316/tecan-genesis-freedom-evo-and-miniprep-tips">Tecan Genesis Freedom, EVO &amp; Miniprep Tips</a>

                			<div class="sub-menu">

        			<h3>Tecan Genesis Freedom, EVO &amp; Miniprep Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1317/96-well-non-filtered-tips-liha-head">96-Well Non-Filtered Tips, LiHa Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Non-Filtered Tips, LiHa Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1318/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1319/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Non-Filtered Tips, LiHa Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Non-Filtered Tips, LiHa Head" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1320/96-well-filtered-tips-liha-head">96-Well Filtered Tips, LiHa Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Filtered Tips, LiHa Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1321/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1322/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filtered Tips, LiHa Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filtered Tips, LiHa Head" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1323/96-well-conductive-tips-liha-head">96-Well Conductive Tips, LiHa Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Conductive Tips, LiHa Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1324/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1325/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Conductive Tips, LiHa Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Conductive Tips, LiHa Head" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tecan Genesis Freedom, EVO and Miniprep Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tecan Genesis Freedom, EVO and Miniprep Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1331/tecan-freedom-evo-temo-and-aquarius-tips">Tecan Freedom EVO, TeMo &amp; Aquarius Tips</a>

                			<div class="sub-menu">

        			<h3>Tecan Freedom EVO, TeMo &amp; Aquarius Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1332/96-well-non-filtered-tips-mca96-head">96-Well Non-Filtered Tips, MCA96 Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Non-Filtered Tips, MCA96 Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1333/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1334/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Non-Filtered Tips, MCA96 Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Non-Filtered Tips, MCA96 Head" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1335/96-well-filtered-tips-mca96-head">96-Well Filtered Tips, MCA96 Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Filtered Tips, MCA96 Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1336/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1337/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filtered Tips, MCA96 Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filtered Tips, MCA96 Head" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1338/96-well-non-filtered-tips-temo96-head">96-Well Non-Filtered Tips, TEMO96 Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Non-Filtered Tips, TEMO96 Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1339/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1340/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Non-Filtered Tips, TEMO96 Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Non-Filtered Tips, TEMO96 Head" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1341/96-well-filtered-tips-temo96-head">96-Well Filtered Tips, TEMO96 Head</a>

                			<div class="sub-menu">

        			<h3>96-Well Filtered Tips, TEMO96 Head</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1342/axygen-brand">Axygen Brand</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axygen Brand" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1343/molecular-bio-products">Molecular Bio Products</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Molecular Bio Products" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Filtered Tips, TEMO96 Head" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Filtered Tips, TEMO96 Head" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Tecan Freedom EVO, TeMo and Aquarius Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Tecan Freedom EVO, TeMo and Aquarius Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1449/16-channel-pipet-tips">16-Channel Pipet Tips</a>

                			<div class="sub-menu">

        			<h3>16-Channel Pipet Tips</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1450/axypette">Axypette</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Axypette" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Axypette" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="16-Channel Pipet Tips" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="16-Channel Pipet Tips" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1452/robotic-reservoirs">Robotic Reservoirs</a>

                			<div class="sub-menu">

        			<h3>Robotic Reservoirs</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1453/single-well-384-bottom-troughs-">Single-Well, 384 bottom troughs </a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Well, 384 bottom troughs " data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Well, 384 bottom troughs " data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1454/single-well-96-bottom-troughs">Single-Well, 96 bottom troughs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Single-Well, 96 bottom troughs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Single-Well, 96 bottom troughs" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1455/8--and--12-channel-troughs">8 &amp; 12-Channel troughs</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8 &amp; 12-Channel troughs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8 &amp; 12-Channel troughs" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Robotic Reservoirs" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Robotic Reservoirs" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1456/deep-well-plates">Deep Well Plates</a>

                			<div class="sub-menu">

        			<h3>Deep Well Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1457/96-well">96-Well</a>

                			<div class="sub-menu">

        			<h3>96-Well</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1458/round-wells">Round Wells</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Round Wells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Round Wells" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1459/square-wells">Square Wells</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Square Wells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Square Wells" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1460/384-well">384-Well</a>

                			<div class="sub-menu">

        			<h3>384-Well</h3>
        			<ul class="t5 list-unstyled" data-tier="5">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1461/square-wells">Square Wells</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Square Wells" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Square Wells" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="384-Well" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="384-Well" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Deep Well Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Deep Well Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1462/assay-plates">Assay Plates</a>

                			<div class="sub-menu">

        			<h3>Assay Plates</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1463/96-well-round-bottom">96-Well Round Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well Round Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well Round Bottom" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1464/96-well-v-bottom">96-Well V Bottom</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="96-Well V Bottom" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="96-Well V Bottom" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Assay Plates" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Assay Plates" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1465/1.2ml-mini-tube-systems">1.2ml Mini Tube Systems</a>

                			<div class="sub-menu">

        			<h3>1.2ml Mini Tube Systems</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1466/individual-tubes-racked">Individual Tubes, Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Individual Tubes, Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Individual Tubes, Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1467/8-tube-strips-racked">8-Tube Strips, Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="8-Tube Strips, Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="8-Tube Strips, Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1468/12-tube-strips-racked">12-Tube Strips, Racked</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="12-Tube Strips, Racked" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="12-Tube Strips, Racked" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1469/bulk-minitubes--and--strip-caps">Bulk Minitubes &amp; Strip Caps</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Bulk Minitubes &amp; Strip Caps" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Bulk Minitubes &amp; Strip Caps" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="1.2ml Mini Tube Systems" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="1.2ml Mini Tube Systems" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1470/sealing-films-for-automation">Sealing Films for Automation</a>

                			<div class="sub-menu">

        			<h3>Sealing Films for Automation</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1471/cold-storage">Cold Storage</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Cold Storage" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Cold Storage" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1472/robotics-pierceability">Robotics Pierceability</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Robotics Pierceability" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Robotics Pierceability" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Films for Automation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Films for Automation" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/1473/sealing-mats-for-automation">Sealing Mats for Automation</a>

                			<div class="sub-menu">

        			<h3>Sealing Mats for Automation</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1474/round-well-compatible">Round Well Compatible</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Round Well Compatible" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Round Well Compatible" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1475/square-well-compatible">Square Well Compatible</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Square Well Compatible" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Square Well Compatible" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Sealing Mats for Automation" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Sealing Mats for Automation" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/1476/plate-sealing-equipment">Plate Sealing Equipment</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Plate Sealing Equipment" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Plate Sealing Equipment" data-url="" data-img=""></div>
            </div>

        </li>

		<li class="menu-item-has-children"><a href="https://geneseesci.com/shop-online/bbapplication/5154/carboys">Carboys</a>

                			<div class="sub-menu">

        			<h3>Carboys</h3>
        			<ul class="t4 list-unstyled" data-tier="4">

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5160/carboys">Carboys</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Carboys" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Carboys" data-url="" data-img=""></div>
            </div>

        </li>

		<li><a href="https://geneseesci.com/shop-online/bbapplication/5161/adapters">Adapters</a>


            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Adapters" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Adapters" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Carboys" data-url="" data-img=""></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Carboys" data-url="" data-img=""></div>
            </div>

        </li>
                			</ul>
    			</div>

            <div class="replacement_ads d-none">
                <div class="top_banner" data-banner-location="top_banner" data-category="Laboratory Automation" data-url="https://geneseesci.com/research-pcr/" data-img="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-1.webp"></div>
                <div class="bottom_banner" data-banner-location="bottom_banner" data-category="Laboratory Automation" data-url="https://geneseesci.com//genesee-brochure" data-img="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></div>
            </div>

        </li>
        					</ul>
				</div>
				<div class="col-auto">
					<div class="ads">
						<div id="ad_block_3"><a href="https://geneseesci.com/research-pcr/"><img class="img-fluid ad-block-3" src="https://geneseesci.com/wp-content/uploads/2022/06/Browse-By-Banners2-270x300-1.webp"></a></div>
						<div id="ad_block_4"><a href="https://geneseesci.com/genesee-brochure"><img class="img-fluid ad-block-4" src="https://geneseesci.com/wp-content/uploads/2022/04/Q2Q3-2022-Brochure-scaled.webp"></a></div>
					</div>
				</div>
			</div>
		</div><!-- .root-container -->
	</li>

	<li id="a-to-z" class="menu-item-has-children hide-1200-down"><a href="#">A to Z Product List</a>
		<div class="root-container sub-menu">
			<ul class="list-unstyled list-inline">
                                    <li class="menu-item-has-children"><a href="#" class="active">A</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6279">
                                                Acids &amp; Bases                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/171">
                                                Adhesives                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6574">
                                                Agarose                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/110">
                                                Agars                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/173">
                                                Aluminum Foil                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6279">
                                                Analytical Balances                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4947">
                                                Anesthesia Apparatus                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6730">
                                                Anion Standards                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6570">
                                                Antibiotics                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5764">
                                                Antibiotics &amp;<br>
Selection Agents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6383">
                                                Antibodies                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6380">
                                                Antibody Purification<br>
Resins                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6731">
                                                APHA Standard Methods<br>
Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6749">
                                                Aqueous Solutions                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6732">
                                                Atomic Absorption (AA)<br>
Standards                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/141">
                                                Autoclave Containers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/142">
                                                Autoclave Tape                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4657">
                                                Automation Pipet Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/143">
                                                Autoradiography Film                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">B</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6278">
                                                Balances                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/147">
                                                Batteries                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7021">
                                                Beckman Coulter<br>
Centrifuges                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7013">
                                                Benchmark Centrifuges                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7625">
                                                Biodegradable Gloves,<br>
Powder-Free                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6585">
                                                Bioequivalent Bovine<br>
Serum                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/148">
                                                Biohazard Autoclave Bags                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5486">
                                                Bioreagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6861">
                                                Blocking Transfer Buffers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6733">
                                                Blood Bank Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6701">
                                                Blotting Boxes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6697">
                                                Blotting Membranes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6702">
                                                Blotting Paper                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6698">
                                                Blotting X-Ray Film                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6734">
                                                BOD / COD Standards                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7220">
                                                BrandTech HandyStep touch<br>
Repeaters                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5758">
                                                Buffers &amp; Balanced<br>
Salts                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5480">
                                                Buffers, Powdered                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5479">
                                                Buffers, Solutions                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6944">
                                                Bundles for Tissue<br>
Culture                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">C</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7448">
                                                Caps for Test Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5151">
                                                Carboys                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6991">
                                                cDNA Synthesis Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6571">
                                                Cell Dissociation<br>
Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6567">
                                                Cell Freezing Container                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7633">
                                                Cell Imaging Systems                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5008">
                                                Cell Scrapers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5714">
                                                Cell Strainers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4378">
                                                Centrifuge Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6828">
                                                Centrifuges                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://seating.geneseesci.com/">
                                                Chairs                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6735">
                                                Chemical Indicators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6750">
                                                Chemical Standards                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5760">
                                                Classical Media                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/175">
                                                Cleaning Agents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6736">
                                                Clinical Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7282">
                                                Closures for Vials &amp;<br>
Bottles                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6141">
                                                CO2 Incubators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7236">
                                                CO2 Regulators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/371">
                                                Cold Storage Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6737">
                                                Color Standards                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/439">
                                                Competent Cells                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6738">
                                                Conductivity Standards                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6319">
                                                Consumables, Eppendorf                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5004">
                                                Coverslip Rack                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4411">
                                                Cryogenic Vials                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4596">
                                                Cryovial Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6272">
                                                Cryovial Racks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4746">
                                                Culture Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/149">
                                                Cuvettes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6739">
                                                Cytology Reagents                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">D</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/222">
                                                Deep Well Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5485">
                                                Dehydrated Culture Media                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5778">
                                                DMEM                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4473">
                                                DNA Ladders                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5172">
                                                DNA/RNA Co-Purification<br>
Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/410">
                                                dNTPs                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5773">
                                                DPBS                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/121">
                                                <i>Drosophila</i> Media                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4946">
                                                <i>Drosophila</i> Media<br>
Dispensing Equipment                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7235">
                                                <i>Drosophila</i> Stock<br>
Bottles                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6740">
                                                Dry Chemicals                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/179">
                                                Dry Milk                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6389">
                                                Dura ECL Detection<br>
Reagent                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">E</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6382">
                                                ECL Detection Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4488">
                                                Electroblotting Systems                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7601">
                                                Electronic Pipettors                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6114">
                                                Electrophoresis                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4449">
                                                Electrophoresis Buffers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/422">
                                                Electrophoresis Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5447">
                                                Electroporators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/375">
                                                ELISA, Incubation &amp;<br>
Storage                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5064">
                                                Epigenetics Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5382">
                                                Eppendorf Centrifuges                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6304">
                                                Eppendorf Pipet Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5400">
                                                Eppendorf Research Plus<br>
Pipettors                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6594">
                                                Ergonomic X Pipet Tips<br>
for LTS                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6741">
                                                European Pharmacopoeia<br>
(EP) Reagents                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">F</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6390">
                                                Femto                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6585">
                                                Fetal Bovine Serum                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7037">
                                                Film Strips for PCR                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/163">
                                                Film, Foil, Wrap                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/380">
                                                Films for Automation                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/372">
                                                Films for Tissue Culture                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4731">
                                                Filtration Bottle Tops                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4727">
                                                Filtration Systems                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6742">
                                                Fixatives                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7064">
                                                Flow Cytometry Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/378">
                                                Fluorescence &amp;<br>
Luminescence Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://freezerrackconfigurator.com/genesee">
                                                Freezer Racks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6127">
                                                Freezers                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">G</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4477">
                                                Gel Boxes &amp;<br>
Accessories                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5038">
                                                Gel DNA Extraction Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4492">
                                                Gel Documentation Systems                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4652">
                                                Gel Loading Pipet Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4597">
                                                General Purpose Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5041">
                                                Genomic DNA Purification<br>
Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4699">
                                                Gilson Pipet Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5800">
                                                Glove Box Holders                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/259">
                                                Gloves                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6379">
                                                GST-Tag Purification<br>
Resins                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">H</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7737">
                                                Hand Sanitizer                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7220">
                                                HandyStep touch Repeaters                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5152">
                                                Heavy Duty Vacuum Bottles                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6746">
                                                Hematology Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5775">
                                                HEPES                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6743">
                                                High Purity Water                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7194">
                                                High-Fidelity Polymerases                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6378">
                                                His-Tag Purification<br>
Resins                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6744">
                                                Histology Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6129">
                                                Homogenizers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6128">
                                                Hot Plates &amp; Stirrers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/402">
                                                Hot Start 2X <i>Taq</i><br>
Master Mix                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6745">
                                                HPLC Reagents                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">I</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5752">
                                                Ice Pans &amp; Ice Buckets                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5806">
                                                Immunoassay Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6132">
                                                Incubators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4955">
                                                Incubators,<br>
<i>Drosophila</i><br>
Specific                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5898">
                                                Inoculating Loops                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5771">
                                                Insect Cell Media                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7045">
                                                Inserts for TC Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6921">
                                                INTERFERin siRNA &amp;<br>
miRNA                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6747">
                                                Ion Selective Electrode<br>
ISE Standards &amp;<br>
Reagents                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">J</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6917">
                                                jetMESSENGER mRNA<br>
Transfection Reagent                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7070">
                                                jetOPTIMUS DNA<br>
Transfection Reagent                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6915">
                                                jetPEI HTS DNA<br>
Transfection Reagent                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6916">
                                                jetPRIME DNA &amp; siRNA<br>
Transfection Reagent                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">K</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/1782">
                                                Kimwipe &amp; Glove Box<br>
Dispensers                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">L</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4982">
                                                Lab Markers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/152">
                                                Lab Wipes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5719">
                                                Labeling Tape                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/260">
                                                Latex Gloves, Powder-Free                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5384">
                                                Liquid Handling                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7633">
                                                Live Cell Imaging Systems                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6594">
                                                LTS Ergonomic X Pipet<br>
Tips for Rainin                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4979">
                                                Luminescence/<br>
Fluorescence Plates                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">M</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4985">
                                                Mammalian Cell Media                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6256">
                                                Measuring Plastics                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4928">
                                                Media                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5086">
                                                Media Dispensing Pumps                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5767">
                                                Media Supplements                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6748">
                                                Microbiology Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6547">
                                                Microbiomics &amp;<br>
Metagenomics                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4395">
                                                Microcentrifuge Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4606">
                                                Microplate Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4613">
                                                Microscope Slide Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/153">
                                                Microscope Slide Storage                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/158">
                                                Microscope Slides                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6148">
                                                Microscopes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4425">
                                                Mini Tube Systems                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5385">
                                                Mixers &amp; Temperature<br>
Control                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5382">
                                                Multipurpose Centrifuges                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">N</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/183">
                                                Nail Polish                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5466">
                                                New Brunswick Freezers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5470">
                                                New Brunswick Incubators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5473">
                                                New Brunswick Shakers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/259">
                                                NEXT-GEN Gloves                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/261">
                                                Nitrile Gloves,<br>
Powder-Free                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5908">
                                                Non-treated Assay Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5145">
                                                Nucleic Acid Collection /<br>
Stabilization                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6560">
                                                Nucleic Acid Stains                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">O</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6160">
                                                Ovens                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6751">
                                                Oxidation-Reduction<br>
Potential (ORP) Standards                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">P</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6385">
                                                PAGE Reagents &amp; Stains                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5774">
                                                PBS                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/185">
                                                PCR Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5037">
                                                PCR Purification / DNA<br>
Clean-up Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4571">
                                                PCR Tube Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7450">
                                                PCR Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/1777">
                                                Personal Tube Chillers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/230">
                                                Petri Dishes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6752">
                                                pH Control Buffers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6276">
                                                pH Indicator Papers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6287">
                                                pH Meters &amp;<br>
Accessories                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6753">
                                                pH Reference Buffers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6754">
                                                pH Test Strips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6388">
                                                Pico ECL Detection<br>
Reagent                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/384">
                                                Pierceable Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6503">
                                                PIPETMAN Classic Single<br>
Channel                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6527">
                                                PIPETMAN G Single Channel                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6513">
                                                PIPETMAN L Single Channel                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5690">
                                                Pipette Aids                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/1510">
                                                Pipette Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6375">
                                                Pipettors &amp; Accessories                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5040">
                                                Plasmid DNA Purification<br>
Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/173">
                                                Plastic Wrap                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6582">
                                                Plate Spreaders                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4491">
                                                Power Supplies                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5484">
                                                Pre-weighed Media Vials                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6282">
                                                Precision Balances                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6589">
                                                Premium Pipet Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4624">
                                                Printers &amp; Accessories                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5759">
                                                Process Water                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7062">
                                                Protease Inhibitor<br>
Cocktails                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7597">
                                                Protein Concentrators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/379">
                                                Protein Crystallization<br>
Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6559">
                                                Protein Filtration                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6713">
                                                Protein Ladders                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6220">
                                                Pumps                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6387">
                                                Purification Reagents                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">Q</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6939">
                                                qPCR Machines                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/418">
                                                Quantitative DNA Ladders                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">R</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4612">
                                                Rack &amp; Box Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/181">
                                                Razor Blades                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/233">
                                                Reagent Reservoirs                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/370">
                                                Real-Time PCR Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6980">
                                                Real-Time PCR Master<br>
Mixes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5703">
                                                Repeater                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4973">
                                                Repeater Pipette Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5400">
                                                Research Plus Pipettors                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5051">
                                                RNA Clean-up Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/239">
                                                Robotic Reservoirs                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4419">
                                                Round-Bottom Culture<br>
Tubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5780">
                                                RPMI 1640                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/182">
                                                Rubber Bands                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">S</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7084">
                                                Sample Collection                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7737">
                                                Sanitizer                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4399">
                                                Screw Cap Microtubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5909">
                                                Sealing Film for<br>
Microtubes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://seating.geneseesci.com/">
                                                Seating                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4721">
                                                Serological Pipets                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6585">
                                                Serum                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7656">
                                                Shaker Flasks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6135">
                                                Shaking Incubators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/167">
                                                Soap &amp; Hand Lotion                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6755">
                                                Solvents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4618">
                                                Specialty Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6230">
                                                Spectrophotometers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/1754">
                                                Stainless Steel Freezer<br>
Racks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/1764">
                                                Standard Microtube Racks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/367">
                                                Standard PCR Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6928">
                                                Steel Dewar Flasks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5190">
                                                Stereo/Dissecting<br>
Microscopes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6233">
                                                Sterilization Equipment                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5714">
                                                Strainers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/search?s=PCRSC">
                                                Strip Caps for PCR Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/168">
                                                Surface Decontaminants                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4735">
                                                Syringe Filters                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">T</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4574">
                                                0.5/0.6ml Tube Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4585">
                                                1.5/2ml Tube Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4605">
                                                15/50ml Tube Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/392">
                                                <i>Taq</i> DNA Polymerase                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/405">
                                                <i>Taq</i> Master Mixes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4429">
                                                Test Tubes, No Caps                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6061">
                                                Thermal Cyclers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4614">
                                                Thermal Transfer Labels                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6944">
                                                Tissue Culture Bundles                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4718">
                                                Tissue Culture Dishes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/372">
                                                Tissue Culture Films                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4706">
                                                Tissue Culture Flasks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/209">
                                                Tissue Culture Plates                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6756">
                                                Titrants                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/180">
                                                Toothpicks                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5053">
                                                Total RNA Purification<br>
Kits                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6914">
                                                Transfection Reagents                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4698">
                                                Transfer Pipets                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4493">
                                                Transilluminators                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4424">
                                                Transport Tubes,<br>
Self-Standing                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6303">
                                                Transporter &amp;<br>
Carriers                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/113">
                                                Tryptone, Peptone, Yeast<br>
Extract                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/1770">
                                                Tube Storage Boxes w/<br>
Lids                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7064">
                                                Tubes for Flow Cytometry                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5714">
                                                Tubes, 15 &amp; 15ml<br>
Centrifuge                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4395">
                                                Tubes, Microcentrifuge                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">U</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6585">
                                                U.S. Origin FBS                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5168">
                                                Ultra-Pure Water                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5180">
                                                UPrep Universal Spin<br>
Columns                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6585">
                                                USDA Approved Origin FBS                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6757">
                                                USP Reagents                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">V</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4726">
                                                Vacuum Filtration                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7723">
                                                Viral DNA/RNA<br>
Purification                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">W</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5168">
                                                Water                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/7153">
                                                Water &amp; Dry Baths                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/169">
                                                Weighing Dishes                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/6299">
                                                Western Blotting Film                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4656">
                                                Wide Orifice Pipet Tips                                            </a>

                                    </li>
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/4623">
                                                Writers &amp; Pens                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="">X</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="">Y</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                            </ul>
                        </div>
                    </li>
                                    <li class="menu-item-has-children"><a href="#" class="active">Z</a>
    					<div class="sub-menu">
    						<ul class="list-unstyled">
                                                                    <li>
                                                                                    <a href="https://geneseesci.com/shop-online/azproduct/5042">
                                                Zymo Research Kits                                            </a>

                                    </li>
                                                            </ul>
                        </div>
                    </li>
                			</ul>
		</div>
	</li>
</ul>

<script>
jQuery(document).ready(function($) {
	$('.sub-menu').parent().addClass('menu-item-has-children');

	$('.sub-menu a').click(function(e) {
		if($(this).parent().find('.sub-menu').length) {
			e.preventDefault();

			$(this).closest('ul').find('li').removeClass('expanded');

			$(this).parent().addClass('expanded');

			$(this)
				.closest('.root-container')
				.removeClass('col2 col3 col4')
				.addClass('col'+$(this).closest('ul').data('tier'));
			var mul = $(this).closest('ul').data('tier');
			var width = $(this).width();
			// if(mul != 4){
			// 	$(this)
			// 		.closest('.root-container')
			// 		.css({'margin-left':'-'+ width * mul +'px'});
			// }
		}
	});

    $('#by-product ul > li > a').click(function(){
        var top = $(this).siblings('.replacement_ads').find('.top_banner');
        var bottom = $(this).siblings('.replacement_ads').find('.bottom_banner');

        // if ( top.data('url') != '' && top.data('img') != '' ) {
        if ( top.data('img') != '' ) {
            $('#ad_block_1 a').attr('href', top.data('url')).attr('data-banner-location', top.data('banner-location')).attr('data-category', top.data('category'));
            $('#ad_block_1 a img').attr('src', top.data('img'));
        }

        // if ( bottom.data('url') != '' && bottom.data('img') != '' ) {
        if ( bottom.data('img') != '' ) {
            $('#ad_block_2 a').attr('href', bottom.data('url')).attr('data-banner-location', bottom.data('banner-location')).attr('data-category', bottom.data('category'));
            $('#ad_block_2 a img').attr('src', bottom.data('img'));
        }
    });

    $('#by-application ul > li > a').click(function(){
        var top = $(this).siblings('.replacement_ads').find('.top_banner');
        var bottom = $(this).siblings('.replacement_ads').find('.bottom_banner');

        // if ( top.data('url') != '' && top.data('img') != '' ) {
        if ( top.data('img') != '' ) {
            $('#ad_block_3 a').attr('href', top.data('url')).attr('data-banner-location', top.data('banner-location')).attr('data-category', top.data('category'));
            $('#ad_block_3 a img').attr('src', top.data('img'));
        }

        // if ( bottom.data('url') != '' && bottom.data('img') != '' ) {
        if ( bottom.data('img') != '' ) {
            $('#ad_block_4 a').attr('href', bottom.data('url')).attr('data-banner-location', bottom.data('banner-location')).attr('data-category', bottom.data('category'));
            $('#ad_block_4 a img').attr('src', bottom.data('img'));
        }
    });
});
</script>
						<div class="form-inline my-2 my-lg-0">
							<ul class="main-menu mr-auto">
								<!-- <li><a id="open-signup" data-toggle="modal" data-target="#exampleModalCenter" style="cursor: pointer;"  href="#">Newsletter</a></li> -->
								<!-- <li><a  href="#">Newsletter</a></li> -->
								<li><a href="https://geneseesci.com/support/">Support</a></li>
								<li><a href="https://geneseesci.com/company/">Company</a></li>
								<li><a href="https://geneseesci.com/contact/">Contact</a></li>
								<li class="p-0 ml-0" style="padding:0px;margin:0px;">
									<div class="dropdown open">
										<div>
										   <div class="btn btn-link btn-block" id="google_translate_element"><div class="skiptranslate goog-te-gadget" dir="ltr" style=""><div id=":0.targetLanguage" class="goog-te-gadget-simple" style="white-space: nowrap;"><img src="https://www.google.com/images/cleardot.gif" class="goog-te-gadget-icon" alt="" style="background-image: url(&quot;https://translate.googleapis.com/translate_static/img/te_ctrl3.gif&quot;); background-position: -65px 0px;"><span style="vertical-align: middle;"><a aria-haspopup="true" class="goog-te-menu-value" href="javascript:void(0)"><span>Select Language</span><img src="https://www.google.com/images/cleardot.gif" alt="" width="1" height="1"><span style="border-left: 1px solid rgb(187, 187, 187);">​</span><img src="https://www.google.com/images/cleardot.gif" alt="" width="1" height="1"><span aria-hidden="true" style="color: rgb(118, 118, 118);">▼</span></a></span></div></div></div>
										</div>
									</div>

									<script type="text/javascript" async="">
										function googleTranslateElementInit() {
											new google.translate.TranslateElement(
												{
													pageLanguage: 'en',
													includedLanguages: 'en,es,de,ja,fr,it,zh-CN',
													layout: google.translate.TranslateElement.InlineLayout.SIMPLE,
													autoDisplay: false
												},
												'google_translate_element'
											);
										}

										$('document').ready(function () {

											function changeLeftIcon(url){
												$("#google_translate_element img").eq(0).attr("src", url);
											}

												// RESTYLE THE DROPDOWN MENU
											$('#google_translate_element').on("click", function () {

												$("iframe").contents().find(".goog-te-menu2-item div").each(function(){
													var code = $(this).text().substring(1, 3);
													if ( $(this).children('img').length < 1 ) {
														$(this).prepend('<img style="width: 20px;" src="/wp-content/themes/heisenbug/images/flag-' + code.toLowerCase() + '.png">&nbsp; ');
													}
												});

												$("iframe").contents().find('.goog-te-menu2-item-selected').css ('display', 'none');

												$("iframe").contents().find(".goog-te-menu2-item div").on('click', function(){
													var code = $(this).text().substring(1, 3);
													changeLeftIcon('/wp-content/themes/heisenbug/images/flag-'+code.toLowerCase()+'.png');
												})

												$("iframe").contents().find('.goog-te-menu-frame').css({
													'width':'163px;'
												});
												$("iframe").contents().find('.goog-te-menu2').css({
													'width':'100%',
													'border':'none'
												});
												$("iframe").contents().find('#:1.menuBody').css({
													'width':'163px;'
												});

												$("#google_translate_element span").eq(3).css({"color": '#ffffff'});
												$("#google_translate_element a span").css({"color": '#ffffff', 'text-transform': 'uppercase'});

											});
										});

									</script>
									<script type="text/javascript" src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>

									<style>
										#google_translate_element div{
											background-color: rgb(74,74,74);
											border-color: rgb(74,74,74);
										}
										#google_translate_element span{
											color: #ffffff
										}
										#google_translate_element a{
											color: #ffffff;
											text-transform: uppercase;
										}
										#google_translate_element img{
											background-image: none !important;
										}
										.goog-te-menu-frame{
											min-width:163px !important;
										}
										.goog-te-menu2{
											min-width:163px !important;
										}
										.goog-te-combo{
											width:163px;
										}
									</style>
								</li>

															</ul>

							<ul class="main-menu social-icon list-inline">
								<li>
								   <a href="https://www.facebook.com/geneseescientific/" target="_blank">
								   <img src="https://geneseesci.com/wp-content/themes/heisenbug/images/facebook-icon.png" alt="">
								   </a>
								</li>
								<li>
								   <a href="https://twitter.com/geneseesci" target="_blank">
								   <img src="https://geneseesci.com/wp-content/themes/heisenbug/images/twitter-icon.png" alt="">
								   </a>
								</li>
								<li>
								   <a href="https://www.instagram.com/genesee_sci" target="_blank">
								   <img src="https://geneseesci.com/wp-content/themes/heisenbug/images/instagram-icon.png" alt="">
								   </a>
								</li>
								<li>
								   <a href="https://www.linkedin.com/company/genesee-scientific/" target="_blank">
								   <img src="https://geneseesci.com/wp-content/themes/heisenbug/images/linkdin-icon.png" alt="">
								   </a>
								</li>
							</ul>
						</div>
					</nav>

				</div>

				<div class="mm-trigger float-right">
					<a href="#" id="trigger" class="menu-trigger"><img src="https://geneseesci.com/wp-content/themes/heisenbug/images/mobile-menu-toggle.jpg"></a>
				</div>


				<!-- Modal -->
				<div class="modal fade" id="exampleModalCenter" tabindex="-1" data-backdrop="false" role="dialog" aria-labelledby="exampleModalCenterTitle" aria-hidden="true">
				  <div class="modal-dialog modal-dialog-centered" role="document">
					<div class="modal-content">
					  <div class="modal-body">
						 <div id="klaviyo-signup" class="klaviyo-form-RiCTs6 klaviyo-form form-version-cid-1"><div class="needsclick  kl-private-reset-css-Xuajs1" style="transform: translate(0px, 0px);"><form class="needsclick klaviyo-form klaviyo-form-version-cid_1 kl-private-reset-css-Xuajs1" data-testid="klaviyo-form-RiCTs6" novalidate="" tabindex="-1" style="display: flex; flex-direction: row; box-sizing: border-box; width: 100%; overflow: visible; border-radius: 2px; border-style: none; border-width: 0px; border-color: rgb(0, 0, 0); background-color: rgb(255, 255, 255); background-repeat: no-repeat; background-position-y: 50%; padding: 20px;"><div class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; flex-direction: column; width: 100%; margin: 0px; padding: 0px; justify-content: center;"><div data-testid="form-row" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; flex-direction: row; align-items: stretch; position: relative;"><div component="[object Object]" data-testid="form-component" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; justify-content: flex-start; padding: 10px 6px; position: relative; flex: 1 0 0px;"><div class="kl-private-reset-css-Xuajs1 go3710136913" style="width: 100%;"><div class="ql-snow ql-container ql-disabled"><div class="ql-editor" data-gramm="false" contenteditable="false"><p style="text-align: center;"><strong style="font-size: 24px;">Stay in touch with Genesee!</strong></p><p style="text-align: center;"><br></p><p style="text-align: center;"><span style="font-size: 16px;">Get updated with news, discounts and promotions.</span></p></div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div></div></div></div></div><div data-testid="form-row" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; flex-direction: row; align-items: stretch; position: relative;"><div component="[object Object]" data-testid="form-component" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; justify-content: flex-start; padding: 10px 6px; position: relative; flex: 1 0 0px;"><div class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; flex-grow: 1; flex-direction: column; align-self: flex-end;"><input class="needsclick go1917793270 kl-private-reset-css-Xuajs1" type="email" name="email" tabindex="0" placeholder="Enter your email address" aria-label="Enter your email address" aria-invalid="false" options="[object Object]" style="box-sizing: border-box; border-radius: 2px; padding: 0px 0px 0px 16px; height: 38px; text-align: left; color: rgb(0, 0, 0); font-family: Arial, &quot;Helvetica Neue&quot;, Helvetica, sans-serif; font-size: 16px; font-weight: 400; letter-spacing: 0px; background-color: rgb(255, 255, 255); border: 1px solid rgb(180, 187, 195);"><div class="needsclick  kl-private-reset-css-Xuajs1" style="width: 100%; position: relative;"></div></div></div></div><div data-testid="form-row" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; flex-direction: row; align-items: stretch; position: relative;"><div component="[object Object]" data-testid="form-component" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; justify-content: flex-start; padding: 10px 6px; position: relative; flex: 1 0 0px;"><div class="kl-private-reset-css-Xuajs1 go3710136913" style="width: 100%;"><div class="ql-snow ql-container ql-disabled"><div class="ql-editor" data-gramm="false" contenteditable="false"><p><span style="font-size: 12px;">We use email and targeted online advertising to send you product and services updates, promotional offers and other marketing communications based on the information we collect about you, such as your email address, general location, and purchase and website browsing history.</span></p><p><br></p><p><span style="color: rgb(0, 0, 0); background-color: transparent; font-size: 12px;">We process your personal data as stated in our </span><a href="https://geneseesci.com/privacy-policy/" target="_blank" style="color: rgb(0, 0, 0); background-color: transparent; font-size: 12px;">Privacy Policy</a><span style="color: rgb(0, 0, 0); background-color: transparent; font-size: 12px;">. &nbsp;You may withdraw your consent or manage your preferences at any time by clicking the unsubscribe link at the bottom of any of our marketing emails, or by </span><a href="https://geneseesci.com/contact/" target="_blank" style="color: rgb(0, 0, 0); background-color: transparent; font-size: 12px;">contacting us</a><span style="color: rgb(0, 0, 0); background-color: transparent; font-size: 12px;">.</span></p></div><div class="ql-clipboard" contenteditable="true" tabindex="-1"></div></div></div></div></div><div data-testid="form-row" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; flex-direction: row; align-items: stretch; position: relative;"><div component="[object Object]" data-testid="form-component" class="needsclick  kl-private-reset-css-Xuajs1" style="display: flex; justify-content: flex-start; padding: 10px 6px; position: relative; flex: 1 0 0px;"><button class="needsclick go3894874857 kl-private-reset-css-Xuajs1" type="button" tabindex="0" style="background: rgb(82, 136, 24); border-radius: 2px; border-style: none; border-color: rgb(0, 0, 0); border-width: 0px; color: rgb(255, 255, 255); font-family: Arial, &quot;Helvetica Neue&quot;, Helvetica, sans-serif; font-size: 16px; font-weight: 700; letter-spacing: 0px; line-height: 1; white-space: normal; padding-top: 11px; padding-bottom: 11px; text-align: center; word-break: break-word; align-self: flex-end; cursor: pointer; height: auto; width: 100%;">Subscribe</button></div></div></div><input type="submit" tabindex="-1" value="Submit" style="display: none;"></form></div></div>
					  </div>
					  <div class="modal-footer">
						<button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
					  </div>
					</div>
				  </div>
				</div>

			</div>

		</div>
        <iframe frameborder="0" class="goog-te-menu-frame skiptranslate" title="Language Translate Widget" style="visibility: visible; box-sizing: content-box; width: 163px; height: 151px; left: 967.719px; top: 135.5px; display: none;"></iframe>
  </div>
`;
